<template>
  <div :class="chatRootClass">
    <!-- Debug log message display -->
    <div v-if="showDebug" class="debug-log">
      <div class="debug-header">
        <button @click="toggleDebug">Close</button>
        <button @click="copyLogToClipboard" class="copy-button">Copy</button>
      </div>
      <div class="log-message" v-html="logMessage"></div>
    </div>

    <div class="chat-panel">
      <!-- MOTD Modal Component -->
      <MotdModal :route="$route.path" />

      <div
        class="title-bar"
        :class="{ 'title-bar--named': selectedChat && !isMobile }"
      >
        <div class="title-icon">
          <i
            class="fas fa-comment-dots"
            style="color: rgb(66, 191, 66)"
            @click="showCloseAllChatsPopup"
          ></i>
        </div>
        <div class="title-text">
          <small @click="toggleDebug">Chat with:</small>
          <div class="chat-name-container">
            <div class="chat-name-block">
              <div class="chat-name-line">
                <span class="chat-name">
                  {{
                    selectedChat &&
                    (selectedChat.groupName ||
                      selectedChat.displayName ||
                      selectedChat.fullName)
                  }}
                </span>
                <span
                  v-if="selectedTenantNotifyOn"
                  class="person-flag person-flag-on"
                  title="Chat notifications"
                >N</span>
              </div>
              <span v-if="selectedChatProperty" class="chat-name-property">{{
                selectedChatProperty
              }}</span>
            </div>
            <span class="group-icon-container"> </span>
          </div>
        </div>
        <div class="title-buttons">
          <button
            v-if="selectedChat"
            type="button"
            class="share-button"
            :title="shareNote || 'Share this chat'"
            @click="shareSelectedChat"
          >
            <i class="fas fa-share-nodes"></i>
          </button>
          <span v-if="shareNote" class="share-note">{{ shareNote }}</span>
          <button class="back-button" @click="$router.go(-1)">
            <i class="fas fa-arrow-left"></i>
          </button>
          <button v-if="!isMobile" @click="sendClose" class="home" title="Close">
            <i class="fas fa-close"></i>
          </button>
          <button
            v-if="needsNotifEnable"
            @click="onEnableNotifications"
            class="home"
            title="Enable chat notifications"
          >
            <i class="fas fa-bell"></i>
          </button>
          <button class="home" title="Home" @click="goHome">
            <i class="fas fa-home"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Rest of the template remains unchanged -->
    <div id="insideChatPanel" class="panel">
      <div class="active-chats-wrapper-outer">
        <div class="active-chats-wrapper">
          <div class="fixed-chats">
            <div class="chat-square" @click="showDndPopup = true">
              <div
                class="chat-circle chat-circle-tool"
                :class="{ 'chat-circle-tool-dnd': insideChatDndOn }"
                :title="
                  insideChatDndOn
                    ? 'Do not disturb is on'
                    : 'Inside Chat notifications'
                "
              >
                <i
                  class="fas"
                  :class="insideChatDndOn ? 'fa-bell-slash' : 'fa-bell'"
                ></i>
              </div>
            </div>
            <div class="chat-square" @click="showAddChatPopup">
              <div class="chat-circle chat-circle-tool">
                <i class="fas fa-plus"></i>
              </div>
            </div>
            <div class="chat-square" @click="hideSelectedChat">
              <div
                :title="'archive this\nchat'"
                class="chat-circle chat-circle-tool"
              >
                <i class="fas fa-archive"></i>
              </div>
            </div>
            <div class="chat-square" @click="onBroomClick">
              <div
                :title="broomTitle"
                class="chat-circle chat-circle-tool"
                :class="{ 'chat-circle-tool-alert': broomPhase !== 0 }"
              >
                <i class="fas fa-broom"></i>
              </div>
            </div>
          </div>
          <div class="chat-heads-column">
            <button
              type="button"
              class="zoom-meet-btn"
              title="Open Zoom. Press and hold to edit the link."
              @click="onZoomClick"
              @touchstart.passive="startZoomPress"
              @touchend="cancelZoomPress"
              @touchmove="cancelZoomPress"
              @mousedown="startZoomPress"
              @mouseup="cancelZoomPress"
              @mouseleave="cancelZoomPress"
              @contextmenu.prevent
            >
              Zoom
            </button>
            <div class="scrollable-chats">
            <div class="recent-tenant-block">
              <div class="chat-head-label">Recent</div>
              <button
                type="button"
                class="recent-tenant-btn"
                title="25 most recent tenant messages"
                @click="openRecentTenants"
              >
                25
              </button>
            </div>
            <template v-for="section in chatHeadSections" :key="section.key">
              <div class="chat-head-label">{{ section.label }}</div>
            <div
              v-for="chat in section.chats"
              :key="chat.id"
              :title="chatHeadTitle(chat)"
              class="chat-square"
              :class="
                selectedChat && selectedChat.id === chat.id
                  ? 'selected-chat'
                  : ''
              "
              @click="onChatHeadClick(chat)"
              @touchstart.passive="startGroupHeadPress(chat)"
              @touchend="cancelGroupHeadPress"
              @touchmove="cancelGroupHeadPress"
              @mousedown="startGroupHeadPress(chat)"
              @mouseup="cancelGroupHeadPress"
              @mouseleave="cancelGroupHeadPress"
              @contextmenu="chat.groupId && $event.preventDefault()"
            >
              <div
                class="chat-circle"
                :class="{
                  'chat-circle-group': chat.groupId,
                  'chat-circle-sys': isSystemChatHead(chat),
                }"
                :style="{
                  backgroundColor:
                    chatColors[
                      parseInt(chat.id.toString().split('-')[2] || 0) %
                        chatColors.length
                    ],
                }"
              >
                {{ chatHeadFaceLabel(chat) }}
              </div>
              <span
                v-if="chatShowsKeywordFlag(chat)"
                class="keyword-flag"
                title="Keyword in a tenant message from the last 24 hours"
              >
                <i class="fas fa-flag"></i>
              </span>
              <div v-if="chatHeadBadge(chat) > 0" class="badge">
                {{ chatHeadBadge(chat) > 99 ? '99+' : chatHeadBadge(chat) }}
              </div>
            </div>
            </template>
            </div>
          </div>
        </div>
      </div>
      <div class="main-content-wrapper">
        <div class="action-buttons">
          <button @click="toggleShowUnread">
            {{ showRead ? 'Show All' : 'hide Read' }}
          </button>
          <button @click="catchUpUnreadChats">Catch Up</button>
          <button
            v-if="selectedChat && selectedChat.userId === 0"
            @click="deleteAllSystemMessages"
          >
            delete All
          </button>
          <button
            class="copy-message-btn"
            title="Delete selected message"
            @click="deleteSelectedMessageOrReply"
            :disabled="!selectedMessage && !selectedReply"
          >
            <i class="fas fa-trash"></i>
          </button>
          <button
            class="copy-message-btn"
            title="Edit selected message"
            @click="beginEditSelectedMessage"
            :disabled="!selectedMessage && !selectedReply"
          >
            <i class="fas fa-pen"></i>
          </button>
          <button
            class="copy-message-btn"
            title="Copy selected message"
            @click="copySelectedMessageOrReply"
            :disabled="!selectedMessage && !selectedReply"
          >
            <i class="fas fa-copy"></i>
          </button>
        </div>
        <div class="content">
          <div class="search-bar">
            <input
              v-model="conversationQuery"
              placeholder="Search..."
              :class="{ 'search-input-iphone': isIphone }"
            />
            <button @click="clearSearch">
              <i class="fas fa-backspace"></i>
            </button>
            <button @click="scrollToTop">
              <i class="fas fa-angle-up"></i>
            </button>
            <button @click="scrollToBottom">
              <i class="fas fa-angle-down"></i>
            </button>
            <button
              @click="refreshConversation"
              :disabled="!selectedChat || refreshingConversation"
              title="Reload this conversation"
            >
              <i
                class="fas fa-sync-alt"
                :class="{ 'fa-spin': refreshingConversation }"
              ></i>
            </button>
          </div>
          <div class="conversation-panel" ref="conversationPanelRef">
            <!-- Show pagination button at the top of messages -->
            <div v-if="selectedChat" class="pagination-control">
              <button @click="loadMoreMessages" :disabled="loadingMoreMessages">
                {{ loadingMoreMessages ? 'Loading...' : 'Load More Messages' }}
              </button>
            </div>

            <div
              v-if="tenantResolvedMessageId != null"
              class="tenant-resolve-bar"
            >
              <button
                type="button"
                class="tenant-resolve-toggle"
                @click="toggleTenantResolved"
              >
                <i
                  class="fas"
                  :class="
                    tenantResolvedExpanded ? 'fa-chevron-down' : 'fa-chevron-up'
                  "
                ></i>
                {{
                  tenantResolvedExpanded
                    ? 'hide resolved issue'
                    : 'show resolved issue'
                }}
              </button>
            </div>

            <template v-for="row in conversationPanelRows" :key="row.key">
            <button
              v-if="row.kind === 'header'"
              type="button"
              class="chat-date-group-header"
              :class="{
                'chat-date-group-header-spaced':
                  row.group.key === 'week' || row.group.key === 'older',
              }"
              :aria-expanded="!systemDateCollapsed[row.group.key]"
              @click="toggleSystemDateGroup(row.group.key)"
            >
              <i
                class="fas"
                :class="
                  systemDateCollapsed[row.group.key]
                    ? 'fa-chevron-right'
                    : 'fa-chevron-down'
                "
              ></i>
              <span>{{ row.group.label }}</span>
              <span class="chat-date-group-count">{{
                row.group.items.length
              }}</span>
            </button>
            <div
              v-else
              class="message"
              :data-push-id="row.message.id"
              :title="row.message.id + ' ' + row.message.isReplyTo"
              :class="{
                fromuser: row.message.fromPeopleId !== null,
                selected: selectedMessage === row.message,
                reply: row.message.isReply,
                'reply-context': row.message._replyContext,
                'has-reactions': messageReactionList(row.message).length > 0,
                'system-chat-message': isSystemChatHead(selectedChat),
                'push-highlight': Number(row.message.id) === pushHighlightId,
              }"
              @click="selectMessage(row.message)"
            >
              <button
                v-if="
                  reactionAnchorId === row.message.id &&
                  row.message.isReply &&
                  !row.message._replyContext
                "
                type="button"
                class="chat-outdent"
                title="Make this a regular message"
                @click.stop="makeRegularMessage(row.message)"
              >
                <i class="fas fa-caret-left"></i>
              </button>
              <button
                v-if="reactionAnchorId === row.message.id"
                type="button"
                class="chat-react-face"
                title="React"
                @click.stop="toggleReactionPicker(row.message)"
              >
                😊
              </button>
              <div
                v-if="reactionPickerFor === row.message.id"
                class="chat-react-picker"
                @click.stop
              >
                <button
                  v-for="emoji in chatReactionEmojis"
                  :key="emoji"
                  type="button"
                  class="chat-react-choice"
                  :class="{
                    chosen: messageReactionList(row.message).includes(emoji),
                  }"
                  @click.stop="reactToMessage(row.message, emoji)"
                >
                  {{ emoji }}
                </button>
              </div>
              <div
                v-if="messageReactionList(row.message).length"
                class="chat-reaction-row"
              >
                <span
                  v-for="emoji in messageReactionList(row.message)"
                  :key="emoji"
                >{{ emoji }}</span>
              </div>
              <div class="timestamp">
                <span>{{ formatTimestamp(row.message.datetime) }}</span>
                <span
                  v-if="timestampSourceLabel(row.message)"
                  :class="getClassForInitials(timestampSourceLabel(row.message))"
                >{{ timestampSourceLabel(row.message) }}</span>
                <span
                  v-if="
                    row.message._tenantMessage &&
                    row.message.fromUserId &&
                    row.message.tenantViewedAt
                  "
                  class="tenant-viewed-check"
                  :title="`Tenant viewed ${formatTimestamp(row.message.tenantViewedAt)}`"
                >
                  <i class="fas fa-check-circle"></i>
                </span>
              </div>
              <div>
                <span
                  v-if="row.message.message"
                  :class="{ 'system-message-text': isSystemChatHead(selectedChat) }"
                  v-html="renderMarkdown(row.message.message, { linkPhones: isSystemChatHead(selectedChat) })"
                  @click="openWorkOrderFromMessage"
                ></span>
                <div
                  v-if="row.message.images && row.message.images.length"
                  class="chat-inline-images"
                >
                  <div
                    v-for="img in row.message.images"
                    :key="img.id || img.previewUrl"
                    class="chat-inline-image-wrap"
                    :data-chat-media-key="chatImageKey(img)"
                    @click.stop="openChatImage(img, row.message.images)"
                  >
                    <img
                      v-if="img.previewUrl || chatImageSrc(img)"
                      :src="img.previewUrl || chatImageSrc(img)"
                      class="chat-inline-image"
                      alt="Chat photo"
                    />
                    <div
                      v-else
                      class="chat-inline-image-skel"
                      aria-hidden="true"
                    ></div>
                  </div>
                </div>
                <div
                  v-if="row.message.audios && row.message.audios.length"
                  class="chat-inline-audios"
                >
                  <div
                    v-for="clip in row.message.audios"
                    :key="'a' + (clip.id || clip.previewUrl)"
                    class="chat-audio-player"
                    :data-chat-media-key="chatImageKey(clip)"
                    @click.stop
                  >
                    <button
                      type="button"
                      class="chat-audio-btn"
                      :title="
                        playingAudioId === chatAudioKey(clip) ? 'Pause' : 'Play'
                      "
                      @click="toggleChatAudio(clip)"
                    >
                      <i
                        :class="
                          playingAudioId === chatAudioKey(clip)
                            ? 'fas fa-pause'
                            : 'fas fa-play'
                        "
                      ></i>
                    </button>
                    <button
                      type="button"
                      class="chat-audio-btn"
                      title="Rewind"
                      @click="rewindChatAudio(clip)"
                    >
                      <i class="fas fa-undo"></i>
                    </button>
                    <span class="chat-audio-label">Voice</span>
                  </div>
                </div>
              </div>
              <div v-if="row.message.replies">
                <div
                  v-for="(reply, index) in row.message.replies"
                  :key="reply.datetime"
                  class="reply"
                  :class="{ selected: selectedReply === reply }"
                  @click.stop="selectReply(reply)"
                >
                  <div
                    v-if="shouldShowTimestamp(row.message.replies, index)"
                    class="timestamp"
                  >
                    {{ formatTimestamp(reply.datetime) }}
                  </div>
                  <div>
                    <strong>{{ reply.userId }}:</strong>
                    <span
                      :class="{ 'system-message-text': isSystemChatHead(selectedChat) }"
                      v-html="renderMarkdown(reply.replyMessage, { linkPhones: isSystemChatHead(selectedChat) })"
                      @click="openWorkOrderFromMessage"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
            </template>
            <div v-if="showTenantResolvePrompt" class="tenant-resolve-bar">
              <span>Is this issue resolved?</span>
              <button type="button" @click="markTenantIssueResolved">yes</button>
              <button type="button" @click="dismissTenantResolvePrompt">no</button>
            </div>
          </div>
        </div>
        <div class="composer-wrap">
          <div
            v-if="pendingChatImages.length"
            class="chat-pending-images"
          >
            <div
              v-for="item in pendingChatImages"
              :key="item.localId"
              class="chat-pending-thumb"
            >
              <img :src="item.previewUrl" alt="Pending photo" />
              <button
                type="button"
                class="chat-pending-remove"
                title="Remove photo"
                @mousedown.prevent
                @click="removePendingChatImage(item.localId)"
              >
                ×
              </button>
            </div>
            <button
              type="button"
              class="chat-pending-send"
              title="Send photo into this chat"
              :disabled="sendingChat"
              @mousedown.prevent
              @click="addMessageOrReply"
            >
              <i v-if="sendingChat" class="fas fa-spinner fa-spin"></i>
              <template v-else>Send</template>
            </button>
          </div>
          <div v-if="pendingChatAudio" class="chat-pending-audio">
            <div class="chat-audio-player chat-audio-player-pending">
              <audio
                ref="pendingAudioEl"
                :src="pendingChatAudio.previewUrl"
                preload="metadata"
                @ended="playingPendingAudio = false"
              ></audio>
              <button
                type="button"
                class="chat-audio-btn"
                :title="playingPendingAudio ? 'Pause' : 'Play'"
                @mousedown.prevent
                @click="togglePendingAudio"
              >
                <i
                  :class="playingPendingAudio ? 'fas fa-pause' : 'fas fa-play'"
                ></i>
              </button>
              <button
                type="button"
                class="chat-audio-btn"
                title="Rewind"
                @mousedown.prevent
                @click="rewindPendingAudio"
              >
                <i class="fas fa-undo"></i>
              </button>
              <span class="chat-audio-label"
                >Voice · {{ formatClock(pendingChatAudio.durationMs) }}</span
              >
              <button
                type="button"
                class="chat-pending-remove chat-pending-audio-remove"
                title="Remove recording"
                @mousedown.prevent
                @click="clearPendingChatAudio"
              >
                ×
              </button>
            </div>
            <button
              v-if="!pendingChatImages.length"
              type="button"
              class="chat-pending-send"
              title="Send voice into this chat"
              :disabled="sendingChat"
              @mousedown.prevent
              @click="addMessageOrReply"
            >
              <i v-if="sendingChat" class="fas fa-spinner fa-spin"></i>
              <template v-else>Send</template>
            </button>
          </div>
          <div v-if="isRecordingAudio" class="chat-recording-bar">
            <span class="chat-recording-dot"></span>
            <span class="chat-recording-label"
              >Recording {{ formatClock(recordingElapsedMs) }} / 2:00</span
            >
            <button
              type="button"
              class="chat-recording-stop"
              @mousedown.prevent
              @click="stopChatRecording"
            >
              Stop
            </button>
          </div>
          <div class="input-container">
            <input
              ref="galleryInputRef"
              type="file"
              accept="image/*,image/heic,image/heif,.heic,.heif"
              multiple
              class="chat-gallery-input"
              @change="onGalleryChange"
            />
            <button
              type="button"
              class="chat-attach-btn"
              title="Attach photo from gallery"
              :disabled="!selectedChat"
              @mousedown.prevent
              @click="openGalleryPicker"
            >
              <i class="fas fa-image"></i>
            </button>
            <button
              type="button"
              class="chat-attach-btn chat-mic-btn"
              :class="{ recording: isRecordingAudio }"
              :title="
                isRecordingAudio
                  ? 'Stop recording'
                  : 'Record voice (2 min max)'
              "
              :disabled="!selectedChat"
              @mousedown.prevent
              @click="toggleChatRecording"
            >
              <i class="fas fa-microphone"></i>
            </button>
            <textarea
              v-if="isMobile"
              v-model="newMessageOrReply"
              :disabled="!selectedChat"
              :placeholder="composerPlaceholder"
              title="Press and hold to clear"
              @paste="onComposerPaste"
              @input="onComposerInput"
              @keydown="onComposerKeydown"
              @touchstart.passive="startComposerHold"
              @touchend="cancelComposerHold"
              @touchcancel="cancelComposerHold"
              @contextmenu="onComposerContextMenu"
            ></textarea>
            <textarea
              v-if="!isMobile"
              v-model="newMessageOrReply"
              :disabled="!selectedChat"
              :placeholder="composerPlaceholder"
              title="Press Esc to clear"
              @paste="onComposerPaste"
              @input="onComposerInput"
              @keydown="onComposerKeydown"
            ></textarea>
            <button
              type="button"
              class="send-button"
              :title="sendingChat ? 'Sending' : 'Send'"
              :disabled="sendingChat || !selectedChat"
              :aria-busy="sendingChat"
              @mousedown.prevent
              @click="addMessageOrReply"
            >
              <i
                :class="
                  sendingChat
                    ? 'fas fa-spinner fa-spin'
                    : 'fas fa-paper-plane'
                "
              ></i>
            </button>
          </div>
        </div>
      </div>
      <div v-if="footerMessage != ''" class="footer">Message</div>

      <div
        v-if="showRecentFeatureHint"
        class="recent-feature-hint"
        role="note"
        :style="{
          '--recent-feature-hint-top': recentFeatureHintTop,
          '--recent-feature-hint-left': recentFeatureHintLeft,
        }"
        @click="hideRecentFeatureHint"
      >
        <div class="recent-feature-hint-callout">
          <svg
            class="recent-feature-hint-arrow"
            viewBox="0 0 72 40"
            aria-hidden="true"
          >
            <polygon points="26,4 2,20 26,36" fill="currentColor" />
            <line
              x1="22"
              y1="20"
              x2="68"
              y2="20"
              stroke="currentColor"
              stroke-width="4"
              stroke-linecap="round"
            />
          </svg>
          <div class="recent-feature-hint-copy">
            <p class="recent-feature-hint-text">
              New feature: see the 25 most recent tenant messages in one spot.
            </p>
            <button
              type="button"
              class="recent-feature-hint-dismiss"
              @click.stop="hideRecentFeatureHintForever"
            >
              don't show this again
            </button>
          </div>
        </div>
      </div>

      <!-- Rest of the template components remain unchanged -->
      <!-- ... -->
    </div>

    <div v-if="showDndPopup" class="dnd-popup">
      <div class="popup-header">
        <div class="popup-title">Inside Chat notifications</div>
        <button class="close-button" @click="showDndPopup = false">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="popup-body">
        <div class="dnd-always-row">
          <button
            type="button"
            class="dnd-always-on"
            :class="{ 'dnd-always-on-active': dndAlwaysOn }"
            :aria-pressed="dndAlwaysOn ? 'true' : 'false'"
            @click="toggleDndAlwaysOn"
          >
            always on
          </button>
          <button
            type="button"
            class="dnd-how"
            @click="showDndHow = true"
          >
            how it works
          </button>
        </div>
        <label class="dnd-until">
          do not disturb until:
          <input v-model="dndUntilInput" type="datetime-local" />
        </label>
        <label class="dnd-check">
          <input v-model="dndExceptEmergencies" type="checkbox" />
          except emergencies
        </label>
        <label class="dnd-check">
          <input v-model="dndExceptStaff" type="checkbox" />
          except staff
        </label>
        <label class="dnd-until dnd-keywords">
          keywords
          <input
            v-model="dndKeywordsInput"
            type="text"
            placeholder="leak, mold, no heat"
          />
        </label>
        <div class="dnd-actions">
          <button type="button" @click="saveInsideChatDndSettings">Save</button>
          <button type="button" @click="clearInsideChatDnd">Turn off</button>
        </div>
      </div>
    </div>

    <div
      v-if="showDndHow"
      class="dnd-how-panel"
      role="dialog"
      aria-label="How notifications work"
    >
      <div class="dnd-how-head">
        <span>How it works</span>
        <button
          type="button"
          class="dnd-how-close"
          aria-label="Close how it works"
          @click="showDndHow = false"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="dnd-how-body">
        <p v-for="part in dndHowParts" :key="part.title || part.body">
          <strong v-if="part.title">{{ part.title }}.</strong>
          {{ part.body }}
        </p>
      </div>
    </div>

    <!-- Group Management Popup -->
    <div v-if="showGroupManagement" class="group-management-popup">
      <div class="popup-header">
        <div class="popup-title">
          <small>Manage Group:</small>
          <div class="group-name">{{ selectedChat?.groupName }}</div>
        </div>
        <button class="close-button" @click="showGroupManagement = false">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="popup-body">
        <!-- Rename Group Section -->
        <div class="rename-group-section">
          <h4>Rename Group</h4>
          <div class="rename-input-group">
            <input v-model="newGroupNameEdit" placeholder="New group name" />
            <button @click="renameGroup()" :disabled="!newGroupNameEdit.trim()">
              Save
            </button>
          </div>
        </div>

        <!-- Member List Section -->
        <div class="member-section">
          <h4>Group Members</h4>
          <div v-if="loadingGroupMembers">Loading members...</div>
          <ul v-else class="member-list">
            <li
              v-for="member in groupMembers"
              :key="member.userId"
              class="member-item"
            >
              <span>{{ member.displayName || member.userId }}</span>
              <button
                class="remove-member"
                @click="removeMemberFromGroup(member.userId)"
              >
                <i class="fas fa-times"></i>
              </button>
            </li>
          </ul>
        </div>

        <!-- Add Members Section -->
        <div class="add-members-section">
          <h4>Add Members</h4>
          <input
            class="member-search"
            v-model="addMemberSearch"
            placeholder="Search for members to add..."
            @input="debouncedSearchMembersToAdd"
          />
          <ul v-if="membersToAdd.length > 0" class="members-to-add-list">
            <li
              v-for="user in membersToAdd"
              :key="user.userId"
              @click="addMemberToGroup(user.userId)"
            >
              <span>{{ user.displayName }}</span>
              <i class="fas fa-plus"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div
      v-if="showZoomEditor"
      class="zoom-url-popup"
      role="dialog"
      aria-label="Zoom link"
    >
      <div class="zoom-url-title">Zoom link</div>
      <input
        ref="zoomUrlInput"
        v-model="zoomUrlDraft"
        type="url"
        inputmode="url"
        autocomplete="off"
        spellcheck="false"
        @keydown.enter.prevent="saveZoomUrlEdit"
      />
      <div v-if="zoomUrlError" class="zoom-url-error">{{ zoomUrlError }}</div>
      <div class="zoom-url-actions">
        <button type="button" @click="showZoomEditor = false">Cancel</button>
        <button type="button" class="zoom-url-save" @click="saveZoomUrlEdit">
          Save
        </button>
      </div>
    </div>

    <div
      v-if="showRecentTenants"
      class="recent-tenants-popup"
      role="dialog"
      aria-label="Recent tenant messages"
    >
      <div class="recent-tenants-head">
        <span>Recent tenant messages</span>
        <button
          type="button"
          class="recent-tenants-close"
          aria-label="Close recent tenant messages"
          @click="showRecentTenants = false"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="recent-tenants-panel">
        <div v-if="recentTenantsLoading" class="recent-tenants-status">Loading…</div>
        <div v-else-if="recentTenantsError" class="recent-tenants-status">
          {{ recentTenantsError }}
        </div>
        <div v-else-if="!recentTenantRows.length" class="recent-tenants-status">
          No tenant messages.
        </div>
        <ul v-else class="recent-tenants-list">
          <li v-for="row in recentTenantRows" :key="row.id">
            <button
              type="button"
              class="recent-tenant-row"
              @click="onRecentTenantRowClick(row)"
              @pointerdown="startRecentTenantRowPress(row, $event)"
              @pointerup="cancelRecentTenantRowPress"
              @pointercancel="cancelRecentTenantRowPress"
              @pointerleave="cancelRecentTenantRowPress"
              @pointermove="moveRecentTenantRowPress($event)"
              @contextmenu.prevent="onRecentTenantRowContextMenu(row)"
            >
              <span class="recent-tenant-meta">
                <strong>{{ recentTenantHeading(row) }}</strong>
                <span>{{ recentTenantMessageStamp(row.createdAt) }}</span>
              </span>
              <span class="recent-tenant-text">{{ row.message || "[Photo]" }}</span>
            </button>
          </li>
        </ul>
        <div
          v-if="showRecentTenantsHint && recentTenantRows.length"
          class="recent-tenants-hint"
          role="note"
          @click="hideRecentTenantsHint"
        >
          <div class="recent-tenants-hint-callout">
            <p class="recent-tenants-hint-text">
              press and hold or click to go to a message in this list
            </p>
            <button
              type="button"
              class="recent-tenants-hint-dismiss"
              @click.stop="hideRecentTenantsHintForever"
            >
              don't show this again
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Add the close all chats confirmation popup -->
    <div v-if="showCloseAllChats" class="close-all-chats-popup">
      <div class="popup-content">
        <p>Close all chats?</p>
        <div class="popup-actions">
          <button @click="closeAllChats" class="confirm-btn">Yes</button>
          <button @click="showCloseAllChats = false" class="cancel-btn">
            No
          </button>
        </div>
      </div>
    </div>

    <!-- Add Chat Popup -->
    <div v-if="showPopup" class="popup">
      <div>
        <input
          type="text"
          v-model="searchQuery"
          placeholder="Search users or tenants..."
          @input="debouncedSearch"
          autofocus
        />
        <div class="chat-type-selector">
          <button
            :class="{ active: chatTypeTab === 'one-to-one' }"
            @click="chatTypeTab = 'one-to-one'"
          >
            Direct Chat
          </button>
          <button
            :class="{ active: chatTypeTab === 'group' }"
            @click="chatTypeTab = 'group'"
          >
            Group Chat
          </button>
        </div>

        <!-- One-to-one chat section -->
        <div v-if="chatTypeTab === 'one-to-one'" class="one-to-one-section">
          <ul v-if="searchResults.length > 0">
            <li
              v-for="result in searchResults"
              :key="result.id"
              @click="startChat(result)"
            >
              {{
                result.displayName ||
                result.fullName ||
                result.userId ||
                'Unknown'
              }}
            </li>
          </ul>
          <div v-else-if="searchQuery.trim()">No results found</div>
          <div v-else>Type to search for users or tenants</div>
        </div>

        <!-- Group chat section -->
        <div v-if="chatTypeTab === 'group'" class="group-section">
          <div v-if="!isCreatingGroup">
            <div class="section-header">
              <h3>Select a group</h3>
              <button class="create-group-btn" @click="isCreatingGroup = true">
                New Group
              </button>
            </div>

            <div v-if="loading" class="loading">Loading groups...</div>
            <ul v-else-if="groups.length > 0">
              <li
                v-for="group in groups"
                :key="group.id"
                @click="selectGroupChat(group)"
              >
                {{ group.name }}
              </li>
            </ul>
            <div v-else class="no-groups">No groups found</div>
          </div>

          <div v-else class="create-group">
            <div class="section-header">
              <h3>Create New Group</h3>
              <button class="back-btn" @click="isCreatingGroup = false">
                Back
              </button>
            </div>

            <input
              v-model="newGroupName"
              placeholder="Group name"
              class="group-name-input"
            />

            <div class="group-members">
              <h4>Add Members</h4>

              <div
                class="selected-members-list"
                v-if="selectedGroupMembers.length > 0"
              >
                <div
                  v-for="member in selectedGroupMembers"
                  :key="member.userId"
                  class="selected-member"
                >
                  {{ member.displayName }}
                  <button @click="removeSelectedMember(member)">×</button>
                </div>
              </div>

              <input
                type="text"
                v-model="groupMemberSearch"
                placeholder="Search members..."
                @input="debouncedSearchGroupMembers"
              />

              <ul v-if="groupMemberResults.length > 0">
                <li
                  v-for="user in groupMemberResults"
                  :key="user.userId"
                  @click="selectGroupMember(user)"
                  :class="{ 'already-selected': isUserAlreadySelected(user) }"
                >
                  {{ user.displayName }}
                  <span
                    v-if="isUserAlreadySelected(user)"
                    class="already-selected-text"
                  >
                    (Added)
                  </span>
                </li>
              </ul>
            </div>

            <div class="create-group-actions">
              <button
                @click="createGroup"
                class="create-btn"
                :disabled="
                  !newGroupName.trim() || selectedGroupMembers.length === 0
                "
              >
                Create
              </button>
              <button @click="isCreatingGroup = false" class="cancel-btn">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  <div
    v-if="lightboxImageUrl"
    class="chat-image-lightbox"
    @click="closeChatLightbox"
    @touchstart.passive="onLightboxTouchStart"
    @touchend="onLightboxTouchEnd"
    @touchcancel="onLightboxTouchCancel"
  >
    <img :src="lightboxImageUrl" alt="Chat photo" draggable="false" />
  </div>
  </div>
</template>

<script setup>
import {
  pushSupported,
  notificationPermission,
  subscribePushIfGranted,
  enableNotifications,
  setChatAppBadge,
} from '@/utils/chatPush';
import { ref, watch, computed, onMounted, onUnmounted, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from '@/axiosConfig';
import { debounce } from 'lodash';
import { openDB } from 'idb';
import { io } from 'socket.io-client'; // Import socket.io-client
import eventBus from './eventBus.js'; // Import eventBus
import { marked } from 'marked'; // Import marked for Markdown rendering
import MotdModal from './MotdModal.vue'; // Import MOTD modal component
import {
  isLikelyImageFile,
  prepareImageForWorkOrderUpload,
  uploadFileLikeWorkOrder,
} from '@/utils/chunkedHeicUpload';
import {
  clipboardImageItems,
  readClipboardImage,
} from '@/utils/chatClipboardImage';
import {
  CHAT_MEDIA_CACHE_LIMIT,
  getCachedChatMedia,
  putCachedChatMedia,
  pruneCachedChatMedia,
} from '@/utils/chatMediaCache';
import {
  isSystemChatMessage,
  incomingDirectPeer,
  chatsMatchIncomingDirect,
} from '@/utils/chatNotificationRules';
import {
  claimInsideChatSend,
  composerDraftText,
  loadInsideChatDraft,
  saveInsideChatDraft,
  detachChatReply,
  editableChatMessage,
  orderReplyThreadsToLatest,
  placeSentChatMessage,
} from '@/utils/insideChatSend';
import { readNavigatorOnline } from '@/utils/networkBanner';
import {
  OUTBOUND_HOLD_TEXT,
  deliverOrQueue,
  insideChatOutboundItem,
  isNetworkSendFailure,
} from '@/utils/outboundQueue';
import {
  chatHeaderProperty,
  chatHeaderNotifyOn,
  chatHeadFaceLabel,
  chatTimestampSourceLabel,
  groupChatHeads,
  isSystemChatHead,
  isSweepableInsideChat,
  isTenantChatHead,
  canAccessSystemChat,
  visibleInsideChats,
} from '@/utils/insideChatHeader';
import {
  linkWorkOrderMentions,
  workOrderIdFromChatHref,
} from '@/utils/chatWorkOrderLink';
import { linkPhoneTel } from '@/utils/chatPhoneLinks';
import {
  chatUsesDateSeparators,
  conversationPanelRowsFor,
  defaultSystemDateCollapsed,
} from '@/utils/systemChatDateGroups';
import { insideChatNewHeadHotkey } from '@/utils/insideChatNewHead';
import {
  chatLightboxIndex,
  chatLightboxSwipe,
} from '@/utils/insideChatLightbox';
import {
  conversationQueryAfterChatSelect,
  filterChatMessages,
} from '@/utils/insideChatSearch';
import {
  isTenantIssueResolved,
  lastTenantMessageId,
  visibleTenantMessages,
} from '@/utils/tenantIssueResolved';
import {
  chatHeadKeywordFlag,
  displayedChatUnread,
  isEmergencyTenantText,
  isInsideChatDndActive,
  isTenantChatMessage,
  keywordMessageStillOpen,
  messageHasKeyword,
  currentDndDevice,
  insideChatDndHowItWorks,
  readDndAlwaysOn,
  writeDndAlwaysOn,
} from '@/utils/insideChatDnd';
import { publishDndAlwaysOn } from '@/utils/smsAlertQuiet';
import { finishStaffChatMarkdown } from '@/utils/youtubePreview';
import { insideChatRootClass } from '@/utils/insideChatLayout';
import {
  insideChatShareUrl,
  insideChatShareTargetFromQuery,
  findChatForShareTarget,
} from '@/utils/insideChatShare';
import {
  insideChatPushScrollPlan,
  scrollPanelChildToCenter,
} from '@/utils/insideChatPushOpen';
import {
  ZOOM_PRESS_MS,
  readZoomUrl,
  writeZoomUrl,
  openZoomMeeting,
} from '@/utils/insideChatZoom';
import {
  findTenantChatHead,
  markRecentFeatureHintSeen,
  markRecentTenantsHintSeen,
  recentFeatureHintPosition,
  recentFeatureHintSeen,
  recentTenantHeading,
  recentTenantMessageStamp,
  recentTenantPeopleId,
  recentTenantsHintSeen,
  tenantChatHeadFromRecentRow,
} from '@/utils/recentTenantChat';

const props = defineProps({
  chatMessage: Object,
  sharedSocket: Object,
});

const route = useRoute();
const router = useRouter();

// Debug log message variables
const showDebug = ref(false);
const logMessage = ref('Chat tool initialized');
let logMessageTimeout = null;

// Push notifications
const notifPerm = ref(notificationPermission());
const needsNotifEnable = computed(
  () => pushSupported() && notifPerm.value !== 'granted',
);
const onEnableNotifications = async () => {
  const result = await enableNotifications();
  notifPerm.value = result.permission || notificationPermission();
  appendLog(
    result.ok
      ? '🔔 Push notifications enabled'
      : `🔕 ${result.message || 'Notifications not enabled'}`,
  );
};

// Function to append a message to the log
const appendLog = (message) => {
  const timestamp = new Date().toLocaleTimeString();
  logMessage.value = `${timestamp}: ${message}<br>` + logMessage.value;

  // Reset any existing timeout
  if (logMessageTimeout) {
    clearTimeout(logMessageTimeout);
    logMessageTimeout = null;
  }
};

// Function to copy log content to clipboard
const copyLogToClipboard = () => {
  // Create a temporary element to hold the raw text
  const tempEl = document.createElement('div');
  tempEl.innerHTML = logMessage.value;
  const textToCopy = tempEl.textContent || tempEl.innerText || '';

  try {
    navigator.clipboard.writeText(textToCopy).then(() => {
      // Briefly show confirmation
      const originalText = logMessage.value;
      logMessage.value +=
        '<br><span style="color: yellow">Log copied to clipboard!</span>';

      // Restore original log after 2 seconds
      setTimeout(() => {
        logMessage.value = originalText;
      }, 2000);
    });
  } catch (err) {
    console.error('Failed to copy log to clipboard:', err);
    logMessage.value +=
      '<br><span style="color: red">Failed to copy to clipboard</span>';
  }
};

// Function to toggle debug log display
const toggleDebug = () => {
  showDebug.value = !showDebug.value;

  // Clear any existing timeout if it exists
  if (logMessageTimeout) {
    clearTimeout(logMessageTimeout);
    logMessageTimeout = null;
  }

  // No more auto-dismiss timer - log stays open until manually closed
};

// Define generateUniqueId as a global function
let currentId = 1; // Start ID management at 1
const generateUniqueId = () => {
  // Generate a timestamp-based unique ID to avoid collisions
  const timestamp = new Date().getTime();
  const randomNum = Math.floor(Math.random() * 1000);
  return `${timestamp}-${randomNum}-${currentId++}`;
};

const formatLeaseProperty = (row) => {
  if (!row) return '';
  const unit = String(row.UnitNumber ?? row.unitNumber ?? '').trim();
  return [row.StreetNumber ?? row.streetNumber, row.StreetName ?? row.streetName, unit]
    .map((p) => (p == null ? '' : String(p).trim()))
    .filter(Boolean)
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();
};

const tenantPropertyByPeopleId = ref({});

const parseGroupMemberNames = (raw) => {
  if (Array.isArray(raw)) {
    return raw.map((n) => String(n || '').trim()).filter(Boolean);
  }
  if (typeof raw === 'string' && raw.trim()) {
    return raw
      .split('\n')
      .map((n) => n.trim())
      .filter(Boolean);
  }
  return [];
};

const applyGroupMeta = (chat, group) => {
  if (!chat || !group) return;
  if (group.name) chat.groupName = group.name;
  const names = parseGroupMemberNames(group.memberNames);
  if (names.length) chat.memberNames = names;
};

const chatHeadTitle = (chat) => {
  if (!chat) return '';
  if (chat.groupId) {
    const groupLabel = chat.groupName || chat.initials || 'Group';
    const members = parseGroupMemberNames(chat.memberNames);
    if (members.length) return [groupLabel, ...members].join('\n');
    return groupLabel;
  }
  const name =
    chat.displayName || chat.fullName || chat.groupName || '';
  const addr =
    chat.propertyAddress ||
    (chat.personId != null
      ? tenantPropertyByPeopleId.value[Number(chat.personId)]
      : '') ||
    '';
  if (name && addr) return `${name}\n${addr}`;
  if (name) return name;
  if (chat.initials === 'UC') return 'Unknown contact';
  return chat.initials || '';
};

const applyLeaseRowToChat = (chat, row) => {
  if (!chat || !row) return;
  const addr = formatLeaseProperty(row);
  if (addr) {
    chat.propertyAddress = addr;
    if (row.peopleId != null) {
      tenantPropertyByPeopleId.value[Number(row.peopleId)] = addr;
    }
  }
  const fullName = row.fullName || row.tenantName || '';
  if (fullName && !chat.displayName && !chat.fullName) {
    chat.displayName = fullName;
    chat.fullName = fullName;
    if (chat.initials === 'UC') {
      chat.initials = fullName
        .split(' ')
        .map((n) => n[0])
        .join('');
    }
  }
  if (Object.prototype.hasOwnProperty.call(row, 'pixieNotifications')) {
    chat.pixieNotifications = row.pixieNotifications;
  }
};

const activeChats = ref([]);
const conversations = ref([]);
const showRecentTenants = ref(false);
const showRecentTenantsHint = ref(false);
const showRecentFeatureHint = ref(false);
const recentFeatureHintTop = ref('80px');
const recentFeatureHintLeft = ref('72px');
const zoomUrl = ref(readZoomUrl(localStorage));
const showZoomEditor = ref(false);
const zoomUrlDraft = ref('');
const zoomUrlError = ref('');
const zoomUrlInput = ref(null);
const zoomLongPressed = ref(false);
const recentTenantRows = ref([]);
const recentTenantsLoading = ref(false);
const recentTenantsError = ref('');
const tenantResolvedMessageId = ref(null);
const tenantResolvedExpanded = ref(false);
const resolvePromptHiddenFor = ref(null);
const showPopup = ref(false);
const searchQuery = ref('');
const conversationQuery = ref('');
const isIphone = /iPhone/.test(navigator.userAgent || '');
const searchResults = ref([]);
const currentUser = ref(null);
const footerMessage = ref('');
const myId = ref(null); // Store the client's own ID
const recentMessageIds = ref(new Set()); // Track recently received message IDs to prevent duplicates
const loadingMoreMessages = ref(false); // Track whether we're loading more messages
const paginationCount = ref(1); // Number of pages (n * 100) to load

const chatColors = [
  '#FFD700',
  '#FFA500',
  '#FF8C00',
  '#FF4500',
  '#FF0000',
  '#FF1493',
  '#FF69B4',
  '#FF00FF',
  '#8A2BE2',
];

const showRead = ref(false);
const showDndPopup = ref(false);
const showDndHow = ref(false);
const dndHowParts = insideChatDndHowItWorks();
const dndUntilInput = ref('');
const dndExceptEmergencies = ref(true);
const dndExceptStaff = ref(true);
const dndKeywordsInput = ref('');
const keywordFlags = ref({});
const keywordAlertCounts = ref({});
const resolvedKeywordBoundary = ref({});
const dndSettings = ref({
  until: null,
  exceptEmergencies: true,
  exceptStaff: true,
  keywords: '',
});
const dndNow = ref(new Date());
const dndAlwaysOn = ref(readDndAlwaysOn(localStorage, null));
let dndTickTimer = null;
let keywordFlagTimer = null;
const dndAlertSettings = computed(() => ({
  ...dndSettings.value,
  alwaysOn: dndAlwaysOn.value,
}));
const insideChatDndOn = computed(() =>
  isInsideChatDndActive(dndAlertSettings.value, dndNow.value),
);
const chatHeadBadge = (chat) => {
  const withKeyword = {
    ...chat,
    keywordUnread: Math.max(
      Number(chat.keywordUnread) || 0,
      Number(keywordAlertCounts.value[Number(chat.personId)]) || 0,
    ),
  };
  return displayedChatUnread(withKeyword, dndAlertSettings.value, dndNow.value);
};
const chatShowsKeywordFlag = (chat) =>
  chatHeadKeywordFlag(chat, keywordFlags.value, dndNow.value);
const totalUnread = computed(() =>
  activeChats.value.reduce((n, c) => n + chatHeadBadge(c), 0),
);
watch(totalUnread, (v) => {
  setChatAppBadge(v);
});
const scheduleDndTick = () => {
  clearTimeout(dndTickTimer);
  dndTickTimer = null;
  const settings = dndAlertSettings.value;
  if (!isInsideChatDndActive(settings)) return;
  const until = new Date(settings.until).getTime();
  if (!Number.isFinite(until) || until <= Date.now()) return;
  const delay = Math.min(Math.max(until - Date.now(), 1000), 30000);
  dndTickTimer = setTimeout(() => {
    dndNow.value = new Date();
    scheduleDndTick();
  }, delay);
};
watch(
  [dndSettings, dndAlwaysOn],
  () => {
    dndNow.value = new Date();
    scheduleDndTick();
  },
  { deep: true },
);
watch(currentUser, (user) => {
  dndAlwaysOn.value = readDndAlwaysOn(localStorage, user && user.role);
});
watch(showDndPopup, (open) => {
  if (!open) showDndHow.value = false;
});
const dndDevicePayload = () =>
  currentDndDevice(localStorage, navigator.userAgent);
const syncDndDevice = async () => {
  try {
    await axios.put('/api/inside-chat/dnd-device', {
      ...dndDevicePayload(),
      alwaysOn: dndAlwaysOn.value,
    });
  } catch (error) {
    appendLog(`DND device save failed: ${error.message}`);
  }
};
const toggleDndAlwaysOn = () => {
  dndAlwaysOn.value = !dndAlwaysOn.value;
  writeDndAlwaysOn(localStorage, dndAlwaysOn.value);
  publishDndAlwaysOn(dndAlwaysOn.value);
  syncDndDevice();
  eventBus.emit('inside-chat-dnd-changed');
};
const selectedChat = ref(null);
const shareNote = ref('');
let shareNoteTimer = null;
const selectedChatProperty = computed(() =>
  chatHeaderProperty(selectedChat.value, tenantPropertyByPeopleId.value),
);
const selectedTenantNotifyOn = computed(() =>
  chatHeaderNotifyOn(selectedChat.value),
);
const chatHeadSections = computed(() =>
  groupChatHeads(
    visibleInsideChats(
      activeChats.value,
      currentUser.value && currentUser.value.role,
    ),
  ),
);
const newMessageOrReply = ref(loadInsideChatDraft(localStorage));
watch(newMessageOrReply, (text) => {
  saveInsideChatDraft(localStorage, text);
});
const conversationPanelRef = ref(null);
const galleryInputRef = ref(null);
const pendingChatImages = ref([]);
const pendingChatAudio = ref(null);
const sendingChat = ref(false);
const isRecordingAudio = ref(false);
const recordingElapsedMs = ref(0);
const playingAudioId = ref(null);
const playingPendingAudio = ref(false);
const pendingAudioEl = ref(null);
const chatImageUrls = ref({});
const lightboxImageUrl = ref('');
const lightboxImages = ref([]);
const lightboxIndex = ref(0);
let lightboxTouch = null;
let lightboxIgnoreClick = false;
let lightboxIgnoreTimer = 0;
let lightboxStepToken = 0;
const editingMessage = ref(null);
const composerPlaceholder = computed(() => {
  if (editingMessage.value) return 'Edit message, then Send';
  return pendingChatImages.value.length || pendingChatAudio.value
    ? 'Optional caption, then click Send'
    : isMobile.value
      ? 'Type your reply here...'
      : 'Type your reply here, hit TAB...';
});

// Chat type tab state variables
const chatTypeTab = ref('one-to-one');
const groups = ref([]);
const loading = ref(false);
const isCreatingGroup = ref(false);
const newGroupName = ref('');
const groupMemberSearch = ref('');
const groupMemberResults = ref([]);
const selectedGroupMembers = ref([]);

// Group management popup state variables
const showGroupManagement = ref(false);
const groupMembers = ref([]);
const loadingGroupMembers = ref(false);
const addMemberSearch = ref('');
const membersToAdd = ref([]);
const newGroupNameEdit = ref('');

// Function to load group members
const loadGroupMembers = async () => {
  if (!selectedChat.value || !selectedChat.value.groupId) return;

  loadingGroupMembers.value = true;
  try {
    const response = await axios.get(
      `/api/chat-groups/${selectedChat.value.groupId}/members`,
    );
    groupMembers.value = response.data;
  } catch (error) {
    console.error('Error fetching group members:', error);
  } finally {
    loadingGroupMembers.value = false;
  }
};

// Function to search for users to add to the group
const searchMembersToAdd = () => {
  if (!addMemberSearch.value.trim()) {
    membersToAdd.value = [];
    return;
  }

  const query = addMemberSearch.value.toLowerCase();
  // Filter out users who are already members
  const currentMemberIds = groupMembers.value.map((member) => member.id);
  membersToAdd.value = chatUsers.value
    .filter(
      (user) =>
        user.userId && // Only include users (employees)
        user.displayName &&
        user.displayName.toLowerCase().includes(query) &&
        !currentMemberIds.includes(user.userId),
    )
    .slice(0, 5);
};

const debouncedSearchMembersToAdd = debounce(searchMembersToAdd, 300);

// Function to add a member to the group
const addMemberToGroup = async (userId) => {
  if (!selectedChat.value || !selectedChat.value.groupId) return;

  try {
    await axios.post(`/api/chat-groups/${selectedChat.value.groupId}/members`, {
      members: [userId],
    });

    // Refresh the list of members
    await loadGroupMembers();
    addMemberSearch.value = '';
    membersToAdd.value = [];
  } catch (error) {
    console.error('Error adding member to group:', error);
  }
};

// Function to remove a member from the group
const removeMemberFromGroup = async (userId) => {
  if (!selectedChat.value || !selectedChat.value.groupId) return;

  try {
    await axios.delete(
      `/api/chat-groups/${selectedChat.value.groupId}/members/${userId}`,
    );

    // Refresh the list of members
    await loadGroupMembers();
  } catch (error) {
    console.error('Error removing member from group:', error);
  }
};

// Function to rename the group
const renameGroup = async () => {
  if (
    !selectedChat.value ||
    !selectedChat.value.groupId ||
    !newGroupNameEdit.value.trim()
  )
    return;

  try {
    await axios.put(`/api/chat-groups/${selectedChat.value.groupId}`, {
      name: newGroupNameEdit.value.trim(),
    });

    // Update group name in selectedChat and activeChats
    selectedChat.value.groupName = newGroupNameEdit.value.trim();

    const chatIndex = activeChats.value.findIndex(
      (chat) => chat.groupId === selectedChat.value.groupId,
    );

    if (chatIndex !== -1) {
      activeChats.value[chatIndex].groupName = newGroupNameEdit.value.trim();

      // Update in IndexedDB
      const existingChat = await chatDB.get(
        'chats',
        activeChats.value[chatIndex].id,
      );
      if (existingChat) {
        existingChat.groupName = newGroupNameEdit.value.trim();
        await chatDB.put('chats', existingChat);
      }
    }

    newGroupNameEdit.value = '';
  } catch (error) {
    console.error('Error renaming group:', error);
  }
};

// Watch showGroupManagement to load members when opened
watch(showGroupManagement, (newVal) => {
  if (newVal && selectedChat.value && selectedChat.value.groupId) {
    loadGroupMembers();
    newGroupNameEdit.value = selectedChat.value.groupName || '';
  }
});

const loadGroups = async () => {
  loading.value = true;
  try {
    const response = await axios.get('/api/chat-groups');
    groups.value = response.data;
  } catch (error) {
    console.error('Error fetching chat groups:', error);
  } finally {
    loading.value = false;
  }
};

const searchGroupMembers = () => {
  if (!groupMemberSearch.value.trim()) {
    groupMemberResults.value = [];
    return;
  }

  const query = groupMemberSearch.value.toLowerCase();
  // Filter users (not tenants) for adding to groups
  groupMemberResults.value = chatUsers.value
    .filter(
      (user) =>
        user.userId && // Only include users (employees)
        user.displayName &&
        user.displayName.toLowerCase().includes(query),
    )
    .slice(0, 5);
};

const debouncedSearchGroupMembers = debounce(searchGroupMembers, 300);

const selectGroupMember = (user) => {
  if (!isUserAlreadySelected(user)) {
    selectedGroupMembers.value.push(user);
    // Clear the search input
    groupMemberSearch.value = '';
    groupMemberResults.value = [];

    // Return focus to search input
    nextTick(() => {
      const input = document.querySelector('.group-members input');
      if (input) {
        input.focus();
      }
    });
  }
};

const removeSelectedMember = (member) => {
  selectedGroupMembers.value = selectedGroupMembers.value.filter(
    (m) => m.userId !== member.userId,
  );
};

const isUserAlreadySelected = (user) => {
  return selectedGroupMembers.value.some(
    (member) => member.userId === user.userId,
  );
};

const createGroup = async () => {
  if (!newGroupName.value.trim() || selectedGroupMembers.value.length === 0) {
    return;
  }

  try {
    const memberIds = selectedGroupMembers.value.map((member) => member.userId);

    const response = await axios.post('/api/chat-groups', {
      name: newGroupName.value.trim(),
      members: memberIds,
    });

    // After creating the group, refresh the list and reset form
    await loadGroups();
    newGroupName.value = '';
    selectedGroupMembers.value = [];
    isCreatingGroup.value = false;

    // Start the chat with the new group
    if (response.data && response.data.groupId) {
      selectGroupChat({
        id: response.data.groupId,
        name: response.data.name,
        groupId: response.data.groupId,
        groupName: response.data.name,
      });
    }
  } catch (error) {
    console.error('Error creating group:', error);
  }
};

const selectGroupChat = async (group) => {
  // Check if group is already in activeChats
  const existingChat = activeChats.value.find(
    (chat) => chat.groupId && chat.groupId === group.id,
  );

  if (existingChat) {
    // If group chat exists, select it
    await selectChat(existingChat);
  } else {
    // Create a new group chat entry
    const newGroupChat = {
      id: generateUniqueId(),
      initials: (() => {
        if (group.name && typeof group.name === 'string') {
          return group.name
            .split(' ')
            .map((n) => n[0])
            .join('');
        }
        // Default initials if groupName is not available
        return 'G' + (group.id || '');
      })(),
      displayName: null,
      fullName: null,
      personId: null,
      userId: null,
      groupId: group.id,
      groupName: group.name,
      unreadCount: 0,
      lastViewedMessageId: 0, // Initialize last viewed message ID
    };

    activeChats.value.unshift(newGroupChat);
    selectedChat.value = newGroupChat;

    try {
      await chatDB.add('chats', JSON.parse(JSON.stringify(newGroupChat)));
    } catch (error) {
      console.error('Error adding group chat to DB:', error);
    }

    // Load conversations for the group
    await loadGroupConversations(group.id, showRead.value);
  }

  showPopup.value = false;
};

// Update loadConversations to handle loading group messages
const loadGroupConversations = async (groupId, showRead) => {
  try {
    loading.value = true;
    const params = {
      groupId,
      showRead,
    };

    // Add limit parameter for pagination
    if (paginationCount.value > 1) {
      params.limit = paginationCount.value * 100;
    }

    const response = await axios.get('/api/chat-messages', { params });
    conversations.value = response.data;
    loading.value = false;
  } catch (error) {
    console.error('Error fetching group conversations:', error);
    loading.value = false;
  }
};

// Function to load more messages (increase pagination)
const loadMoreMessages = async () => {
  if (loadingMoreMessages.value) return;

  loadingMoreMessages.value = true;
  const oldPaginationCount = paginationCount.value;
  const oldMessageCount = conversations.value.length;
  const oldFirstMessageId = conversations.value[0]?.id || 'unknown';

  appendLog(
    `Load More clicked: Current page=${oldPaginationCount}, messages=${oldMessageCount}, first ID=${oldFirstMessageId}`,
  );

  paginationCount.value += 1;
  appendLog(`Pagination count increased to: ${paginationCount.value}`);

  try {
    if (selectedChat.value) {
      appendLog(
        `Requesting more messages with limit=${paginationCount.value * 100}`,
      );

      if (selectedChat.value.groupId) {
        await loadGroupConversations(
          selectedChat.value.groupId,
          showRead.value,
        );
      } else {
        await loadConversations(
          selectedChat.value.personId,
          selectedChat.value.userId,
          showRead.value,
        );
      }

      const newMessageCount = conversations.value.length;
      const newFirstMessageId = conversations.value[0]?.id || 'unknown';

      appendLog(
        `After load: messages=${newMessageCount}, first ID=${newFirstMessageId}`,
      );
      appendLog(`Messages added: ${newMessageCount - oldMessageCount}`);

      if (newMessageCount === oldMessageCount) {
        appendLog(
          'WARNING: No new messages loaded - pagination may not be working!',
        );
      } else if (chatUsesDateSeparators(selectedChat.value)) {
        systemDateCollapsed.value = {
          ...systemDateCollapsed.value,
          week: false,
          older: false,
        };
      }
    }
  } catch (error) {
    console.error('Error loading more messages:', error);
    appendLog(`Error loading more messages: ${error.message}`);
  } finally {
    loadingMoreMessages.value = false;
  }
};

let chatDB;

// Function to get auth token from localStorage
const getAuthToken = () => {
  return localStorage.getItem('token');
};

// Function to get the client's own ID (myId)
const fetchMyId = async () => {
  try {
    const response = await axios.get('/api/myid');
    myId.value = response.data.userId;
    console.log('My ID:', myId.value);
  } catch (error) {
    console.error('Error fetching my ID:', error);
  }
};

let socket; // Define socket instance outside the function

const onIncomingChatMessage = (data) => {
  appendLog(
    `📩 Received chat socket event with data ID: ${data?.id || 'unknown'}`,
  );
  handleNewChatMessages(data);
};

const onIncomingTenantChatMessage = (data) => {
  if (!data) return;

  if (data.senderType === 'staff') {
    // Skip system-generated messages (payment confirmations, etc.) — no real staff user
    if (!data.senderUserId) return;
    // Staff reply from another user — skip our own messages (already added locally)
    if (data.senderUserId === myId.value) return;
    appendLog(
      `📱 Received staff tenantChatMessage from userId: ${data.senderUserId} for peopleId: ${data._peopleId}`,
    );
    // Route to the tenant chat head using the tenant's peopleId
    handleNewChatMessages({
      id: `tenant_${data.id}`,
      fromPeopleId: data._peopleId,
      toPeopleId: null,
      fromUserId: null,
      toUserId: null,
      toGroupId: null,
      message: data.message,
      images: data.images || [],
      audios: data.audios || [],
      datetime: data.createdAt,
      fullName: data.staffName || 'Staff',
      _sourceClient: 'chatbot',
      _staffReply: true,
      _tenantMessage: true,
      _tenantConversationId: data._conversationId || data.conversationId,
    });
    return;
  }

  if (data.senderType !== 'tenant') return;
  appendLog(
    `📱 Received tenantChatMessage from peopleId: ${data.senderPeopleId}`,
  );
  // Look up tenant name from chatUsers if not provided
  let fullName = data.fullName;
  if (!fullName || fullName === 'Unknown Tenant') {
    const tenant = chatUsers.value.find(
      (u) => u.peopleId === data.senderPeopleId,
    );
    if (tenant) fullName = tenant.fullName || tenant.displayName;
  }
  // Transform to the format handleNewChatMessages expects
  handleNewChatMessages({
    id: `tenant_${data.id}`,
    fromPeopleId: data.senderPeopleId,
    toPeopleId: null,
    fromUserId: null,
    toUserId: null,
    toGroupId: null,
    message: data.message,
    images: data.images || [],
    audios: data.audios || [],
    datetime: data.createdAt,
    fullName: fullName || 'Unknown Tenant',
    _sourceClient: 'chatbot',
    _tenantMessage: true,
    _tenantConversationId: data._conversationId || data.conversationId,
  });
};

const onIncomingTenantMessageRead = (data) => {
  if (!data || !data.messageId) return;
  appendLog(
    `✓ Tenant viewed message ${data.messageId} (peopleId: ${data.peopleId})`,
  );
  const target = conversations.value.find((m) => m.id === data.messageId);
  if (target) {
    target.tenantViewedAt = data.readAt || new Date().toISOString();
  }
};

const unregisterChatSocketHandlers = (target) => {
  if (!target) return;
  target.off('newChatMessages', onIncomingChatMessage);
  target.off('relayChatMessage', onIncomingChatMessage);
  target.off('tenantChatMessage', onIncomingTenantChatMessage);
  target.off('tenantMessageRead', onIncomingTenantMessageRead);
  target.off('tenantIssueResolved', onTenantIssueResolved);
};

const registerChatSocketHandlers = (target) => {
  if (!target) return;
  unregisterChatSocketHandlers(target);
  target.on('newChatMessages', onIncomingChatMessage);
  target.on('relayChatMessage', onIncomingChatMessage);
  target.on('tenantChatMessage', onIncomingTenantChatMessage);
  target.on('tenantMessageRead', onIncomingTenantMessageRead);
  target.on('tenantIssueResolved', onTenantIssueResolved);
  appendLog('✓ Registered chat socket event handlers');
};

const attachToSharedSocket = (shared) => {
  if (!shared) return;
  if (socket && socket !== shared) {
    unregisterChatSocketHandlers(socket);
    socket.disconnect();
    appendLog('🔌 Disconnected own socket after switching to shared socket');
  }
  socket = shared;
  registerChatSocketHandlers(socket);
};

// Use NavBar's socket when present (even if still connecting). On /ichat
// there is no NavBar, so open our own connection and bind the same handlers.
const connectSocket = () => {
  try {
    if (props.sharedSocket) {
      appendLog('🔗 Using shared socket from NavBar');
      attachToSharedSocket(props.sharedSocket);
      if (socket.connected) {
        appendLog(`✓ Shared socket ID: ${socket.id}`);
      } else {
        appendLog(
          '⏳ Shared socket not connected yet — handlers registered, waiting',
        );
      }
      return;
    }

    const socketUrl = process.env.VUE_APP_SOCKET_URL;

    appendLog(
      `🔌 No shared socket available - creating new connection to: ${socketUrl || 'URL is undefined!'}`,
    );

    if (!socketUrl) {
      console.error('Socket URL is undefined.');
      appendLog(
        '⚠️ ERROR: Socket URL is undefined. Check environment variables.',
      );
      return;
    }

    const token = getAuthToken();
    if (!token) {
      appendLog(
        '⚠️ ERROR: No authentication token found. Socket authentication will fail.',
      );
    } else {
      appendLog(`✓ Auth token found (${token.substring(0, 15)}...)`);
    }

    appendLog('Creating socket connection...');
    socket = io(socketUrl, {
      query: {
        token: token,
        source: 'insideChat',
      },
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
    });

    registerChatSocketHandlers(socket);

    socket.on('connect', () => {
      appendLog(`✓ Connected to WebSocket server with ID: ${socket.id}`);
      console.log('Connected to WebSocket server');
      socket.emit('authenticate', token);
      appendLog('✓ Sent authentication token to server');
    });

    socket.on('connect_error', (error) => {
      appendLog(`⚠️ Socket connection error: ${error.message}`);
      console.error('Socket connection error:', error);
    });

    socket.on('connect_timeout', () => {
      appendLog('⚠️ Socket connection timeout');
      console.error('Socket connection timeout');
    });

    socket.on('error', (error) => {
      appendLog(`⚠️ Socket error: ${error.message}`);
      console.error('Socket error:', error);
    });

    socket.on('reconnect', (attemptNumber) => {
      appendLog(`✓ Socket reconnected after ${attemptNumber} attempts`);
      console.log('Reconnected to WebSocket server');
      socket.emit('authenticate', token);
      // Catch up heads/unreads missed while the socket was down (mobile background).
      loadActiveChats();
    });

    socket.on('reconnect_error', (error) => {
      appendLog(`⚠️ Socket reconnection error: ${error.message}`);
      console.error('Socket reconnection error:', error);
    });

    socket.on('disconnect', (reason) => {
      appendLog(`⚠️ Disconnected from WebSocket server: ${reason}`);
      console.log('Disconnected from WebSocket server:', reason);
    });
  } catch (error) {
    appendLog(`⚠️ Error in connectSocket: ${error.message}`);
    console.error('Error connecting to WebSocket server:', error);
  }
};

watch(
  () => props.sharedSocket,
  (shared) => {
    if (shared && socket !== shared) {
      appendLog('🔗 Shared socket became available — switching');
      attachToSharedSocket(shared);
    }
  },
);

// Add a message ID to the recentMessageIds set
const addToRecentMessageIds = (messageId) => {
  if (!messageId) return;

  recentMessageIds.value.add(messageId);

  // Trim the set if it grows too large (keep last 100 messages)
  if (recentMessageIds.value.size > 100) {
    const iterator = recentMessageIds.value.values();
    recentMessageIds.value.delete(iterator.next().value);
  }
};

// Check if a message ID exists in the recentMessageIds set
const isRecentMessageId = (messageId) => {
  if (!messageId) return false;
  return recentMessageIds.value.has(messageId);
};

const ensureSystemChatHead = async () => {
  if (
    !canAccessSystemChat(currentUser.value && currentUser.value.role)
  ) {
    return null;
  }
  let systemChat = activeChats.value.find((c) => isSystemChatHead(c));
  if (systemChat) {
    systemChat.initials = 'Sys';
    systemChat.displayName = systemChat.displayName || 'System';
    systemChat.fullName = systemChat.fullName || 'System';
    systemChat.userId = 0;
    systemChat.personId = null;
    systemChat.groupId = null;
    systemChat._tenantConversationId = null;
    return systemChat;
  }
  systemChat = {
    id: generateUniqueId(),
    initials: 'Sys',
    displayName: 'System',
    fullName: 'System',
    personId: null,
    userId: 0,
    groupId: null,
    groupName: null,
    unreadCount: 0,
    lastMessageId: 0,
    lastViewedMessageId: 0,
  };
  activeChats.value.push(systemChat);
  try {
    await chatDB.add('chats', JSON.parse(JSON.stringify(systemChat)));
  } catch (e) {
    appendLog(`Error adding System chat to IndexedDB: ${e?.message || e}`);
  }
  return systemChat;
};

const incrementSystemChatUnread = async (data) => {
  const systemChat = await ensureSystemChatHead();
  if (!systemChat) return;
  if (
    selectedChat.value &&
    Number(selectedChat.value.userId) === 0 &&
    selectedChat.value.id === systemChat.id
  ) {
    // Viewing System — append and mark this row read so the head badge stays correct
    if (!conversations.value.some((m) => m.id === data.id)) {
      conversations.value.push(data);
    }
    systemChat.unreadCount = 0;
    systemChat.emergencyUnread = 0;
    if (data?.id) {
      try {
        await axios.post('/api/mark-chat-messages-read', {
          messageIds: [data.id],
        });
        data.status = 1;
      } catch (e) {
        appendLog(`Error marking system message read: ${e?.message || e}`);
      }
    }
  } else {
    if (systemChat.unreadCount == null) systemChat.unreadCount = 0;
    systemChat.unreadCount++;
  }
  if (
    data?.id &&
    (!systemChat.lastMessageId || data.id > systemChat.lastMessageId)
  ) {
    systemChat.lastMessageId = data.id;
  }
  activeChats.value.sort(
    (a, b) => (Number(b.unreadCount) || 0) - (Number(a.unreadCount) || 0),
  );
  const existingChat = await chatDB.get('chats', systemChat.id);
  if (existingChat) {
    existingChat.unreadCount = systemChat.unreadCount;
    existingChat.lastMessageId = systemChat.lastMessageId;
    await chatDB.put('chats', existingChat);
  }
};

const clearChatUnread = (chat) => {
  if (!chat) return;
  chat.unreadCount = 0;
  chat.emergencyUnread = 0;
  chat.keywordUnread = 0;
};

const noteIncomingUnread = (chat, data) => {
  if (!chat) return;
  if (chat.unreadCount == null) chat.unreadCount = 0;
  chat.unreadCount++;
  if (isTenantChatMessage(data) && isEmergencyTenantText(data && data.message)) {
    chat.emergencyUnread = (Number(chat.emergencyUnread) || 0) + 1;
  }
  const keywordPeople =
    data && data.fromPeopleId != null ? data.fromPeopleId : data && data.senderPeopleId;
  const keywordMessageId = data && (data.id != null ? data.id : data.messageId);
  const keywordClosed =
    keywordMessageId != null &&
    keywordMessageId !== '' &&
    !keywordMessageStillOpen(
      keywordMessageId,
      resolvedKeywordBoundary.value[Number(keywordPeople)],
    );
  if (
    isTenantChatMessage(data) &&
    messageHasKeyword(data && data.message, dndSettings.value.keywords) &&
    !keywordClosed
  ) {
    chat.keywordUnread = (Number(chat.keywordUnread) || 0) + 1;
  }
};

const toDatetimeLocalValue = (iso) => {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

const clearKeywordFlagFor = (peopleId) => {
  const key = Number(peopleId);
  if (!Number.isFinite(key)) return;
  const next = { ...keywordFlags.value };
  const counts = { ...keywordAlertCounts.value };
  delete next[key];
  delete counts[key];
  keywordFlags.value = next;
  keywordAlertCounts.value = counts;
  for (const chat of activeChats.value) {
    if (Number(chat.personId) === key) chat.keywordUnread = 0;
  }
};

const applyKeywordFlags = (rows) => {
  const next = {};
  const counts = {};
  for (const row of rows || []) {
    if (!row || row.peopleId == null || !row.at) continue;
    const id = Number(row.peopleId);
    next[id] = row.at;
    counts[id] = Number(row.unread) || 0;
  }
  keywordFlags.value = next;
  keywordAlertCounts.value = counts;
  for (const chat of activeChats.value) {
    const id = Number(chat.personId);
    if (!Number.isFinite(id)) continue;
    if (counts[id] == null) chat.keywordUnread = 0;
  }
};

const applyDndPayload = (data) => {
  dndSettings.value = {
    until: data.until || null,
    exceptEmergencies: data.exceptEmergencies !== false,
    exceptStaff: data.exceptStaff !== false,
    keywords: data.keywords || '',
  };
  dndUntilInput.value = toDatetimeLocalValue(dndSettings.value.until);
  dndExceptEmergencies.value = dndSettings.value.exceptEmergencies;
  dndExceptStaff.value = dndSettings.value.exceptStaff;
  dndKeywordsInput.value = dndSettings.value.keywords;
  if (Array.isArray(data.keywordFlags)) applyKeywordFlags(data.keywordFlags);
};

const noteKeywordFlag = (data) => {
  if (!data || !isTenantChatMessage(data)) return;
  if (!messageHasKeyword(data.message, dndSettings.value.keywords)) return;
  const peopleId =
    data.fromPeopleId != null ? data.fromPeopleId : data.senderPeopleId;
  if (peopleId == null || peopleId === '') return;
  const at = data.datetime || data.createdAt || new Date().toISOString();
  const key = Number(peopleId);
  const messageId = data.id != null ? data.id : data.messageId;
  if (!keywordMessageStillOpen(messageId, resolvedKeywordBoundary.value[key])) {
    return;
  }
  if (!chatHeadKeywordFlag({ personId: key, userId: null }, { [key]: at })) {
    return;
  }
  keywordFlags.value = { ...keywordFlags.value, [key]: at };
};

const loadInsideChatDnd = async () => {
  try {
    const { data } = await axios.get('/api/inside-chat/dnd');
    applyDndPayload(data);
    await syncDndDevice();
  } catch (error) {
    appendLog(`DND load failed: ${error.message}`);
  }
};

const saveInsideChatDndSettings = async () => {
  const until = dndUntilInput.value
    ? new Date(dndUntilInput.value).toISOString()
    : null;
  const { data } = await axios.put('/api/inside-chat/dnd', {
    until,
    exceptEmergencies: dndExceptEmergencies.value,
    exceptStaff: dndExceptStaff.value,
    keywords: dndKeywordsInput.value,
    ...dndDevicePayload(),
  });
  applyDndPayload(data);
  showDndPopup.value = false;
  eventBus.emit('inside-chat-dnd-changed');
};

const clearInsideChatDnd = async () => {
  dndUntilInput.value = '';
  const { data } = await axios.put('/api/inside-chat/dnd', {
    until: null,
    exceptEmergencies: dndExceptEmergencies.value,
    exceptStaff: dndExceptStaff.value,
    keywords: dndKeywordsInput.value,
    ...dndDevicePayload(),
  });
  applyDndPayload(data);
  showDndPopup.value = false;
  eventBus.emit('inside-chat-dnd-changed');
};

// Function to handle new chat messages
const handleNewChatMessages = async (data) => {
  if (!data) return;
  if (Array.isArray(data)) data = data[0];

  // Add detailed log about received message
  appendLog(
    `🔔 NEW MESSAGE RECEIVED: ID=${data.id}, from=${data.fromUserId}, to=${data.toUserId}, toGroupId=${data.toGroupId}`,
  );
  appendLog(
    `Message content: ${data.message?.substring(0, 30)}${data.message?.length > 30 ? '...' : ''}`,
  );
  appendLog(`My ID: ${myId.value}`);
  noteKeywordFlag(data);

  // Check if message ID is already in the recently processed set
  if (data.id && isRecentMessageId(data.id)) {
    appendLog(`⚠️ Skipping already processed message ID: ${data.id}`);
    return;
  }

  // Add message ID to recently processed set
  if (data.id) {
    addToRecentMessageIds(data.id);
  }

  // System messages: always badge the System head (do not auto-open)
  if (isSystemChatMessage(data, myId.value)) {
    appendLog('System message — updating System chat head unread');
    await incrementSystemChatUnread(data);
    return;
  }

  // Enhanced duplicate detection logic
  const isDuplicate = conversations.value.some((existingMsg) => {
    // Check if messages have the same ID
    if (existingMsg.id === data.id) return true;

    // Special handling for messages from ChatBot client
    if (data._sourceClient === 'chatbot') {
      // For ChatBot messages, do strict duplicate detection
      if (
        existingMsg.message === data.message &&
        existingMsg.fromPeopleId === data.fromPeopleId &&
        !(data.audios && data.audios.length) &&
        !(data.images && data.images.length) &&
        Math.abs(new Date(existingMsg.datetime) - new Date(data.datetime)) <
          20000 // 20 second window
      ) {
        appendLog('Found duplicate ChatBot message');
        return true;
      }
    }

    // Standard duplicate detection for other messages
    if (
      existingMsg.message === data.message &&
      existingMsg.fromUserId === data.fromUserId &&
      existingMsg.fromPeopleId === data.fromPeopleId &&
      Math.abs(new Date(existingMsg.datetime) - new Date(data.datetime)) < 10000
    ) {
      appendLog('Found duplicate message with similar content and timestamp');

      // If the existing message was locally added, update it with server data
      if (existingMsg._locallyAdded) {
        Object.assign(existingMsg, {
          ...data,
          _locallyAdded: false,
        });
      }

      return true;
    }

    return false;
  });

  // If it's a duplicate, don't process it further
  if (isDuplicate) {
    appendLog('Detected duplicate message - ignoring');
    return;
  }

  // First, check for group chat messages
  if (data.toGroupId) {
    appendLog(`Processing group message for group ${data.toGroupId}`);

    // Skip messages from myself (unless we want to show our own messages too)
    if (data.fromUserId === myId.value) {
      appendLog(
        'This is my own group message - adding to conversation but not incrementing unread count',
      );
      // We might still want to add it to the conversation if it's the selected chat
      if (selectedChat.value && selectedChat.value.groupId === data.toGroupId) {
        conversations.value.push(data);

        // Scroll to the new message
        await nextTick();
        const lastMessage = document.querySelector(
          '.conversation-panel .message:last-child',
        );
        if (lastMessage) {
          lastMessage.scrollIntoView({ behavior: 'smooth' });
        }
      }
      return;
    }

    const groupChat = activeChats.value.find(
      (chat) => chat.groupId && chat.groupId === data.toGroupId,
    );

    if (groupChat) {
      // If the group chat is already in the active chats
      if (selectedChat.value && selectedChat.value.groupId === data.toGroupId) {
        // If this is the currently selected chat, add the message to conversations
        appendLog(
          `Adding message to current conversation (group ${data.toGroupId})`,
        );
        conversations.value.push(data);

        // Mark message as read immediately since the user is viewing this chat
        try {
          if (data.id) {
            await axios.post('/api/mark-chat-messages-read', {
              messageIds: [data.id],
            });
            appendLog(`Marked message ${data.id} as read (current group chat)`);
          }
        } catch (error) {
          appendLog(`Error marking message as read: ${error.message}`);
        }

        // Scroll to the new message
        await nextTick();
        const lastMessage = document.querySelector(
          '.conversation-panel .message:last-child',
        );
        if (lastMessage) {
          lastMessage.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // Otherwise increment the unread count
        noteIncomingUnread(groupChat, data);
        appendLog(
          `⭐ Group chat unread count incremented to ${groupChat.unreadCount} for ${groupChat.groupName}`,
        );

        // Update the lastMessageId to track the latest message
        if (
          data.id &&
          (!groupChat.lastMessageId || data.id > groupChat.lastMessageId)
        ) {
          groupChat.lastMessageId = data.id;
          appendLog(
            `Updated lastMessageId for group ${data.toGroupId} to ${data.id}`,
          );
        }

        // Sort the chats by unreadCount in descending order
        activeChats.value.sort((a, b) => b.unreadCount - a.unreadCount);

        // Update the chat in IndexedDB
        const existingChat = await chatDB.get('chats', groupChat.id);
        if (existingChat) {
          existingChat.unreadCount = groupChat.unreadCount;
          existingChat.lastMessageId = groupChat.lastMessageId;
          await chatDB.put('chats', existingChat);
          appendLog(
            `Updated unread count in IndexedDB for group chat ${groupChat.id}`,
          );
        }
      }
      return;
    } else {
      // If the group is not in active chats, fetch group info and add it
      appendLog(
        `Group ${data.toGroupId} not found in active chats, attempting to fetch group info`,
      );
      try {
        const response = await axios.get('/api/chat-groups');
        const group = response.data.find((g) => g.id === data.toGroupId);
        if (group) {
          appendLog(`Found group ${group.name}, adding to chats`);

          // Create a new group chat entry with unread count of 1
          const newGroupChat = {
            id: generateUniqueId(),
            initials: (() => {
              if (group.name && typeof group.name === 'string') {
                return group.name
                  .split(' ')
                  .map((n) => n[0])
                  .join('');
              }
              return 'G' + (group.id || '');
            })(),
            displayName: null,
            fullName: null,
            personId: null,
            userId: null,
            groupId: group.id,
            groupName: group.name,
            memberNames: parseGroupMemberNames(group.memberNames),
            unreadCount: 1,
            emergencyUnread: 0,
            lastMessageId: data.id || 0,
            lastViewedMessageId: 0, // Initialize last viewed message ID
          };

          activeChats.value.unshift(newGroupChat);

          // Save to IndexedDB
          try {
            await chatDB.add('chats', JSON.parse(JSON.stringify(newGroupChat)));
            appendLog('Added new group chat to IndexedDB with unread count 1');
          } catch (err) {
            appendLog(`Error adding group to IndexedDB: ${err.message}`);
          }

          // Sort chats by unread count
          activeChats.value.sort((a, b) => b.unreadCount - a.unreadCount);
        }
      } catch (error) {
        console.error('Error fetching group info:', error);
        appendLog(`Error fetching group info: ${error.message}`);
      }
      return;
    }
  }

  // Handle one-to-one chats

  // Skip messages I sent myself (e.g. socket echo of staff-to-staff message).
  // We don't want to badge the recipient's chat head with an unread count
  // for messages we just sent.
  if (
    data.fromUserId != null &&
    myId.value != null &&
    Number(data.fromUserId) === Number(myId.value)
  ) {
    appendLog(
      'Skipping echo of message I sent — not incrementing unread on recipient chat head',
    );
    return;
  }

  const chat = activeChats.value.find((c) =>
    chatsMatchIncomingDirect(c, data, myId.value),
  );

  if (!chat) {
    appendLog(
      `⚠️ No matching chat found. fromPeopleId=${data.fromPeopleId}(${typeof data.fromPeopleId}) activeChats personIds: ${activeChats.value.map((c) => `${c.personId}(${typeof c.personId})`).join(', ')}`,
    );
  }

  if (chat) {
    // if the incoming message is for an activeChat....
    appendLog(
      `Found matching chat for this message: ${chat.displayName || chat.fullName || chat.id}`,
    );
    appendLog(
      `Selected chat: ${selectedChat.value ? selectedChat.value.id : 'none'}`,
    );
    appendLog(
      `Chat match criteria: fromPeopleId=${data.fromPeopleId}, toPeopleId=${data.toPeopleId}, fromUserId=${data.fromUserId}, toUserId=${data.toUserId}`,
    );

    // If no chat is selected, just increment unread count — don't auto-select
    // (auto-selecting triggers markMessagesAsRead, which would mark messages read
    //  on inactive tabs or before the user has actually seen them)
    if (selectedChat.value === null) {
      appendLog('No chat currently selected — incrementing unread count only');
      noteIncomingUnread(chat, data);
      activeChats.value.sort(
        (a, b) => (b.unreadCount || 0) - (a.unreadCount || 0),
      );
      const existingChat = await chatDB.get('chats', chat.id);
      if (existingChat) {
        existingChat.unreadCount = chat.unreadCount;
        existingChat.emergencyUnread = chat.emergencyUnread || 0;
        await chatDB.put('chats', existingChat);
      }
      return;
    }
    appendLog(
      `🔍 selectedChat.id=${selectedChat.value.id} chat.id=${chat.id} match=${selectedChat.value.id === chat.id}`,
    );
    if (selectedChat.value.id === chat.id) {
      // if the selectedChat matches the found chat, show the new message
      // and reset the unreadCount
      appendLog('Message is for the currently selected chat, showing message');
      clearChatUnread(chat);

      // Add the new message to the conversation if it's not already there
      if (!conversations.value.some((msg) => msg.id === data.id)) {
        conversations.value.push(data);
        appendLog('Added new message to current conversation');

        // Scroll to the new message
        await nextTick();
        const lastMessage = document.querySelector(
          '.conversation-panel .message:last-child',
        );
        if (lastMessage) {
          lastMessage.scrollIntoView({ behavior: 'smooth' });
        }
      }

      try {
        if (chat._tenantConversationId) {
          await axios.post('/api/tenant-chat/mark-read', {
            conversationId: chat._tenantConversationId,
          });
        } else if (data.id && !String(data.id).startsWith('tenant_')) {
          await axios.post('/api/mark-chat-messages-read', {
            messageIds: [data.id],
          });
        }
      } catch (error) {
        appendLog(`Error marking message as read: ${error.message}`);
      }
    } else {
      // if the selectedChat does not match the found chat, increment unreadCount
      noteIncomingUnread(chat, data);
      appendLog(
        `⭐ INCREMENTING unread count for chat ${chat.displayName || chat.fullName || chat.id} to ${chat.unreadCount}`,
      );
      appendLog(`Chat.id=${chat.id}, selectedChat.id=${selectedChat.value.id}`);

      // Update the lastMessageId to track the latest message
      if (data.id && (!chat.lastMessageId || data.id > chat.lastMessageId)) {
        chat.lastMessageId = data.id;
        appendLog(`Updated lastMessageId for chat to ${data.id}`);
      }

      // Inspect the DOM to see if the badge is actually being added
      appendLog('Checking DOM for badge elements...');
      setTimeout(() => {
        const badges = document.querySelectorAll('.badge');
        appendLog(`Found ${badges.length} badge elements in DOM`);
      }, 100);

      // Sort the chats by unreadCount in descending order
      activeChats.value.sort((a, b) => b.unreadCount - a.unreadCount);
    }
    // Update the existing item in chatDB if it exists, or create one if it doesn't
    const existingChat = await chatDB.get('chats', chat.id);
    if (existingChat) {
      appendLog(
        `Updating existing chat in IndexedDB, unreadCount=${chat.unreadCount}`,
      );
      existingChat.unreadCount = chat.unreadCount;
      existingChat.emergencyUnread = chat.emergencyUnread || 0;
      if (
        data.id &&
        (!existingChat.lastMessageId || data.id > existingChat.lastMessageId)
      ) {
        existingChat.lastMessageId = data.id;
      }
      await chatDB.put('chats', existingChat);
    } else {
      try {
        appendLog('Adding new chat to IndexedDB');
        await chatDB.add('chats', JSON.parse(JSON.stringify(chat))); // Ensure the object is serializable
      } catch (error) {
        if (error.name === 'ConstraintError') {
          appendLog('Chat already exists in the object store.');
        } else {
          appendLog(`Error storing chat: ${error.message}`);
          throw error;
        }
      }
    }
  } else {
    // Incoming DM/tenant with no head yet: create a badged head, do not
    // auto-select (that would mark the thread read before the user looks).
    appendLog(
      'No existing chat found for this message, creating a head with unread badge',
    );
    await ensureIncomingDirectChatHead(data);
  }
};

/** Create (or find) a direct chat head for an incoming message. Never selects it. */
const ensureIncomingDirectChatHead = async (data) => {
  const existing = activeChats.value.find((c) =>
    chatsMatchIncomingDirect(c, data, myId.value),
  );
  if (existing) return existing;

  const peer = incomingDirectPeer(data, myId.value);
  if (!peer) {
    appendLog(
      'Cannot create chat head — incoming message has no staff/tenant peer',
    );
    return null;
  }

  const name = peer.displayName || peer.fullName || '';
  const initials = name
    ? name
        .split(' ')
        .map((n) => n[0])
        .join('')
    : peer.userId != null
      ? 'U' + String(peer.userId).substring(0, 2)
      : peer.personId != null
        ? 'P' + String(peer.personId).substring(0, 2)
        : 'UC';

  const newChat = {
    id: generateUniqueId(),
    initials: initials || 'UC',
    displayName: peer.displayName,
    fullName: peer.fullName,
    personId: peer.personId,
    userId: peer.userId,
    groupId: null,
    groupName: null,
    unreadCount: 1,
    emergencyUnread:
      isTenantChatMessage(data) && isEmergencyTenantText(data && data.message)
        ? 1
        : 0,
    lastMessageId: data.id || 0,
    lastViewedMessageId: 0,
    propertyAddress:
      formatLeaseProperty(data) ||
      (peer.personId != null
        ? tenantPropertyByPeopleId.value[Number(peer.personId)]
        : '') ||
      '',
    pixieNotifications: (() => {
      const known = chatUsers.value.find(
        (user) =>
          peer.personId != null &&
          Number(user.peopleId) === Number(peer.personId),
      );
      return known ? known.pixieNotifications : undefined;
    })(),
  };

  if (data._tenantConversationId) {
    newChat._tenantConversationId = data._tenantConversationId;
  }

  activeChats.value.unshift(newChat);
  activeChats.value.sort(
    (a, b) => (Number(b.unreadCount) || 0) - (Number(a.unreadCount) || 0),
  );
  try {
    await chatDB.add('chats', JSON.parse(JSON.stringify(newChat)));
    appendLog(
      `Added incoming chat head ${name || peer.userId || peer.personId} with unread 1`,
    );
  } catch (error) {
    if (error.name === 'ConstraintError') {
      appendLog('Chat already exists in the object store.');
    } else {
      appendLog(`Error storing incoming chat head: ${error.message}`);
    }
  }
  return newChat;
};

const markMessagesAsRead = async () => {
  if (!selectedChat.value) {
    appendLog('No selected chat to mark as read');
    return;
  }

  // Conversation-level mark: clears ALL unreads for this thread in the DB
  // (client only loads ~45 days of history, so id-only mark left older
  // unreads in /api/chat/unseen-count and the MHome Chat Bot badge).
  try {
    const chat = selectedChat.value;
    if (chat._tenantConversationId) {
      appendLog(
        `Marking tenant conversation ${chat._tenantConversationId} as read`,
      );
      await axios.post('/api/tenant-chat/mark-read', {
        conversationId: chat._tenantConversationId,
      });
      // Also clear any legacy chat_messages rows for this tenant (toUserId=me)
      if (chat.personId != null) {
        await axios.post('/api/mark-chat-conversation-read', {
          peopleId: chat.personId,
        });
      }
    } else if (chat.groupId != null) {
      appendLog(`Marking group ${chat.groupId} conversation as read`);
      await axios.post('/api/mark-chat-conversation-read', {
        groupId: chat.groupId,
      });
    } else if (chat.userId != null) {
      appendLog(`Marking user_${chat.userId} conversation as read`);
      await axios.post('/api/mark-chat-conversation-read', {
        userId: chat.userId,
      });
    } else if (chat.personId != null) {
      appendLog(`Marking person_${chat.personId} conversation as read`);
      await axios.post('/api/mark-chat-conversation-read', {
        peopleId: chat.personId,
      });
    } else {
      appendLog('Cannot mark conversation read — no chat identifiers');
      return;
    }

    // Reflect locally for any loaded messages
    const me = Number(myId.value);
    if (Array.isArray(conversations.value)) {
      conversations.value.forEach((message) => {
        const from = message.fromUserId == null ? null : Number(message.fromUserId);
        const unread =
          message.status == null ||
          message.status === 0 ||
          message.status === '0';
        if (unread && from !== me) {
          message.status = 1;
        }
      });
    }

    clearChatUnread(chat);
    updateChatInIndexedDB(chat);

    appendLog('✓ Conversation marked as read');
  } catch (error) {
    appendLog(`Error marking messages as read: ${error.message}`);
    console.error('Error marking messages as read:', error);
  }
};

// Helper function to update chat in IndexedDB
const updateChatInIndexedDB = async (chat) => {
  try {
    if (chatDB) {
      await chatDB.put('chats', JSON.parse(JSON.stringify(chat)));
      appendLog(`Updated chat in IndexedDB: ${chat.id}`);
    }
  } catch (error) {
    appendLog(`Error updating chat in IndexedDB: ${error.message}`);
    console.error('Error updating chat in IndexedDB:', error);
  }
};

let groupHeadTimer = null;
const groupHeadLongPressed = ref(false);

const startGroupHeadPress = (chat) => {
  if (!chat?.groupId) return;
  groupHeadLongPressed.value = false;
  clearTimeout(groupHeadTimer);
  groupHeadTimer = setTimeout(() => {
    groupHeadLongPressed.value = true;
    selectedChat.value = chat;
    showGroupManagement.value = true;
  }, 600);
};

const cancelGroupHeadPress = () => {
  clearTimeout(groupHeadTimer);
  groupHeadTimer = null;
};

let zoomPressTimer = null;

const startZoomPress = () => {
  zoomLongPressed.value = false;
  clearTimeout(zoomPressTimer);
  zoomPressTimer = setTimeout(() => {
    zoomLongPressed.value = true;
    zoomUrlDraft.value = zoomUrl.value;
    zoomUrlError.value = '';
    showZoomEditor.value = true;
    nextTick(() => {
      if (zoomUrlInput.value) {
        zoomUrlInput.value.focus();
        zoomUrlInput.value.select();
      }
    });
  }, ZOOM_PRESS_MS);
};

const cancelZoomPress = () => {
  clearTimeout(zoomPressTimer);
  zoomPressTimer = null;
};

const onZoomClick = () => {
  cancelZoomPress();
  if (zoomLongPressed.value) {
    zoomLongPressed.value = false;
    return;
  }
  openZoomMeeting(zoomUrl.value, window);
};

const saveZoomUrlEdit = () => {
  const saved = writeZoomUrl(localStorage, zoomUrlDraft.value);
  if (!saved) {
    zoomUrlError.value = 'Enter a web address.';
    return;
  }
  zoomUrl.value = saved;
  showZoomEditor.value = false;
};

const placeRecentFeatureHint = () => {
  const panel = document.getElementById('insideChatPanel');
  const button = panel && panel.querySelector('.recent-tenant-btn');
  if (!panel || !button) return;
  const panelBox = panel.getBoundingClientRect();
  const buttonBox = button.getBoundingClientRect();
  const callout = panel.querySelector('.recent-feature-hint-callout');
  const placed = recentFeatureHintPosition({
    panelLeft: panelBox.left,
    panelTop: panelBox.top,
    clientLeft: panel.clientLeft,
    clientTop: panel.clientTop,
    buttonTop: buttonBox.top,
    buttonRight: buttonBox.right,
    buttonHeight: buttonBox.height,
    calloutHeight: callout ? callout.offsetHeight : 0,
  });
  recentFeatureHintTop.value = placed.top;
  recentFeatureHintLeft.value = placed.left;
};

const hideRecentFeatureHint = () => {
  showRecentFeatureHint.value = false;
};

const hideRecentFeatureHintForever = () => {
  showRecentFeatureHint.value = false;
  markRecentFeatureHintSeen(localStorage);
};

const hideRecentTenantsHint = () => {
  showRecentTenantsHint.value = false;
};

const hideRecentTenantsHintForever = () => {
  showRecentTenantsHint.value = false;
  markRecentTenantsHintSeen(localStorage);
};

const openRecentTenants = async () => {
  showRecentTenants.value = true;
  showRecentTenantsHint.value = !recentTenantsHintSeen(localStorage);
  recentTenantsLoading.value = true;
  recentTenantsError.value = '';
  try {
    const { data } = await axios.get('/api/tenant-chat/recent', {
      params: { limit: 25 },
    });
    recentTenantRows.value = Array.isArray(data) ? data : [];
  } catch (err) {
    console.error(err);
    recentTenantRows.value = [];
    recentTenantsError.value = 'Failed to load recent tenant messages.';
  } finally {
    recentTenantsLoading.value = false;
  }
};

const openRecentTenantChat = async (row) => {
  const peopleId = recentTenantPeopleId(row);
  if (peopleId == null) return;
  let chat = findTenantChatHead(activeChats.value, peopleId);
  const conversationId = Number(row && row.conversationId);
  if (!chat) {
    const draft = tenantChatHeadFromRecentRow(row);
    if (!draft) return;
    const known = (chatUsers.value || []).find(
      (user) =>
        Number(user.peopleId) === peopleId &&
        (user.userId == null || user.userId === ''),
    );
    chat = {
      id: generateUniqueId(),
      ...draft,
      propertyAddress: tenantPropertyByPeopleId.value[peopleId] || '',
      pixieNotifications: known ? known.pixieNotifications : undefined,
    };
    activeChats.value.unshift(chat);
    try {
      await chatDB.add('chats', JSON.parse(JSON.stringify(chat)));
    } catch (error) {
      appendLog(`Recent tenant chat head save: ${error.message}`);
    }
  } else if (Number.isFinite(conversationId) && conversationId > 0) {
    chat._tenantConversationId = conversationId;
    await updateChatInIndexedDB(chat);
  }
  showRecentTenants.value = false;
  await selectChat(chat);
};

const RECENT_ROW_PRESS_MS = 600;
let recentRowPressTimer = null;
let recentRowOpenedByPress = false;
let recentRowPressOrigin = null;

const startRecentTenantRowPress = (row, event) => {
  recentRowOpenedByPress = false;
  recentRowPressOrigin =
    event && Number.isFinite(event.clientX)
      ? { x: event.clientX, y: event.clientY }
      : null;
  clearTimeout(recentRowPressTimer);
  recentRowPressTimer = setTimeout(() => {
    recentRowOpenedByPress = true;
    openRecentTenantChat(row);
  }, RECENT_ROW_PRESS_MS);
};

const cancelRecentTenantRowPress = () => {
  clearTimeout(recentRowPressTimer);
  recentRowPressTimer = null;
  recentRowPressOrigin = null;
};

const moveRecentTenantRowPress = (event) => {
  if (!recentRowPressOrigin || !event) return;
  const dx = event.clientX - recentRowPressOrigin.x;
  const dy = event.clientY - recentRowPressOrigin.y;
  if (dx * dx + dy * dy > 100) cancelRecentTenantRowPress();
};

const onRecentTenantRowClick = (row) => {
  cancelRecentTenantRowPress();
  if (recentRowOpenedByPress) {
    recentRowOpenedByPress = false;
    return;
  }
  openRecentTenantChat(row);
};

const onRecentTenantRowContextMenu = (row) => {
  if (recentRowOpenedByPress) return;
  recentRowOpenedByPress = true;
  cancelRecentTenantRowPress();
  openRecentTenantChat(row);
};

const onChatHeadClick = (chat) => {
  if (groupHeadLongPressed.value) {
    groupHeadLongPressed.value = false;
    return;
  }
  selectChat(chat);
};

const selectChat = async (chat) => {
  if (
    isSystemChatHead(chat) &&
    !canAccessSystemChat(currentUser.value && currentUser.value.role)
  ) {
    return;
  }
  const previousChatId = selectedChat.value && selectedChat.value.id;
  selectedChat.value = chat;
  showPopup.value = false;

  conversationQuery.value = conversationQueryAfterChatSelect(
    conversationQuery.value,
    previousChatId,
    chat.id,
    isSystemChatHead(chat),
  );

  // Reset pagination counter
  paginationCount.value = 1;

  // Update unreadCount and lastViewedMessageId in chatDB
  const existingChat = await chatDB.get('chats', chat.id);
  if (existingChat) {
    existingChat.unreadCount = 0;
    existingChat.emergencyUnread = 0;
    // Set lastViewedMessageId to the current lastMessageId when viewing the chat
    existingChat.lastViewedMessageId = existingChat.lastMessageId || 0;
    await chatDB.put('chats', existingChat);
    appendLog(
      `Updated chat in IndexedDB: lastViewedMessageId set to ${existingChat.lastViewedMessageId}`,
    );
  }

  // Clear the unread count in UI
  clearChatUnread(chat);

  if (isSystemChatHead(chat)) {
    // userId 0 is falsy, so it must not fall through to the tenant loader.
    chat.initials = 'Sys';
    chat.userId = 0;
    chat.personId = null;
    chat.groupId = null;
    chat._tenantConversationId = null;
    await loadConversations(null, 0, showRead.value);
  } else if (chat.groupId) {
    // If this is a group chat, use loadGroupConversations
    await loadGroupConversations(chat.groupId, showRead.value);
  } else if (chat._tenantConversationId || isTenantChatHead(chat)) {
    // For tenant chats, load from tenant_messages
    let convId = chat._tenantConversationId;
    if (!convId) {
      // Look up conversation ID by peopleId
      try {
        const convResp = await axios.get('/api/tenant-chat/conversations');
        const match = convResp.data.find((c) => c.peopleId === chat.personId);
        if (match) {
          convId = match.id;
          chat._tenantConversationId = convId;
        }
      } catch (e) {
        appendLog(`Error looking up tenant conversation: ${e.message}`);
      }
    }
    if (convId) {
      await loadTenantConversations(convId);
    } else {
      conversations.value = [];
      appendLog('No tenant conversation found for this chat');
    }
  } else {
    // For one-to-one chats, use loadConversations
    await loadConversations(chat.personId, chat.userId, showRead.value);
  }

  // After loading conversations, mark all messages as read
  await markMessagesAsRead();

  // Add debug logging for message array information
  if (conversations.value && conversations.value.length > 0) {
    const messageCount = conversations.value.length;
    const firstMessageId = conversations.value[0]?.id || 'unknown';
    const lastMessageId =
      conversations.value[messageCount - 1]?.id || 'unknown';

    appendLog(
      `Chat selected: ${chat.displayName || chat.fullName || chat.groupName || 'Unknown'}`,
    );
    appendLog(
      `Chat ID: ${chat.userId !== null ? 'userId: ' + chat.userId : chat.personId !== null ? 'peopleId: ' + chat.personId : chat.groupId !== null ? 'groupId: ' + chat.groupId : 'Unknown ID'}`,
    );
    appendLog(`Messages loaded: ${messageCount}`);
    appendLog(`First message ID: ${firstMessageId}`);
    appendLog(`Last message ID: ${lastMessageId}`);
  } else {
    appendLog(
      `Chat selected with no messages: ${chat.displayName || chat.fullName || chat.groupName || 'Unknown'}`,
    );
  }

  // Scroll to the bottom after conversations are loaded
  await nextTick();
  scrollToBottom();
};

const selectedConversation = computed(() => {
  if (!selectedChat.value) return [];
  return conversations.value;
});

const getClassForInitials = (initials) => {
  if (initials === ' (Me)') {
    return 'from-me';
  } else {
    return 'initials';
  }
};

const chatImageKey = (img) => {
  if (!img) return '';
  if (typeof img !== 'object') return img ? `staff:${img}` : '';
  if (img.id == null) return '';
  const source = img.source || 'staff';
  return `${source}:${img.id}`;
};

const chatImageSrc = (img) => {
  if (img && img.previewUrl) return img.previewUrl;
  return chatImageUrls.value[chatImageKey(img)] || '';
};

const CHAT_VOICE_BLOB_TYPE = 'audio/ogg; codecs=opus';
const chatImageInflight = Object.create(null);
let chatMediaObserver = null;
let chatMediaPrefetchKey = '';

const attachmentBlob = (data, ...mimeHints) => {
  const mime = [data && data.type, ...mimeHints]
    .map((value) => String(value || '').split(';')[0].trim())
    .find(Boolean);
  return new Blob([data], { type: mime || '' });
};

const tagMessageMediaSources = (messages) => {
  for (const msg of messages || []) {
    const source = msg._tenantMessage ? 'tenant' : 'staff';
    for (const img of msg.images || []) {
      if (!img.source) img.source = source;
    }
    for (const clip of msg.audios || []) {
      if (!clip.source) clip.source = source;
    }
  }
};

const collectRecentChatMedia = (limit = CHAT_MEDIA_CACHE_LIMIT) => {
  tagMessageMediaSources(conversations.value);
  const items = [];
  for (const msg of conversations.value || []) {
    const dt = new Date(msg.datetime).getTime() || 0;
    for (const img of msg.images || []) {
      if (img.id != null) items.push({ media: img, datetime: dt, id: img.id });
    }
    for (const clip of msg.audios || []) {
      if (clip.id != null) items.push({ media: clip, datetime: dt, id: clip.id });
    }
  }
  items.sort((a, b) => b.datetime - a.datetime || b.id - a.id);
  return items.slice(0, limit).map((row) => row.media);
};

const findChatMediaByKey = (key) => {
  if (!key) return null;
  tagMessageMediaSources(conversations.value);
  for (const msg of conversations.value || []) {
    for (const img of msg.images || []) {
      if (chatImageKey(img) === key) return img;
    }
    for (const clip of msg.audios || []) {
      if (chatImageKey(clip) === key) return clip;
    }
  }
  return null;
};

const rememberChatMediaUrl = (key, blob) => {
  if (!key || !(blob instanceof Blob)) return '';
  const existing = chatImageUrls.value[key];
  if (existing) return existing;
  const url = URL.createObjectURL(blob);
  chatImageUrls.value = { ...chatImageUrls.value, [key]: url };
  return url;
};

const loadChatImage = async (img) => {
  if (!img || img.id == null) return;
  const key = chatImageKey(img);
  if (!key) return;
  if (img.previewUrl || chatImageUrls.value[key]) return;
  if (chatImageInflight[key]) return chatImageInflight[key];

  const run = (async () => {
    const cached = await getCachedChatMedia(key);
    if (cached) {
      rememberChatMediaUrl(key, cached);
      return;
    }
    const path =
      img.source === 'tenant'
        ? `/api/tenant-chat/images/${img.id}`
        : `/api/chat-images/${img.id}`;
    try {
      const res = await axios.get(path, { responseType: 'blob' });
      const blobType = String(res.data && res.data.type ? res.data.type : '');
      if (
        blobType.includes('json') ||
        blobType.includes('text/html') ||
        blobType.includes('text/plain')
      ) {
        console.error(`Invalid chat media response for ${key}`);
        return;
      }
      const isAudio = String(img.mimeType || blobType || '')
        .toLowerCase()
        .startsWith('audio/');
      const blob = isAudio
        ? new Blob([res.data], { type: 'audio/ogg' })
        : attachmentBlob(
            res.data,
            res.headers && res.headers['content-type'],
            img.mimeType,
          );
      rememberChatMediaUrl(key, blob);
      const recentKeys = collectRecentChatMedia().map((m) => chatImageKey(m));
      if (recentKeys.includes(key)) {
        await putCachedChatMedia(key, blob);
      }
    } catch (err) {
      console.error('Error loading chat image', img.id, err);
    }
  })();

  chatImageInflight[key] = run;
  try {
    await run;
  } finally {
    delete chatImageInflight[key];
  }
};

const teardownChatMediaObserver = () => {
  if (chatMediaObserver) {
    chatMediaObserver.disconnect();
    chatMediaObserver = null;
  }
};

const ensureChatMediaObserver = () => {
  if (chatMediaObserver) return chatMediaObserver;
  const root = conversationPanelRef.value;
  if (!root || typeof IntersectionObserver === 'undefined') return null;
  chatMediaObserver = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const key = entry.target.getAttribute('data-chat-media-key');
        chatMediaObserver.unobserve(entry.target);
        const media = findChatMediaByKey(key);
        if (media) loadChatImage(media);
      }
    },
    { root, rootMargin: '400px 0px', threshold: 0 },
  );
  return chatMediaObserver;
};

const observeChatMedia = () => {
  const root = conversationPanelRef.value;
  if (!root) return;
  teardownChatMediaObserver();
  if (typeof IntersectionObserver === 'undefined') {
    collectRecentChatMedia().forEach((media) => loadChatImage(media));
    return;
  }
  const observer = ensureChatMediaObserver();
  if (!observer) return;
  root.querySelectorAll('[data-chat-media-key]').forEach((el) => {
    const key = el.getAttribute('data-chat-media-key');
    if (!key || chatImageUrls.value[key]) return;
    const media = findChatMediaByKey(key);
    if (media && media.previewUrl) return;
    observer.observe(el);
  });
};

const prefetchRecentChatMedia = async () => {
  const items = collectRecentChatMedia();
  const keys = items.map((m) => chatImageKey(m)).filter(Boolean);
  const key = keys.join(',');
  if (key === chatMediaPrefetchKey) return;
  chatMediaPrefetchKey = key;
  if (!items.length) {
    await pruneCachedChatMedia(keys);
    return;
  }
  const queue = items.slice();
  const worker = async () => {
    while (queue.length) {
      const media = queue.shift();
      try {
        await loadChatImage(media);
      } catch (err) {
        console.error('Error prefetching chat media:', err);
      }
    }
  };
  await Promise.all([worker(), worker(), worker()]);
  await pruneCachedChatMedia(keys);
};

const scheduleChatMedia = () => {
  nextTick(() => {
    prefetchRecentChatMedia();
    observeChatMedia();
  });
};

const loadImagesForMessages = (messages) => {
  tagMessageMediaSources(messages);
  scheduleChatMedia();
};

const cacheChatMediaFromPreview = async (img) => {
  const key = chatImageKey(img);
  if (!key || !img.previewUrl) return;
  if (!chatImageUrls.value[key]) {
    chatImageUrls.value = {
      ...chatImageUrls.value,
      [key]: img.previewUrl,
    };
  }
  try {
    const blob = await fetch(img.previewUrl).then((r) => r.blob());
    await putCachedChatMedia(key, blob);
  } catch (err) {
    console.error('Error caching chat preview media:', err);
  }
};

const MAX_CHAT_RECORD_MS = 120000;
const chatAudioPlayers = new Map();
const mediaRecorderRef = ref(null);
const mediaStreamRef = ref(null);
const recordingChunks = [];
const recordingTimer = ref(null);
const recordingStartedAt = ref(0);
const discardRecording = ref(false);

const chatAudioKey = (clip) => {
  if (!clip) return '';
  if (clip.id) return String(clip.id);
  return clip.previewUrl || '';
};

const formatClock = (ms) => {
  const total = Math.max(0, Math.floor((Number(ms) || 0) / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
};

const getChatAudioPlayer = (key) => {
  let player = chatAudioPlayers.get(key);
  if (!player) {
    player = new Audio();
    player.preload = 'auto';
    player.addEventListener('ended', () => {
      if (playingAudioId.value === key) playingAudioId.value = null;
    });
    chatAudioPlayers.set(key, player);
  }
  return player;
};

const pauseAllChatAudio = (exceptId) => {
  chatAudioPlayers.forEach((player, id) => {
    if (exceptId && String(id) === String(exceptId)) return;
    if (player && !player.paused) player.pause();
  });
  const pending = pendingAudioEl.value;
  if (pending && !pending.paused) {
    pending.pause();
    playingPendingAudio.value = false;
  }
};

const toggleChatAudio = async (clip) => {
  const key = chatAudioKey(clip);
  if (!key) return;
  if (clip && clip.id && !clip.previewUrl) await loadChatImage(clip);
  const url = clip.previewUrl || chatImageSrc(clip);
  if (!url) return;
  const player = getChatAudioPlayer(key);
  if (playingAudioId.value === key && !player.paused) {
    player.pause();
    playingAudioId.value = null;
    return;
  }
  pauseAllChatAudio(key);
  if (player.src !== url) {
    player.src = url;
  }
  try {
    await player.play();
    playingAudioId.value = key;
  } catch (err) {
    console.warn('Chat audio play failed', err);
  }
};

const rewindChatAudio = (clip) => {
  const player = chatAudioPlayers.get(chatAudioKey(clip));
  if (player) player.currentTime = 0;
};

const togglePendingAudio = () => {
  const el = pendingAudioEl.value;
  if (!el) return;
  if (!el.paused) {
    el.pause();
    playingPendingAudio.value = false;
    return;
  }
  pauseAllChatAudio();
  el
    .play()
    .then(() => {
      playingPendingAudio.value = true;
    })
    .catch(() => {});
};

const rewindPendingAudio = () => {
  const el = pendingAudioEl.value;
  if (el) el.currentTime = 0;
};

const clearPendingChatAudio = () => {
  playingPendingAudio.value = false;
  if (pendingChatAudio.value?.previewUrl) {
    URL.revokeObjectURL(pendingChatAudio.value.previewUrl);
  }
  pendingChatAudio.value = null;
};

const stopMediaStream = () => {
  const stream = mediaStreamRef.value;
  if (stream) {
    stream.getTracks().forEach((t) => t.stop());
    mediaStreamRef.value = null;
  }
};

const stopRecordingTimer = () => {
  if (recordingTimer.value) {
    clearInterval(recordingTimer.value);
    recordingTimer.value = null;
  }
};

const stopChatRecording = ({ discard = false } = {}) => {
  if (discard) discardRecording.value = true;
  stopRecordingTimer();
  const recorder = mediaRecorderRef.value;
  mediaRecorderRef.value = null;
  if (recorder && recorder.state !== 'inactive') {
    try {
      recorder.stop();
    } catch {
      stopMediaStream();
      isRecordingAudio.value = false;
    }
  } else {
    stopMediaStream();
    isRecordingAudio.value = false;
  }
};

const startChatRecording = async () => {
  if (!selectedChat.value) return;
  if (
    typeof MediaRecorder === 'undefined' ||
    !navigator.mediaDevices?.getUserMedia
  ) {
    window.alert('Voice recording is not supported in this browser.');
    return;
  }
  if (isRecordingAudio.value) return;
  clearPendingChatAudio();
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    mediaStreamRef.value = stream;
    const recorder = new MediaRecorder(stream);
    recordingChunks.length = 0;
    recorder.ondataavailable = (e) => {
      if (e.data && e.data.size) recordingChunks.push(e.data);
    };
    recorder.onstop = () => {
      stopRecordingTimer();
      stopMediaStream();
      isRecordingAudio.value = false;
      const shouldDiscard = discardRecording.value;
      discardRecording.value = false;
      const blob = new Blob(recordingChunks, {
        type: CHAT_VOICE_BLOB_TYPE,
      });
      recordingChunks.length = 0;
      if (shouldDiscard || !blob.size) return;
      pendingChatAudio.value = {
        blob,
        mimeType: 'audio/ogg',
        previewUrl: URL.createObjectURL(blob),
        durationMs: recordingElapsedMs.value,
      };
    };
    recorder.onerror = () => {
      stopChatRecording();
    };
    mediaRecorderRef.value = recorder;
    recordingElapsedMs.value = 0;
    recordingStartedAt.value = Date.now();
    isRecordingAudio.value = true;
    recorder.start();
    recordingTimer.value = setInterval(() => {
      const elapsed = Date.now() - recordingStartedAt.value;
      recordingElapsedMs.value = Math.min(elapsed, MAX_CHAT_RECORD_MS);
      if (elapsed >= MAX_CHAT_RECORD_MS) {
        stopChatRecording();
      }
    }, 200);
  } catch (err) {
    console.error('Microphone access failed', err);
    stopMediaStream();
    isRecordingAudio.value = false;
    window.alert('Could not access the microphone.');
  }
};

const toggleChatRecording = () => {
  if (!selectedChat.value) return;
  if (isRecordingAudio.value) stopChatRecording();
  else startChatRecording();
};

const closeChatLightbox = () => {
  if (lightboxIgnoreClick) {
    lightboxIgnoreClick = false;
    return;
  }
  lightboxStepToken += 1;
  lightboxImageUrl.value = '';
  lightboxImages.value = [];
  lightboxIndex.value = 0;
};

const stepChatLightbox = async (direction) => {
  const images = lightboxImages.value;
  if (images.length < 2) return;
  const index = chatLightboxIndex(
    lightboxIndex.value,
    images.length,
    direction,
  );
  lightboxIndex.value = index;
  const img = images[index];
  const token = ++lightboxStepToken;
  if (img && !img.previewUrl && !chatImageSrc(img)) {
    await loadChatImage(img);
  }
  if (token !== lightboxStepToken || lightboxIndex.value !== index) return;
  const url = (img && (img.previewUrl || chatImageSrc(img))) || '';
  if (url) lightboxImageUrl.value = url;
};

const onLightboxTouchStart = (event) => {
  const touch = event.touches && event.touches[0];
  if (!touch) return;
  lightboxTouch = { x: touch.clientX, y: touch.clientY, at: Date.now() };
};

const onLightboxTouchCancel = () => {
  lightboxTouch = null;
};

const onLightboxTouchEnd = (event) => {
  const start = lightboxTouch;
  lightboxTouch = null;
  const touch = event.changedTouches && event.changedTouches[0];
  if (!start || !touch) return;
  const direction = chatLightboxSwipe(
    touch.clientX - start.x,
    touch.clientY - start.y,
    { elapsed: Date.now() - start.at },
  );
  if (!direction || lightboxImages.value.length < 2) return;
  lightboxIgnoreClick = true;
  clearTimeout(lightboxIgnoreTimer);
  lightboxIgnoreTimer = setTimeout(() => {
    lightboxIgnoreClick = false;
  }, 500);
  if (event.cancelable) event.preventDefault();
  stepChatLightbox(direction);
};

const openChatImage = async (img, images) => {
  if (!img) return;
  const supplied = Array.isArray(images) ? images : [];
  const found = supplied.indexOf(img);
  const gallery = found >= 0 ? supplied : [img];
  lightboxImages.value = gallery;
  lightboxIndex.value = found >= 0 ? found : 0;
  if (!img.previewUrl && !chatImageSrc(img)) {
    await loadChatImage(img);
  }
  const url = img.previewUrl || chatImageSrc(img);
  if (url) lightboxImageUrl.value = url;
};

const openGalleryPicker = () => {
  if (!selectedChat.value || !galleryInputRef.value) return;
  galleryInputRef.value.click();
};

const addChatImageFiles = async (files) => {
  for (const file of files) {
    if (pendingChatImages.value.length >= 4) break;
    if (!isLikelyImageFile(file)) continue;
    const prepared = await prepareImageForWorkOrderUpload(file);
    pendingChatImages.value.push({
      localId: `${Date.now()}-${Math.random()}`,
      file: prepared.file,
      isHeic: prepared.isHeic,
      previewUrl: URL.createObjectURL(prepared.file),
    });
  }
};

const rememberUploadedChatImage = (message, index, response) => {
  const saved = response && response.data;
  const slot = message.images && message.images[index];
  if (!saved || !saved.id || !slot) return;
  Object.assign(slot, saved, {
    previewUrl: slot.previewUrl,
    source: saved.source || slot.source,
  });
};

const uploadChatImageForMessage = async (messageId, item, kind) => {
  return uploadFileLikeWorkOrder(item.file, item.isHeic, {
    skipGlobalError: true,
    singleUrl: '/api/chat-images',
    fillSingleForm: (form) => {
      form.append('messageId', String(messageId));
      form.append('kind', kind);
    },
    initUrl: '/api/chat-images/chunked/init',
    initBody: { messageId, kind },
    chunkUrl: '/api/chat-images/chunked/upload',
    finalizeUrl: '/api/chat-images/chunked/finalize',
  });
};

const removePendingChatImage = (localId) => {
  const idx = pendingChatImages.value.findIndex((p) => p.localId === localId);
  if (idx === -1) return;
  URL.revokeObjectURL(pendingChatImages.value[idx].previewUrl);
  pendingChatImages.value.splice(idx, 1);
};

const clearPendingChatImages = () => {
  pendingChatImages.value.forEach((p) => URL.revokeObjectURL(p.previewUrl));
  pendingChatImages.value = [];
};

const onComposerPaste = (event) => {
  const raw = clipboardImageItems(event.clipboardData?.items);
  if (!raw.length) return;
  event.preventDefault();
  const reads = raw.map((file) => readClipboardImage(file));
  Promise.all(reads).then((copied) => {
    const files = copied.filter(Boolean);
    if (!files.length) {
      window.alert('Could not read the pasted image.');
      return;
    }
    addChatImageFiles(files);
  });
};

const onGalleryChange = (event) => {
  const files = Array.from(event.target.files || []);
  event.target.value = '';
  if (files.length) addChatImageFiles(files);
};

const onComposerTab = (event) => {
  const hasText = newMessageOrReply.value.trim().length > 0;
  const hasAttachment =
    pendingChatImages.value.length > 0 || !!pendingChatAudio.value;
  if (!hasText && !hasAttachment) return;
  event.preventDefault();
  addMessageOrReply();
};

const composerClearsOnHold = () => {
  if (isMobile.value) return true;
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
};

let composerHoldTimer = null;
const startComposerHold = () => {
  if (!composerClearsOnHold() || sendingChat.value) return;
  clearTimeout(composerHoldTimer);
  composerHoldTimer = setTimeout(() => {
    composerHoldTimer = null;
    clearComposerDraft();
  }, 600);
};
const cancelComposerHold = () => {
  clearTimeout(composerHoldTimer);
  composerHoldTimer = null;
};
const onComposerContextMenu = (event) => {
  if (composerClearsOnHold()) event.preventDefault();
};
const onComposerInput = (event) => {
  const text = composerDraftText(
    newMessageOrReply.value,
    event && event.target ? event.target.value : '',
  );
  saveInsideChatDraft(localStorage, text);
};

const onComposerKeydown = (event) => {
  if (event.key === 'Tab') {
    onComposerTab(event);
    return;
  }
  if (event.key === 'Escape' && !composerClearsOnHold()) {
    event.preventDefault();
    clearComposerDraft();
  }
};

const fileToDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

watch(conversations, () => scheduleChatMedia());
watch(
  () => selectedChat.value && selectedChat.value.id,
  () => {
    chatMediaPrefetchKey = '';
    if (isRecordingAudio.value) stopChatRecording({ discard: true });
    clearPendingChatImages();
    clearPendingChatAudio();
  },
);

const composerElements = () =>
  document.querySelectorAll('.input-container textarea');

const flushComposerDraft = async () => {
  composerElements().forEach((el) => {
    if (document.activeElement === el) el.blur();
  });
  await nextTick();
  await new Promise((resolve) => setTimeout(resolve, 0));
  let dom = '';
  composerElements().forEach((el) => {
    if (el.value && el.value.length > dom.length) dom = el.value;
  });
  const text = composerDraftText(newMessageOrReply.value, dom);
  newMessageOrReply.value = text;
  return text;
};

const clearComposerDom = () => {
  newMessageOrReply.value = '';
  composerElements().forEach((el) => {
    el.value = '';
  });
};

const clearComposerDraft = async () => {
  await flushComposerDraft();
  clearComposerDom();
  editingMessage.value = null;
};

const beginEditSelectedMessage = () => {
  const selected = selectedMessage.value
    ? editableChatMessage(selectedMessage.value)
    : selectedReply.value
      ? editableChatMessage({
          id: selectedReply.value.id,
          replyMessage: selectedReply.value.replyMessage,
        })
      : null;
  if (!selected) return;
  const source =
    conversations.value.find((row) => String(row.id) === String(selected.id)) ||
    selectedMessage.value;
  editingMessage.value = {
    id: selected.id,
    message: selected.message,
    _tenantMessage: selected.tenant || Boolean(source && source._tenantMessage),
  };
  newMessageOrReply.value = selected.message;
};

const addMessageOrReply = async () => {
  const draft = await flushComposerDraft();
  const claimed = claimInsideChatSend({
    sending: sendingChat.value,
    text: draft,
    hasImages: pendingChatImages.value.length > 0,
    hasAudio: !!pendingChatAudio.value,
  });
  if (!claimed) return;
  sendingChat.value = true;
  await nextTick();
  const textToSend = claimed.text;
  const pendingFiles = claimed.hasImages ? [...pendingChatImages.value] : [];
  const pendingAudio = pendingChatAudio.value;
  const messageBeingEdited = editingMessage.value;
  clearComposerDom();
  pendingChatImages.value = [];
  pendingChatAudio.value = null;

  if (messageBeingEdited) {
    try {
      const id = messageBeingEdited.id;
      if (messageBeingEdited._tenantMessage) {
        await axios.put(`/api/tenant-chat/messages/${id}`, {
          message: textToSend,
        });
      } else {
        await axios.put(`/api/chat-messages/${id}`, { message: textToSend });
      }
      conversations.value = conversations.value.map((row) =>
        String(row.id) === String(id) ? { ...row, message: textToSend } : row,
      );
      if (
        selectedReply.value &&
        String(selectedReply.value.id) === String(id)
      ) {
        selectedReply.value.replyMessage = textToSend;
      }
      editingMessage.value = null;
      selectedMessage.value = null;
      selectedReply.value = null;
    } catch (error) {
      console.error('Error updating message:', error);
      newMessageOrReply.value = textToSend;
      editingMessage.value = messageBeingEdited;
      appendLog(`Message update failed: ${error.message}`);
    } finally {
      sendingChat.value = false;
    }
    return;
  }

  let isReply = false;
  let isReplyTo = null;

  if (selectedMessage.value) {
    isReply = true;
    isReplyTo =
      selectedMessage.value._replyContextSourceId || selectedMessage.value.id;
  } else if (selectedReply.value) {
    isReply = true;
    isReplyTo = selectedReply.value.isReplyTo;
  } else if (conversations.value.length > 0) {
    const lastMessage = conversations.value[conversations.value.length - 1];
    if (lastMessage.isReply) {
      isReply = true;
      isReplyTo = lastMessage.isReplyTo;
    } else {
      isReplyTo = lastMessage.id;
    }
  }

  const newMessage = {
    datetime: new Date().toISOString(),
    message: textToSend,
    isReply,
    fromUserId: currentUser.value.id,
    toUserId: null,
    fromPeopleId: null,
    toPeopleId: null,
    toGroupId: null,
    isReplyTo,
    status: null,
    createdBy: currentUser.value.id,
    // Add a local flag to identify messages added by the current user
    _locallyAdded: true,
  };

  // Determine the recipient based on the selected chat type
  if (selectedChat.value.groupId) {
    // For group chat
    newMessage.toGroupId = selectedChat.value.groupId;
  } else if (selectedChat.value.personId) {
    // For chat with a tenant
    newMessage.toPeopleId = selectedChat.value.personId;
  } else if (selectedChat.value.userId) {
    // For chat with another employee
    newMessage.toUserId = selectedChat.value.userId;
  }

  let postedMessageId = null;
  let imagesUploaded = 0;
  let placedLocally = false;
  const isTenantChat = !!(
    selectedChat.value.personId &&
    !selectedChat.value.userId &&
    !selectedChat.value.groupId
  );
  const chatOutboundItem = () =>
    insideChatOutboundItem({
      text: textToSend,
      isReply,
      isReplyTo,
      fromUserId: currentUser.value.id,
      toUserId: newMessage.toUserId,
      toPeopleId: newMessage.toPeopleId,
      toGroupId: newMessage.toGroupId,
      conversationId: selectedChat.value._tenantConversationId,
      peopleId: selectedChat.value.personId,
      isTenant: isTenantChat,
      datetime: newMessage.datetime,
      audio: claimed.hasAudio && pendingAudio ? pendingAudio.blob : null,
      audioMime: pendingAudio ? pendingAudio.mimeType : '',
      images: pendingFiles.map((item) => ({
        blob: item.file,
        name: item.file && item.file.name,
        type: item.file && item.file.type,
        isHeic: item.isHeic,
      })),
      messageId: postedMessageId,
      imageIndex: imagesUploaded,
    });

  try {
    if (readNavigatorOnline() === false) {
      await deliverOrQueue({ online: false, item: chatOutboundItem() });
      appendLog(OUTBOUND_HOLD_TEXT);
      return;
    }

    // For tenant chats, resolve the tenant conversation id if we don't already
    // have it. This handles the case where a chat head was opened without
    // going through loadTenantConversations / the bulk conversation sync
    // (e.g., a personId-only chat loaded from IndexedDB).
    const imageSource = isTenantChat ? 'tenant' : 'staff';

    const audiosPayload = [];
    if (claimed.hasAudio && pendingAudio) {
      audiosPayload.push({
        mimeType: pendingAudio.mimeType || 'audio/ogg',
        data: await fileToDataUrl(pendingAudio.blob),
      });
    }
    newMessage.images = pendingFiles.map((item) => ({
      previewUrl: item.previewUrl,
      source: imageSource,
    }));
    newMessage.audios = pendingAudio
      ? [
          {
            previewUrl: pendingAudio.previewUrl,
            source: imageSource,
          },
        ]
      : [];

    if (isTenantChat) {
      const response = await axios.post(
        '/api/tenant-chat/messages',
        {
          conversationId: selectedChat.value._tenantConversationId,
          peopleId: selectedChat.value.personId,
          message: textToSend,
          audios: audiosPayload,
          attachPhotos: pendingFiles.length > 0,
        },
        { skipGlobalError: true },
      );

      const serverMsg = response.data?.message;
      if (serverMsg) {
        newMessage.id = serverMsg.id;
        postedMessageId = newMessage.id;
        addToRecentMessageIds(newMessage.id);
        for (let i = 0; i < pendingFiles.length; i += 1) {
          const uploaded = await uploadChatImageForMessage(
            serverMsg.id,
            pendingFiles[i],
            'tenant',
          );
          imagesUploaded += 1;
          rememberUploadedChatImage(newMessage, i, uploaded);
        }
        if (serverMsg.images && serverMsg.images.length) {
          newMessage.images = serverMsg.images.map((img, idx) => ({
            ...img,
            source: 'tenant',
            previewUrl: newMessage.images[idx]?.previewUrl,
          }));
        }
        if (serverMsg.audios && serverMsg.audios.length) {
          newMessage.audios = serverMsg.audios.map((clip, idx) => ({
            ...clip,
            source: 'tenant',
            previewUrl: newMessage.audios[idx]?.previewUrl,
          }));
        }
        newMessage._tenantMessage = true;
        if (serverMsg.conversationId) {
          selectedChat.value._tenantConversationId = serverMsg.conversationId;
        }
        for (const media of [
          ...(newMessage.images || []),
          ...(newMessage.audios || []),
        ]) {
          cacheChatMediaFromPreview(media);
        }
        loadImagesForMessages([newMessage]);
      }
    } else {
      const response = await axios.post(
        '/api/chat-messages',
        {
          ...newMessage,
          images: [],
          audios: audiosPayload,
          attachPhotos: pendingFiles.length > 0,
        },
        { skipGlobalError: true },
      );

      if (response.data && response.data.data && response.data.data.id) {
        newMessage.id = response.data.data.id;
        postedMessageId = newMessage.id;
        addToRecentMessageIds(newMessage.id);
        for (let i = 0; i < pendingFiles.length; i += 1) {
          const uploaded = await uploadChatImageForMessage(
            newMessage.id,
            pendingFiles[i],
            'staff',
          );
          imagesUploaded += 1;
          rememberUploadedChatImage(newMessage, i, uploaded);
        }
        if (response.data.data.images && response.data.data.images.length) {
          newMessage.images = response.data.data.images.map((img, idx) => ({
            ...img,
            source: 'staff',
            previewUrl: newMessage.images[idx]?.previewUrl,
          }));
        }
        if (response.data.data.audios && response.data.data.audios.length) {
          newMessage.audios = response.data.data.audios.map((clip, idx) => ({
            ...clip,
            source: 'staff',
            previewUrl: newMessage.audios[idx]?.previewUrl,
          }));
        }
        for (const media of [
          ...(newMessage.images || []),
          ...(newMessage.audios || []),
        ]) {
          cacheChatMediaFromPreview(media);
        }
        loadImagesForMessages([newMessage]);
      }
    }

    conversations.value = placeSentChatMessage(conversations.value, newMessage);
    placedLocally = true;

    await nextTick();
    const lastMessage = document.querySelector(
      '.conversation-panel .message:last-child',
    );
    if (lastMessage) {
      lastMessage.scrollIntoView({ behavior: 'smooth' });
    }

    const textarea = document.querySelector('textarea');
    if (textarea) {
      textarea.focus();
    }
  } catch (error) {
    if (isNetworkSendFailure(error)) {
      await deliverOrQueue({ online: false, item: chatOutboundItem() });
      if (postedMessageId && !placedLocally) {
        conversations.value = placeSentChatMessage(
          conversations.value,
          newMessage,
        );
      }
      appendLog(OUTBOUND_HOLD_TEXT);
      return;
    }
    console.error('Error saving message:', error);
    newMessageOrReply.value = textToSend;
    pendingChatImages.value = pendingFiles;
    pendingChatAudio.value = pendingAudio;
    const data = error.response && error.response.data;
    const detail =
      (data && (data.error || data.message)) ||
      error.message ||
      'Unknown error';
    window.alert(`Could not send the photo: ${detail}`);
  } finally {
    sendingChat.value = false;
  }
};

const formatTimestamp = (datetime) => {
  const date = new Date(datetime);
  return date.toLocaleString();
};

const shouldShowTimestamp = (replies, index) => {
  if (index === 0) return true;
  const prevReply = replies[index - 1];
  const currentReply = replies[index];
  const prevDate = new Date(prevReply.datetime);
  const currentDate = new Date(currentReply.datetime);
  return currentDate - prevDate >= 60000; // Show timestamp if more than 1 minute has passed
};

const showAddChatPopup = async () => {
  showPopup.value = !showPopup.value;
  await nextTick();
  /*
  const popup = document.querySelector('.popup');
  const panel = document.querySelector('#insideChatPanel');
  if (popup && panel) {
    const panelRect = panel.getBoundingClientRect();
    popup.style.top = `${panelRect.top + panelRect.height / 4 - popup.offsetHeight / 2}px`;
    popup.style.left = `${panelRect.left + panelRect.width / 2 - popup.offsetWidth / 2}px`;
  }
    */
};

watch(
  () => showPopup.value,
  async (newVal) => {
    if (newVal) {
      await nextTick();
      const input = document.querySelector('.popup input');
      if (input) {
        input.focus();
      }
      searchResults.value = [];
      searchQuery.value = '';
    }
  },
);

const chatUsers = ref([]);

const searchUsersAndTenants = () => {
  if (!searchQuery.value.trim()) {
    searchResults.value = [];
    return;
  }
  const query = searchQuery.value.toLowerCase();
  searchResults.value = chatUsers.value
    .filter(
      (user) =>
        (user.displayName && user.displayName.toLowerCase().includes(query)) ||
        (user.fullName && user.fullName.toLowerCase().includes(query)),
    )
    .slice(0, 5);
};

const goHome = () => {
  // SPA navigation only — window.location can leave iOS standalone PWA for Safari
  router.push('/mhome');
};

const copyShareUrl = async (url) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(url);
      return true;
    } catch {
      /* textarea fallback */
    }
  }
  const textArea = document.createElement('textarea');
  textArea.value = url;
  textArea.style.position = 'fixed';
  textArea.style.left = '-999999px';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  let ok = false;
  try {
    ok = document.execCommand('copy');
  } catch {
    ok = false;
  } finally {
    document.body.removeChild(textArea);
  }
  return ok;
};

const shareSelectedChat = async () => {
  const url = insideChatShareUrl(selectedChat.value);
  if (!url) return;
  const ok = await copyShareUrl(url);
  shareNote.value = ok ? 'Copied' : 'Copy failed';
  clearTimeout(shareNoteTimer);
  shareNoteTimer = setTimeout(() => {
    shareNote.value = '';
  }, 1600);
};

const openChatFromRoute = async () => {
  if (route.name !== 'ichat') return;
  const target = insideChatShareTargetFromQuery(route.query);
  if (!target) return;
  let opened = false;
  const existing = findChatForShareTarget(activeChats.value, target);
  if (existing) {
    await selectChat(existing);
    opened = true;
  } else if (target.kind === 'group') {
    const group = (groups.value || []).find((row) =>
      sameShareId(row && row.id, target.groupId),
    );
    if (group) {
      await selectGroupChat({
        id: group.id,
        name: group.name,
        groupId: group.id,
        groupName: group.name,
      });
      opened = true;
    }
  } else if (target.kind === 'system') {
    const chat = await ensureSystemChatHead();
    if (chat) {
      await selectChat(chat);
      opened = true;
    }
  } else {
    const user = (chatUsers.value || []).find((row) => {
      if (
        target.personId != null &&
        !sameShareId(row.peopleId ?? row.personId, target.personId)
      ) {
        return false;
      }
      if (target.userId != null && !sameShareId(row.userId, target.userId)) {
        return false;
      }
      return target.personId != null || target.userId != null;
    });
    if (user) {
      await startChat(user);
      opened = true;
    } else {
      const stub = {
        id: generateUniqueId(),
        initials: '',
        displayName: '',
        fullName: '',
        personId: target.personId,
        userId: target.userId,
        groupId: null,
        groupName: null,
        unreadCount: 0,
        lastMessageId: 0,
        lastViewedMessageId: 0,
      };
      activeChats.value.unshift(stub);
      try {
        await chatDB.add('chats', JSON.parse(JSON.stringify(stub)));
      } catch {
        /* select still opens the thread */
      }
      await selectChat(stub);
      opened = true;
    }
  }
  if (opened) await scrollToRouteMessage();
};

function sameShareId(left, right) {
  if (left == null || left === '' || right == null || right === '') return false;
  const a = Number(left);
  const b = Number(right);
  return Number.isFinite(a) && a === b;
}

const debouncedSearch = debounce(searchUsersAndTenants, 300);

const userInitials = (message) => {
  let initials = '';
  if (message.fromUserId == null) return '';

  // If the message is from the current user
  if (message.fromUserId === currentUser.value.id) {
    initials = 'Me';
  } else {
    // Find the user who sent the message
    const user = chatUsers.value.find(
      (user) => user.userId === message.fromUserId,
    );
    if (user) {
      if (user.displayName && typeof user.displayName === 'string') {
        // Get initials from display name
        initials = user.displayName
          .split(' ')
          .map((n) => n[0])
          .join('');
      }
    }
  }

  if (initials !== '') {
    return ' (' + initials + ')';
  } else return '';
};

const timestampSourceLabel = (message) =>
  chatTimestampSourceLabel(selectedChat.value, userInitials(message));

const loadChatUsers = async () => {
  try {
    const response = await axios.get('/api/get-users-tenants');
    chatUsers.value = response.data;
  } catch (error) {
    console.error('Error fetching chat users:', error);
  }
};

const loadCurrentUser = async () => {
  try {
    const response = await axios.get('/api/users');
    currentUser.value = response.data.find((user) => user.you === 1);
  } catch (error) {
    console.error('Error fetching current user:', error);
  }
};

const loadConversations = async (peopleId, userId, showRead) => {
  const hasPeople = peopleId != null && peopleId !== '';
  const hasUser = userId != null && userId !== '';
  if (!hasPeople && !hasUser) return;

  loading.value = true;
  try {
    const params = {
      peopleId,
      userId,
      showRead,
    };

    // Add limit parameter for pagination
    if (paginationCount.value > 1) {
      params.limit = paginationCount.value * 100;
    }

    appendLog(
      `API Request: GET /api/chat-messages with params: ${JSON.stringify(params)}`,
    );

    const response = await axios.get('/api/chat-messages', { params });

    // Debugging information about the response
    const receivedMessageCount = response.data.length;
    const firstId = response.data[0]?.id || 'none';
    const lastId = response.data[receivedMessageCount - 1]?.id || 'none';

    appendLog(`API Response: Received ${receivedMessageCount} messages`);
    appendLog(`Message ID range: ${firstId} to ${lastId}`);

    if (paginationCount.value > 1) {
      appendLog(
        `Expected at least ${paginationCount.value * 100} messages for pagination=${paginationCount.value}`,
      );

      if (receivedMessageCount < 100) {
        appendLog(
          `WARNING: Received fewer messages (${receivedMessageCount}) than the default page size (100)`,
        );
      } else if (receivedMessageCount === conversations.value.length) {
        appendLog(
          'WARNING: No new messages received despite pagination increase!',
        );
      }
    }

    conversations.value = response.data;
  } catch (error) {
    console.error('Error fetching conversations:', error);
    appendLog(`Error fetching conversations: ${error.message}`);
  } finally {
    loading.value = false;
  }
};

const loadTenantConversations = async (conversationId) => {
  loading.value = true;
  try {
    appendLog(`Loading tenant messages for conversationId: ${conversationId}`);
    const response = await axios.get('/api/tenant-chat/messages', {
      params: { conversationId },
    });
    const tenantMessages = response.data.messages || [];

    // Transform to the format InsideChatTool expects
    tenantResolvedMessageId.value = response.data.resolvedMessageId || null;
    tenantResolvedExpanded.value = false;
    resolvePromptHiddenFor.value = null;
    conversations.value = tenantMessages.map((m) => ({
      id: m.id,
      message: m.message,
      datetime: m.createdAt,
      fromUserId: m.senderUserId,
      fromPeopleId: m.senderPeopleId,
      toUserId: m.senderType === 'tenant' ? null : null,
      toPeopleId: m.senderType === 'staff' ? null : null,
      fromDisplayName: m.staffName || null,
      fullName:
        m.tenantFirst && m.tenantLast
          ? `${m.tenantFirst} ${m.tenantLast}`
          : null,
      viewedBy: m.viewedBy || null,
      tenantViewedAt: m.tenantViewedAt || null,
      images: m.images || [],
      audios: m.audios || [],
      reactions: m.reactions || [],
      _tenantMessage: true,
    }));
    loadImagesForMessages(conversations.value);

    appendLog(`Loaded ${conversations.value.length} tenant messages`);
  } catch (error) {
    console.error('Error fetching tenant conversations:', error);
    appendLog(`Error fetching tenant conversations: ${error.message}`);
  } finally {
    loading.value = false;
  }
};

const hideSelectedChat = async () => {
  if (selectedChat.value) {
    activeChats.value = activeChats.value.filter(
      (chat) => chat.id !== selectedChat.value.id,
    );

    // Update activeChats in IndexedDB
    await chatDB.delete('chats', selectedChat.value.id); // Delete individual chat
    await markMessagesAsRead(); // Mark messages as read
    selectedChat.value = null;
  }
};

const broomPhase = ref(0);

const broomTitle = computed(() =>
  broomPhase.value === 0
    ? 'remove chat heads\nwith no unread badge'
    : 'mark tenant and staff chats read',
);

const onBroomClick = async () => {
  if (broomPhase.value === 0) {
    await cleanupStaleChatHeads();
    broomPhase.value = activeChats.value.some(
      (chat) => Number(chat.unreadCount) > 0 && isSweepableInsideChat(chat),
    )
      ? 1
      : 0;
    return;
  }
  await markAllConversationsRead({ sweepableOnly: true });
  broomPhase.value = 0;
};

const catchUpUnreadChats = async () => {
  await markAllConversationsRead();
  broomPhase.value = 0;
};

const markAllConversationsRead = async (options = {}) => {
  const unreadChats = activeChats.value.filter((chat) => {
    if (!(Number(chat.unreadCount) > 0)) return false;
    if (options.sweepableOnly && !isSweepableInsideChat(chat)) return false;
    return true;
  });
  if (unreadChats.length === 0) {
    appendLog('Catch up: no unread conversations');
    return;
  }

  let marked = 0;
  for (const chat of unreadChats) {
    try {
      if (chat._tenantConversationId) {
        await axios.post('/api/tenant-chat/mark-read', {
          conversationId: chat._tenantConversationId,
        });
        if (chat.personId != null) {
          await axios.post('/api/mark-chat-conversation-read', {
            peopleId: chat.personId,
          });
        }
      } else if (chat.groupId != null) {
        await axios.post('/api/mark-chat-conversation-read', {
          groupId: chat.groupId,
        });
      } else if (chat.userId != null) {
        await axios.post('/api/mark-chat-conversation-read', {
          userId: chat.userId,
        });
      } else if (chat.personId != null) {
        await axios.post('/api/mark-chat-conversation-read', {
          peopleId: chat.personId,
        });
      } else {
        appendLog(`Catch up: skipped chat ${chat.id} (no identifiers)`);
        continue;
      }
      clearChatUnread(chat);
      await updateChatInIndexedDB(chat);
      marked += 1;
    } catch (error) {
      appendLog(
        `Catch up: failed for ${chat.id}: ${error.message}`,
      );
    }
  }

  if (
    selectedChat.value &&
    unreadChats.some((c) => c.id === selectedChat.value.id)
  ) {
    const me = Number(myId.value);
    if (Array.isArray(conversations.value)) {
      conversations.value.forEach((message) => {
        const from =
          message.fromUserId == null ? null : Number(message.fromUserId);
        const unread =
          message.status == null ||
          message.status === 0 ||
          message.status === '0';
        if (unread && from !== me) {
          message.status = 1;
        }
      });
    }
  }

  appendLog(`Catch up: cleared ${marked} conversation(s)`);
};

const cleanupStaleChatHeads = async () => {
  if (!chatDB) {
    return;
  }

  const staleChats = activeChats.value.filter(
    (chat) => !(Number(chat.unreadCount) > 0) && isSweepableInsideChat(chat),
  );

  if (staleChats.length === 0) {
    appendLog('Cleanup: no stale chat heads to remove');
    return;
  }

  const staleIds = new Set(staleChats.map((chat) => chat.id));

  if (selectedChat.value && staleIds.has(selectedChat.value.id)) {
    selectedChat.value = null;
    conversations.value = [];
  }

  activeChats.value = activeChats.value.filter(
    (chat) => Number(chat.unreadCount) > 0 || !isSweepableInsideChat(chat),
  );

  for (const chat of staleChats) {
    try {
      await chatDB.delete('chats', chat.id);
    } catch (error) {
      appendLog(
        `Cleanup: failed to delete chat ${chat.id} from IndexedDB: ${error.message}`,
      );
    }
  }

  appendLog(
    `Cleanup: removed ${staleChats.length} stale chat head(s) with no unread badge`,
  );
};

const startChat = async (result) => {
  // Check if a chat with the same peopleId or userId already exists
  const existingChat = activeChats.value.find(
    (chat) =>
      (chat.personId && chat.personId === result.peopleId) ||
      (chat.userId !== null && chat.userId === result.userId) ||
      (chat.userId === 0 && result.userId === 0), // Add specific check for System messages with userId = 0
  );

  if (existingChat) {
    if (
      Object.prototype.hasOwnProperty.call(result, 'pixieNotifications')
    ) {
      existingChat.pixieNotifications = result.pixieNotifications;
    }
    await selectChat(existingChat);
  } else {
    // Logic to start a new chat with the selected user or tenant
    // if result contains displayName and userId, then use these instead of result.fromDisplayName
    const newChat = {
      id: generateUniqueId(),
      initials: (() => {
        if (result.displayName && typeof result.displayName === 'string') {
          return result.displayName
            .split(' ')
            .map((n) => n[0])
            .join('');
        } else if (result.fullName && typeof result.fullName === 'string') {
          return result.fullName
            .split(' ')
            .map((n) => n[0])
            .join('');
        } else if (result.groupId) {
          // For group chats, use the group ID directly (start with 1)
          return 'G' + (result.groupId || '1');
        } else if (result.userId) {
          // For user chats without a name
          return 'U' + result.userId.toString().substring(0, 2);
        } else if (result.personId) {
          // For person chats without a name
          return 'P' + result.personId.toString().substring(0, 2);
        }
        // Default initials if nothing else available
        return 'UC'; // UC for "Unknown Contact"
      })(),
      displayName: result.displayName || '',
      fullName: result.fullName || '',
      personId: result.peopleId,
      propertyAddress:
        formatLeaseProperty(result) ||
        (result.peopleId != null
          ? tenantPropertyByPeopleId.value[Number(result.peopleId)]
          : '') ||
        '',
      userId: result.userId,
      unreadCount: 0,
      lastMessageId: 0, // Initialize last message ID
      lastViewedMessageId: 0, // Initialize last viewed message ID
      pixieNotifications: result.pixieNotifications,
    };

    if (
      newChat.personId !== null ||
      newChat.userId !== null ||
      newChat.fullName !== '' ||
      newChat.displayName !== ''
    ) {
      activeChats.value.unshift(newChat);
      selectedChat.value = newChat;
      // Save individual chat to IndexedDB
      console.log('newChat', newChat);

      try {
        await chatDB.add('chats', JSON.parse(JSON.stringify(newChat))); // Ensure the object is serializable
      } catch (error) {
        if (error.message === 'Key already exists in the object store.') {
          console.log('Error: Key already exists in the object store.');
        } else {
          // Optionally handle other errors here or allow them to be thrown
          throw error;
        }
      }

      await loadConversations(newChat.personId, newChat.userId, showRead.value);
      await nextTick();
      scrollToBottom(); // Explicitly scroll to bottom after loading conversations
      showPopup.value = false;
    }
  }
};

const loadActiveChats = async () => {
  try {
    // First load chats from IndexedDB
    let storedChats = await chatDB.getAll('chats');
    console.log('Loaded chats from IndexedDB:', storedChats);

    // Log the chats to debug panel
    appendLog(`Loading chats from IndexedDB: ${storedChats.length} found`);

    // Initialize activeChats with stored chats from IndexedDB
    activeChats.value = [];

    // Store unique identifiers to track what we've already added
    const addedUserIds = new Set();
    const addedPersonIds = new Set();
    const addedGroupIds = new Set();

    // Track the number of groups to assign sequential group numbers
    let groupCounter = 1;

    // Process stored chats first
    if (storedChats && storedChats.length > 0) {
      for (const chat of storedChats) {
        if (isSystemChatHead(chat)) {
          if (
            !canAccessSystemChat(currentUser.value && currentUser.value.role)
          ) {
            continue;
          }
          // System chat - only add if we haven't added it yet
          if (!addedUserIds.has(0)) {
            chat.initials = 'Sys';
            chat.displayName = chat.displayName || 'System';
            chat.fullName = chat.fullName || 'System';
            chat.userId = 0;
            chat.personId = null;
            chat.groupId = null;
            chat._tenantConversationId = null;
            activeChats.value.push(chat);
            addedUserIds.add(0);
          }
        } else if (chat.groupId) {
          // Group chat - only add if we haven't added this group yet
          if (!addedGroupIds.has(chat.groupId)) {
            // Restore G1, G2 naming scheme for initials
            chat.initials = 'G' + groupCounter;
            activeChats.value.push(chat);
            addedGroupIds.add(chat.groupId);
            groupCounter++;
          }
        } else if (chat.userId) {
          // User chat - only add if we haven't added this user yet
          if (!addedUserIds.has(chat.userId)) {
            activeChats.value.push(chat);
            addedUserIds.add(chat.userId);
          }
        } else if (chat.personId) {
          // Person chat - only add if we haven't added this person yet
          if (!addedPersonIds.has(chat.personId)) {
            activeChats.value.push(chat);
            addedPersonIds.add(chat.personId);
          }
        } else {
          // Unknown chat type, add it anyway
          activeChats.value.push(chat);
        }
      }
    }

    // Then fetch initial chats from the server
    const response = await axios.get('/api/initial-chats', {});
    appendLog(`Fetched ${response.data.length} initial chats from server`);

    response.data.forEach((result) => {
      // Check if this chat already exists in our tracking sets
      const alreadyHasUser =
        result.userId !== null && addedUserIds.has(result.userId);
      const alreadyHasPerson =
        result.personId !== null && addedPersonIds.has(result.personId);
      const alreadyHasGroup =
        result.groupId !== null && addedGroupIds.has(result.groupId);

      if (alreadyHasPerson && (result.peopleId ?? result.personId)) {
        const pid = Number(result.peopleId ?? result.personId);
        const existing = activeChats.value.find(
          (c) => Number(c.personId) === pid,
        );
        if (existing) {
          applyLeaseRowToChat(existing, {
            ...result,
            peopleId: pid,
          });
        }
      }

      if (!alreadyHasUser && !alreadyHasPerson && !alreadyHasGroup) {
        // Only add if not already tracked
        const newChat = {
          id: generateUniqueId(),
          initials: (() => {
            // Restore G1, G2 naming scheme for group initials
            if (result.groupId) {
              return 'G' + groupCounter.toString();
            } else if (
              result.displayName &&
              typeof result.displayName === 'string'
            ) {
              return result.displayName
                .split(' ')
                .map((n) => n[0])
                .join('');
            } else if (result.fullName && typeof result.fullName === 'string') {
              return result.fullName
                .split(' ')
                .map((n) => n[0])
                .join('');
            } else if (result.userId) {
              return 'U' + result.userId.toString().substring(0, 2);
            } else if (result.personId) {
              return 'P' + result.personId.toString().substring(0, 2);
            }
            return 'UC'; // UC for "Unknown Contact"
          })(),
          displayName: result.displayName || '',
          fullName: result.fullName || '',
          personId: result.peopleId ?? result.personId ?? null,
          propertyAddress:
            formatLeaseProperty(result) ||
            ((result.peopleId ?? result.personId) != null
              ? tenantPropertyByPeopleId.value[
                  Number(result.peopleId ?? result.personId)
                ]
              : '') ||
            '',
          userId: result.userId,
          groupId: result.groupId,
          groupName: result.groupName,
          unreadCount: 0,
          lastMessageId: 0, // Add tracking for last message ID
        };

        // If this is a group, increment the counter
        if (result.groupId) {
          groupCounter++;
        }

        if (
          isSystemChatHead(newChat) &&
          !canAccessSystemChat(currentUser.value && currentUser.value.role)
        ) {
          return;
        }

        activeChats.value.push(newChat);

        // Track what we've added
        if (result.userId !== null) addedUserIds.add(result.userId);
        if (newChat.personId !== null && newChat.personId !== undefined)
          addedPersonIds.add(newChat.personId);
        if (result.groupId !== null) addedGroupIds.add(result.groupId);
      }
    });

    // Also fetch current groups from the server
    try {
      const groupResponse = await axios.get('/api/chat-groups');
      const serverGroups = groupResponse.data;

      appendLog(`Fetched ${serverGroups.length} groups from server`);

      // Check for any new groups that aren't already in our tracking
      for (const group of serverGroups) {
        const existing = activeChats.value.find(
          (c) => Number(c.groupId) === Number(group.id),
        );
        if (existing) {
          applyGroupMeta(existing, group);
          try {
            await updateChatInIndexedDB(existing);
          } catch {
            /* ignore */
          }
          continue;
        }
        if (!addedGroupIds.has(group.id)) {
          // Create a new group chat object
          const newGroupChat = {
            id: generateUniqueId(),
            // Restore G1, G2 naming scheme for group initials
            initials: 'G' + groupCounter.toString(),
            displayName: '', // Groups don't have a display name in this context
            fullName: '', // Groups don't have a full name
            personId: null,
            userId: null,
            groupId: group.id,
            groupName: group.name,
            memberNames: parseGroupMemberNames(group.memberNames),
            unreadCount: 0,
            lastMessageId: 0,
          };

          activeChats.value.push(newGroupChat);
          addedGroupIds.add(group.id);
          groupCounter++; // Increment counter for the new group
        }
      }
    } catch (error) {
      console.error('Error fetching groups:', error);
      appendLog(`Error fetching groups: ${error.message}`);
    }

    // Fetch tenant conversations with unread messages
    try {
      const tenantResponse = await axios.get('/api/tenant-chat/conversations');
      const tenantConversations = tenantResponse.data || [];
      appendLog(
        `Fetched ${tenantConversations.length} tenant conversations from server`,
      );

      for (const tc of tenantConversations) {
        if (!tc.peopleId) continue;

        // If this person already exists (from IndexedDB or initial-chats),
        // update their unread count and tenant conversation ID
        if (addedPersonIds.has(tc.peopleId)) {
          const existing = activeChats.value.find(
            (c) => Number(c.personId) === Number(tc.peopleId),
          );
          if (existing) {
            existing._tenantConversationId = tc.id;
            const leaseProperty = formatLeaseProperty(tc);
            if (leaseProperty) {
              existing.propertyAddress = leaseProperty;
              tenantPropertyByPeopleId.value[Number(tc.peopleId)] =
                leaseProperty;
            }
            // Use the higher of existing (from socket events) or server count to avoid double-counting
            existing.unreadCount = Math.max(
              existing.unreadCount || 0,
              tc.unreadCount || 0,
            );
            existing.emergencyUnread = Math.max(
              Number(existing.emergencyUnread) || 0,
              Number(tc.emergencyUnread) || 0,
            );
            existing.pixieNotifications = tc.pixieNotifications;
            // Pre-populate recentMessageIds so socket events won't double-count
            if (tc.latestTenantMessageId) {
              addToRecentMessageIds(`tenant_${tc.latestTenantMessageId}`);
            }
            appendLog(
              `Updated existing chat head for peopleId=${tc.peopleId}: unread=${existing.unreadCount}, tenantConvId=${tc.id}`,
            );
          }
          continue;
        }

        // Only create a new chat head if there are unread tenant messages
        if (!tc.unreadCount) continue;

        const name =
          tc.tenantName ||
          `${tc.tenantFirst || ''} ${tc.tenantLast || ''}`.trim() ||
          'Unknown Tenant';
        const initials = name
          .split(' ')
          .map((n) => n[0])
          .join('');

        const leaseProperty = formatLeaseProperty(tc);
        if (leaseProperty) {
          tenantPropertyByPeopleId.value[Number(tc.peopleId)] = leaseProperty;
        }
        const newChat = {
          id: generateUniqueId(),
          initials: initials || 'T',
          displayName: name,
          fullName: name,
          personId: tc.peopleId,
          userId: null,
          groupId: null,
          groupName: null,
          unreadCount: tc.unreadCount || 0,
          emergencyUnread: Number(tc.emergencyUnread) || 0,
          lastMessageId: 0,
          _tenantConversationId: tc.id,
          propertyAddress: leaseProperty || '',
          pixieNotifications: tc.pixieNotifications,
        };

        activeChats.value.push(newChat);
        addedPersonIds.add(tc.peopleId);

        // Pre-populate recentMessageIds so socket events won't double-count
        if (tc.latestTenantMessageId) {
          addToRecentMessageIds(`tenant_${tc.latestTenantMessageId}`);
        }

        appendLog(
          `Added tenant chat head: ${name} (peopleId=${tc.peopleId}, unread=${tc.unreadCount})`,
        );
      }
    } catch (error) {
      console.error('Error fetching tenant conversations:', error);
      appendLog(`Error fetching tenant conversations: ${error.message}`);
    }

    const personIdsNeedingLease = [
      ...new Set(
        activeChats.value
          .filter((c) => c.personId)
          .map((c) => Number(c.personId)),
      ),
    ];
    if (personIdsNeedingLease.length) {
      try {
        const leaseResp = await axios.get('/api/people-current-leases', {
          params: { ids: personIdsNeedingLease.join(',') },
        });
        for (const row of leaseResp.data || []) {
          const existing = activeChats.value.find(
            (c) => Number(c.personId) === Number(row.peopleId),
          );
          if (existing) {
            applyLeaseRowToChat(existing, row);
            try {
              await updateChatInIndexedDB(existing);
            } catch {
              /* ignore */
            }
          }
        }
      } catch (error) {
        appendLog(`Error hydrating current leases: ${error.message}`);
      }
    }

    // Always fetch latest ids so a System head can appear even with zero
    // stored chats (system unreads are computed independently of chatIds).
    const chatIdsToCheck = activeChats.value.map((chat) => {
      return {
        userId: chat.userId,
        personId: chat.personId,
        groupId: chat.groupId,
      };
    });

    try {
      appendLog(
        `Checking for new messages via latest-message-ids API: ${chatIdsToCheck.length} chats to check`,
      );

      const latestResponse = await axios.get('/api/latest-message-ids', {
        params: {
          chatIds: JSON.stringify(chatIdsToCheck),
        },
      });

      const { latestIds, unreadCounts } = latestResponse.data;

      appendLog(
        `Got latest message IDs response: ${Object.keys(latestIds).length} IDs, ${Object.keys(unreadCounts).length} unread counts`,
      );

      // Ensure System head exists when server reports user_0 unreads
      if (
        (Number(unreadCounts.user_0) || 0) > 0 ||
        latestIds.user_0 != null
      ) {
        await ensureSystemChatHead();
      }

      // Update each chat with latest message ID and unread count.
      // Staff unread comes from chat_messages; tenant heads may already
      // have tenant_messages unread — sum those rather than overwrite.
      for (const chat of activeChats.value) {
        const chatIdentifier = chat.groupId
          ? `group_${chat.groupId}`
          : chat.personId
            ? `person_${chat.personId}`
            : `user_${chat.userId}`;

        if (latestIds[chatIdentifier] !== undefined) {
          chat.lastMessageId = latestIds[chatIdentifier];
          addToRecentMessageIds(latestIds[chatIdentifier]);
        }
        if (unreadCounts[chatIdentifier] !== undefined) {
          const staffUnread = Number(unreadCounts[chatIdentifier]) || 0;
          if (chat._tenantConversationId != null) {
            chat.unreadCount =
              (Number(chat.unreadCount) || 0) + staffUnread;
          } else {
            chat.unreadCount = staffUnread;
          }
        }
      }
    } catch (error) {
      console.error('Error fetching latest message IDs:', error);
      appendLog(`Error checking for new messages: ${error.message}`);
    }

    console.log('Final activeChats:', activeChats.value);

    // Log the final activeChats JSON to the debug panel
    appendLog(
      `Final activeChats: ${JSON.stringify(activeChats.value, null, 2)}`,
    );

    // Clear and repopulate IndexedDB to ensure consistency
    await chatDB.clear('chats');

    for (const chat of activeChats.value) {
      try {
        // Use put instead of add to overwrite any existing entries with the same ID
        await chatDB.put('chats', JSON.parse(JSON.stringify(chat)));
      } catch (addError) {
        console.error('Failed to add chat:', chat, 'Error:', addError);
        appendLog(`Failed to add chat: ${chat.id}, Error: ${addError.message}`);
      }
    }

    // Sort chats by unread count
    activeChats.value.sort(
      (a, b) => (b.unreadCount || 0) - (a.unreadCount || 0),
    );
  } catch (error) {
    console.error('Error in loadActiveChats:', error);
    appendLog(`Error loading active chats: ${error.message}`);
  }
};

const filterConversations = () =>
  filterChatMessages(selectedConversation.value, conversationQuery.value);

// Use debounce to limit filtering
const filteredConversations = computed(() => {
  return filterConversations();
});

const tenantChatOpen = computed(() => {
  const chat = selectedChat.value;
  if (!chat || chat.groupId) return false;
  return !!(chat._tenantConversationId || isTenantChatHead(chat));
});

const tenantResolveLastId = computed(() =>
  tenantChatOpen.value ? lastTenantMessageId(conversations.value) : null,
);

const tenantIssueResolved = computed(() =>
  isTenantIssueResolved(
    tenantResolveLastId.value,
    tenantResolvedMessageId.value,
  ),
);

const showTenantResolvePrompt = computed(
  () =>
    tenantChatOpen.value &&
    tenantResolveLastId.value != null &&
    !tenantIssueResolved.value &&
    resolvePromptHiddenFor.value !== tenantResolveLastId.value,
);

const displayedConversations = computed(() => {
  const rows = orderReplyThreadsToLatest(filteredConversations.value);
  if (!tenantChatOpen.value || tenantResolvedMessageId.value == null) return rows;
  return visibleTenantMessages(rows, {
    resolvedMessageId: tenantResolvedMessageId.value,
    expanded: tenantResolvedExpanded.value,
  });
});

const systemDateCollapsed = ref(defaultSystemDateCollapsed());

const conversationPanelRows = computed(() =>
  conversationPanelRowsFor(
    selectedChat.value,
    displayedConversations.value,
    systemDateCollapsed.value,
    new Date(),
  ),
);

function toggleSystemDateGroup(key) {
  systemDateCollapsed.value = {
    ...systemDateCollapsed.value,
    [key]: !systemDateCollapsed.value[key],
  };
}

const markTenantIssueResolved = async () => {
  const chat = selectedChat.value;
  const messageId = tenantResolveLastId.value;
  const conversationId = chat && chat._tenantConversationId;
  if (!conversationId || messageId == null) return;
  try {
    const { data } = await axios.post('/api/tenant-chat/resolved', {
      conversationId,
      messageId,
    });
    tenantResolvedMessageId.value = data.resolvedMessageId || messageId;
    tenantResolvedExpanded.value = false;
    const boundary = Number(data.resolvedMessageId || messageId);
    if (chat.personId != null && Number.isFinite(boundary)) {
      resolvedKeywordBoundary.value = {
        ...resolvedKeywordBoundary.value,
        [Number(chat.personId)]: boundary,
      };
      clearKeywordFlagFor(chat.personId);
    }
    await loadInsideChatDnd();
  } catch (error) {
    appendLog(`Resolve failed: ${error.message}`);
    if (conversationId) await loadTenantConversations(conversationId);
  }
};

const dismissTenantResolvePrompt = () => {
  resolvePromptHiddenFor.value = tenantResolveLastId.value;
};

const toggleTenantResolved = () => {
  const reveal = !tenantResolvedExpanded.value;
  tenantResolvedExpanded.value = reveal;
  if (reveal) nextTick(() => scrollToBottom());
};

const onTenantIssueResolved = (data) => {
  if (data && data.peopleId != null && data.messageId != null) {
    const key = Number(data.peopleId);
    const boundary = Number(data.messageId);
    const prev = Number(resolvedKeywordBoundary.value[key]) || 0;
    if (Number.isFinite(key) && Number.isFinite(boundary) && boundary >= prev) {
      resolvedKeywordBoundary.value = {
        ...resolvedKeywordBoundary.value,
        [key]: boundary,
      };
      clearKeywordFlagFor(key);
      loadInsideChatDnd();
    }
  }
  if (!data || !selectedChat.value) return;
  const chat = selectedChat.value;
  const sameConversation =
    chat._tenantConversationId != null &&
    Number(chat._tenantConversationId) === Number(data.conversationId);
  const samePerson =
    chat.personId != null &&
    data.peopleId != null &&
    Number(chat.personId) === Number(data.peopleId);
  if (!sameConversation && !samePerson) return;
  const incoming = Number(data.messageId);
  const last = lastTenantMessageId(conversations.value);
  if (!Number.isFinite(incoming) || incoming <= 0) return;
  if (last != null && incoming > last) return;
  if (
    tenantResolvedMessageId.value != null &&
    incoming < Number(tenantResolvedMessageId.value)
  ) {
    return;
  }
  tenantResolvedMessageId.value = incoming;
  tenantResolvedExpanded.value = false;
};

function scrollToTop() {
  if (conversationPanelRef.value) {
    conversationPanelRef.value.scrollTop = 0;
  }
}

function scrollToBottom() {
  if (conversationPanelRef.value) {
    conversationPanelRef.value.scrollTop =
      conversationPanelRef.value.scrollHeight;
  }
}

const pushHighlightId = ref(null);
let pushHighlightTimer = null;

function messagePushEl(id) {
  const root = conversationPanelRef.value;
  if (!root || !root.querySelector) return null;
  return root.querySelector(`[data-push-id="${id}"]`);
}

async function scrollToRouteMessage() {
  const plan = insideChatPushScrollPlan({
    query: route.query,
    messages: conversations.value,
    resolvedMessageId: tenantResolvedMessageId.value,
    usesDateGroups: chatUsesDateSeparators(selectedChat.value),
  });
  if (!plan || !plan.found) return;
  pushHighlightId.value = plan.id;
  clearTimeout(pushHighlightTimer);
  pushHighlightTimer = setTimeout(() => {
    if (pushHighlightId.value === plan.id) pushHighlightId.value = null;
  }, 3600);
  if (plan.expandResolved) tenantResolvedExpanded.value = true;
  if (plan.expandGroup) {
    systemDateCollapsed.value = {
      ...systemDateCollapsed.value,
      [plan.expandGroup]: false,
    };
  }
  await nextTick();
  let el = messagePushEl(plan.id);
  if (!el) {
    systemDateCollapsed.value = {
      today: false,
      yesterday: false,
      week: false,
      older: false,
    };
    if (tenantChatOpen.value) tenantResolvedExpanded.value = true;
    await nextTick();
    el = messagePushEl(plan.id);
  }
  scrollPanelChildToCenter(conversationPanelRef.value, el);
}

function clearSearch() {
  conversationQuery.value = '';
}

const refreshingConversation = ref(false);
async function refreshConversation() {
  if (!selectedChat.value || refreshingConversation.value) return;
  refreshingConversation.value = true;
  try {
    await selectChat(selectedChat.value);
  } finally {
    refreshingConversation.value = false;
  }
}

const renderMarkdown = (text, options = {}) => {
  const raw = text || '';
  const source = options.linkPhones ? linkPhoneTel(raw) : raw;
  const result = marked.parse(linkWorkOrderMentions(source));
  const origin =
    typeof window !== 'undefined' ? window.location.origin : '';
  return finishStaffChatMarkdown(result, origin);
};

function openWorkOrderFromMessage(event) {
  const link = event.target && event.target.closest && event.target.closest('a');
  if (!link) return;
  const href = link.getAttribute('href') || '';
  if (href.startsWith('tel:')) {
    event.stopPropagation();
    return;
  }
  const id = workOrderIdFromChatHref(href);
  if (!id) return;
  event.preventDefault();
  event.stopPropagation();
  router.push({ path: '/mworkorders', query: { search: `:${id}` } });
}

const selectedMessage = ref(null);
const selectedReply = ref(null);
const reactionAnchorId = ref(null);
const reactionPickerFor = ref(null);
const chatReactionEmojis = ['😊', '❤️', '👍', '👎', '😇', '😠', '💯', '😂', '😢', '👏', '🙄', '🤓', '☹️'];

function messageReactionList(message) {
  const value = message && message.reactions;
  if (Array.isArray(value)) return value;
  if (typeof value === 'string' && value.trim()) {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
}

function toggleReactionPicker(message) {
  const id = message && message.id;
  reactionPickerFor.value = reactionPickerFor.value === id ? null : id;
}

async function makeRegularMessage(message) {
  const target = detachChatReply(message);
  if (!target) return;
  try {
    await axios.put(`/api/chat-messages/${target.id}/detach-reply`);
    conversations.value = conversations.value.map((row) => {
      if (!row || String(row.id) !== String(target.id)) return row;
      return { ...row, isReply: 0, isReplyTo: null };
    });
    if (
      selectedMessage.value &&
      String(selectedMessage.value.id) === String(target.id)
    ) {
      selectedMessage.value = {
        ...selectedMessage.value,
        isReply: 0,
        isReplyTo: null,
      };
    }
  } catch (error) {
    console.error('Error detaching reply:', error);
  }
}

async function reactToMessage(message, emoji) {
  if (!message) return;
  const sourceId = message._replyContextSourceId || message.id;
  const tenant = Boolean(message._tenantMessage);
  selectedMessage.value = null;
  selectedReply.value = null;
  reactionAnchorId.value = null;
  reactionPickerFor.value = null;
  const url = tenant
    ? `/api/tenant-chat/messages/${sourceId}/reactions`
    : `/api/chat-messages/${sourceId}/reactions`;
  try {
    const response = await axios.put(url, { emoji });
    const reactions = response.data.reactions || [];
    conversations.value = conversations.value.map((row) => {
      const id = row._replyContextSourceId || row.id;
      if (String(id) !== String(sourceId)) return row;
      return { ...row, reactions };
    });
  } catch (error) {
    console.error('Error saving reaction:', error);
  }
}

const selectMessage = (message) => {
  reactionAnchorId.value = message ? message.id : null;
  reactionPickerFor.value = null;
  if (message && message._replyContext) {
    const source = conversations.value.find(
      (row) => String(row.id) === String(message._replyContextSourceId),
    );
    selectedMessage.value = source || message;
  } else {
    selectedMessage.value = message;
  }
  selectedReply.value = null; // Deselect any selected reply
};

const selectReply = (reply) => {
  selectedReply.value = reply;
  selectedMessage.value = null;
  reactionAnchorId.value = null;
  reactionPickerFor.value = null;
};

const copyTextToClipboard = async (text) => {
  const textToCopy = String(text ?? '');
  if (!textToCopy) return;

  // Clipboard API requires a secure context (HTTPS or localhost).
  // DEV is often http://hostname or an IP, so fall back to execCommand.
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(textToCopy);
      return;
    } catch (err) {
      console.warn('clipboard.writeText failed, trying fallback:', err);
    }
  }

  const textArea = document.createElement('textarea');
  textArea.value = textToCopy;
  textArea.setAttribute('readonly', '');
  textArea.style.position = 'fixed';
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.width = '1px';
  textArea.style.height = '1px';
  textArea.style.padding = '0';
  textArea.style.border = 'none';
  textArea.style.outline = 'none';
  textArea.style.boxShadow = 'none';
  textArea.style.background = 'transparent';
  textArea.style.opacity = '0';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  textArea.setSelectionRange(0, textToCopy.length);
  try {
    const copied = document.execCommand('copy');
    if (!copied) {
      throw new Error('execCommand copy failed');
    }
  } finally {
    document.body.removeChild(textArea);
  }
};

const copySelectedMessageOrReply = async () => {
  let textToCopy = '';
  if (selectedMessage.value) {
    textToCopy = selectedMessage.value.message || '';
  } else if (selectedReply.value) {
    textToCopy = selectedReply.value.replyMessage || '';
  }
  if (!textToCopy) return;
  try {
    await copyTextToClipboard(textToCopy);
  } catch (err) {
    console.error('Failed to copy message to clipboard:', err);
  }
};

const deleteSelectedMessageOrReply = async () => {
  let idToDelete = null;

  if (selectedMessage.value) {
    idToDelete = selectedMessage.value.id;
  } else if (selectedReply.value) {
    idToDelete = selectedReply.value.id;
  }

  if (idToDelete) {
    try {
      await axios.delete(`/api/chat-messages/${idToDelete}`);
      if (selectedMessage.value) {
        conversations.value = conversations.value.filter(
          (message) => message.id !== idToDelete,
        );
        selectedMessage.value = null;
      } else if (selectedReply.value) {
        const parentMessage = conversations.value.find((message) =>
          message.replies.some((reply) => reply.id === idToDelete),
        );
        if (parentMessage) {
          parentMessage.replies = parentMessage.replies.filter(
            (reply) => reply.id !== idToDelete,
          );
        }
        selectedReply.value = null;
      }
    } catch (error) {
      console.error('Error deleting message or reply:', error);
    }
  }
};

const deleteAllSystemMessages = async () => {
  if (!selectedChat.value || selectedChat.value.userId !== 0) return;
  try {
    await axios.delete('/api/chat-messages/system/all');
    conversations.value = [];
    selectedMessage.value = null;
    selectedReply.value = null;
  } catch (error) {
    console.error('Error deleting all system messages:', error);
  }
};

const handleKeyup = (event) => {
  const textarea = document.querySelector('textarea');
  if (event.key === 'Delete' && document.activeElement !== textarea) {
    deleteSelectedMessageOrReply();
  }
  if (
    insideChatNewHeadHotkey(event, document.activeElement) &&
    !showPopup.value
  ) {
    showPopup.value = true;
  }
};

const reloadOpenChatAfterOutbound = async (detail) => {
  const chat = selectedChat.value;
  if (!chat || !detail || detail.kind !== 'inside-chat') return;
  if (
    detail.messageId &&
    conversations.value.some(
      (row) => String(row.id) === String(detail.messageId),
    )
  ) {
    return;
  }
  if (detail.isTenant) {
    if (String(chat.personId || '') !== String(detail.peopleId || '')) return;
    const convId = chat._tenantConversationId || detail.conversationId;
    if (convId) await loadTenantConversations(convId);
    return;
  }
  if (detail.toGroupId) {
    if (String(chat.groupId || '') !== String(detail.toGroupId)) return;
    await loadGroupConversations(chat.groupId, showRead.value);
    return;
  }
  if (String(chat.userId || '') !== String(detail.toUserId || '')) return;
  await loadConversations(chat.personId, chat.userId, showRead.value);
};

const onOutboundSent = (event) => {
  reloadOpenChatAfterOutbound(event && event.detail).catch(() => undefined);
};

onMounted(async () => {
  window.addEventListener('pixie-outbound-sent', onOutboundSent);
  showRecentFeatureHint.value = !recentFeatureHintSeen(localStorage);
  await nextTick();
  placeRecentFeatureHint();
  // initialize
  chatDB = await openDB('chatDB', 1, {
    upgrade(db) {
      // Update schema to include lastMessageId and lastViewedMessageId for tracking
      if (!db.objectStoreNames.contains('chats')) {
        const chatStore = db.createObjectStore('chats', {
          keyPath: 'id',
          autoIncrement: true,
        });
        // Add index for faster lookup by group, person, or user ID
        chatStore.createIndex('groupId', 'groupId');
        chatStore.createIndex('personId', 'personId');
        chatStore.createIndex('userId', 'userId');
      }
    },
  });

  keywordFlagTimer = setInterval(() => {
    dndNow.value = new Date();
  }, 60000);

  // Get my user ID
  await fetchMyId();
  appendLog(`Fetched my user ID: ${myId.value}`);
  await loadInsideChatDnd();

  connectSocket(); // Connect to WebSocket server on mount

  // Create a test function to manually emit an event for testing
  window._testSocketEvent = () => {
    appendLog('🧪 Manual test event triggered');
    const testData = {
      id: 'test-' + Date.now(),
      message: 'Test message',
      datetime: new Date().toISOString(),
      fromUserId: 'test-user',
      toUserId: myId.value,
    };
    handleNewChatMessages(testData);
    appendLog('Manual test event processed');
  };
  appendLog('Added test function: window._testSocketEvent()');

  window.addEventListener('keyup', handleKeyup);
  await loadChatUsers();
  await loadCurrentUser();
  await loadActiveChats();
  await loadGroups(); // Load groups on mount
  await openChatFromRoute();

  // Silently (re)subscribe to push if permission already granted; update state.
  try {
    await subscribePushIfGranted();
    notifPerm.value = notificationPermission();
  } catch (e) {
    /* ignore */
  }
  // Initial badge sync after chats are loaded
  setChatAppBadge(totalUnread.value);

  // Incoming message that opened this panel: ensure a badged head exists,
  // but do not auto-select (selectChat marks the thread read).
  if (props.chatMessage) {
    const msg = props.chatMessage;
    const existing = activeChats.value.find(
      (c) =>
        (isSystemChatMessage(msg, myId.value) && Number(c.userId) === 0) ||
        (msg.toGroupId && Number(c.groupId) === Number(msg.toGroupId)) ||
        chatsMatchIncomingDirect(c, msg, myId.value),
    );
    if (!existing) {
      await handleNewChatMessages(msg);
    } else if (msg.id) {
      addToRecentMessageIds(msg.id);
    }
  }
});

// Disconnect socket on unmount
onUnmounted(() => {
  clearTimeout(pushHighlightTimer);
  window.removeEventListener('pixie-outbound-sent', onOutboundSent);
  cancelZoomPress();
  cancelComposerHold();
  if (isRecordingAudio.value) stopChatRecording({ discard: true });
  clearPendingChatAudio();
  teardownChatMediaObserver();
  Object.values(chatImageUrls.value).forEach((url) => {
    if (url && String(url).startsWith('blob:')) URL.revokeObjectURL(url);
  });
  chatAudioPlayers.forEach((player) => {
    try {
      player.pause();
      player.src = '';
    } catch {
      /* ignore */
    }
  });
  chatAudioPlayers.clear();
  clearTimeout(dndTickTimer);
  clearInterval(keywordFlagTimer);
  if (socket) {
    unregisterChatSocketHandlers(socket);

    // Only disconnect if we're NOT using a shared socket
    if (socket !== props.sharedSocket) {
      socket.disconnect();
      console.log('Disconnected from WebSocket server');
      appendLog('🔌 Disconnected own socket connection');
    } else {
      appendLog(
        '🔗 Removed event handlers from shared socket (not disconnecting)',
      );
    }
  }
  window.removeEventListener('keyup', handleKeyup);
  clearTimeout(shareNoteTimer);
});

watch(
  () => [route.query.group, route.query.user, route.query.person, route.query.msg],
  () => {
    if (!chatDB) return;
    openChatFromRoute();
  },
);

const isMobile = computed(() => {
  const width = window.innerWidth;
  return width <= 768; // Adjust the width threshold as needed
});

const isPageRoute = computed(() => route.name === 'ichat');
const chatRootClass = computed(() => insideChatRootClass(isPageRoute.value));

const toggleShowUnread = () => {
  showRead.value = !showRead.value;
  if (selectedChat.value) {
    loadConversations(
      selectedChat.value.personId,
      selectedChat.value.userId,
      showRead.value,
    );
  }
};

const sendClose = () => {
  eventBus.emit('requestCloseChat');
};

const showCloseAllChats = ref(false);

const showCloseAllChatsPopup = () => {
  showCloseAllChats.value = true;
};

const closeAllChats = async () => {
  activeChats.value = [];
  await chatDB.clear('chats');
  showCloseAllChats.value = false;
};

// const debugCleanupChats = async () => {
//   const before = activeChats.value.length;
//   // Log what we have before cleanup
//   for (const chat of activeChats.value) {
//     appendLog(
//       `  chat: initials=${chat.initials} personId=${chat.personId}(${typeof chat.personId}) userId=${chat.userId} groupId=${chat.groupId} tenantConvId=${chat._tenantConversationId} name=${chat.displayName || chat.fullName}`,
//     );
//   }
//   // Nuke IndexedDB and reload fresh from server
//   activeChats.value = [];
//   selectedChat.value = null;
//   conversations.value = [];
//   await chatDB.clear('chats');
//   appendLog(`Debug: cleared ${before} chats from IndexedDB, reloading...`);
//   await loadActiveChats();
//   appendLog(`Debug: reloaded ${activeChats.value.length} chats from server`);
//   for (const chat of activeChats.value) {
//     appendLog(
//       `  reloaded: initials=${chat.initials} personId=${chat.personId}(${typeof chat.personId}) userId=${chat.userId} tenantConvId=${chat._tenantConversationId}`,
//     );
//   }
//   alert(
//     `Cleared ${before} stale chats, reloaded ${activeChats.value.length} fresh from server`,
//   );
// };

// Function to refresh chat data when tab becomes active
const refreshMessages = async () => {
  console.log('InsideChatTool: Refreshing messages due to tab activation');

  try {
    // Reload active chats to get latest messages
    await loadActiveChats();
    console.log('InsideChatTool: Messages refreshed successfully');
  } catch (error) {
    console.error('InsideChatTool: Error refreshing messages:', error);
  }
};

// Expose the refreshMessages function so parent can call it
defineExpose({
  refreshMessages,
});
</script>

<style scoped>
:deep(.chat-video-preview) {
  display: block;
  margin-top: 8px;
  line-height: 0;
}

:deep(.chat-video-preview img) {
  display: block;
  width: 100%;
  max-width: 240px;
  border-radius: 8px;
}

.inside-chat-root--page,
.inside-chat-root--fill {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  min-height: 0;
  width: 100%;
}

.inside-chat-root--page .chat-panel,
.inside-chat-root--fill .chat-panel {
  flex-shrink: 0;
}

.inside-chat-root--page .panel,
.inside-chat-root--fill .panel {
  flex: 1;
  height: auto;
  min-height: 0;
}

.inside-chat-root--page .active-chats-wrapper-outer,
.inside-chat-root--fill .active-chats-wrapper-outer,
.inside-chat-root--page .active-chats-wrapper,
.inside-chat-root--fill .active-chats-wrapper {
  height: 100%;
  max-height: none;
}

.inside-chat-root--page .chat-heads-column,
.inside-chat-root--fill .chat-heads-column,
.inside-chat-root--page .scrollable-chats,
.inside-chat-root--fill .scrollable-chats {
  max-height: none;
  flex: 1;
  min-height: 0;
}

.inside-chat-root--page .main-content-wrapper,
.inside-chat-root--fill .main-content-wrapper {
  height: auto;
  min-height: 0;
  flex: 1;
}

.inside-chat-root--page .conversation-panel,
.inside-chat-root--fill .conversation-panel {
  height: auto;
  padding-bottom: 10px;
}

.panel {
  font-size: 0.9em;
  border: 1px solid #ccc;
  overflow: hidden;
  background: #cdcdcd;
  z-index: 10001;
  height: 739px;
  padding: 10px;
  position: relative;
  display: flex;
  flex-direction: row;
  padding-left: 0;
}

.title-bar {
  background: #6e5875;
  color: #fff;
  font-size: 1.4em;
  padding: 8px;
  height: auto;
  min-height: 48px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.title-bar--named {
  padding-top: 18px;
}

.title-icon {
  flex: 0 0 40px;
}

.title-text {
  flex: 1 1 0;
  min-width: 0;
  font-size: 0.8em;
  text-align: left;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.title-text small {
  display: block;
  line-height: 1.1;
}

.chat-name {
  font-weight: bold;
}

.title-buttons {
  display: flex;
  gap: 5px;
}

.back-button,
.group-button,
.share-button,
.home {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #e1dede;
  color: #eee;
  background: #907793;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.back-button {
  font-weight: normal;
  font-size: 0.7em;
}

.share-note {
  align-self: center;
  font-size: 0.45em;
  line-height: 1;
  color: #fff;
  white-space: nowrap;
}

.home {
  font-size: 0.6em;
  margin-right: 10px;
  border: 1px solid #ccc;
}

.title-bar button i,
.search-bar button i,
.send-button i,
.action-buttons button i {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.main-content-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 10px;
  position: relative;
  justify-content: space-between; /* This distributes space between elements */
  width: 85%;
  height: 700px;
}

.action-buttons {
  display: flex;
  gap: 5px;
  flex: 0 0 auto;
  justify-content: flex-end;
}

.action-buttons button {
  width: 100px;
  border-radius: 6px;
  border: 1px solid rgb(195 195 195);
  padding: 6px;
  background: #6e5875;
  color: white;
}

.action-buttons button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.action-buttons button.copy-message-btn {
  width: 40px;
  flex-shrink: 0;
}

.inside-chat-root {
  position: relative;
}

.dnd-popup {
  position: absolute;
  top: 108px;
  left: calc(15% + 8px);
  z-index: 10005;
  width: 280px;
  max-width: calc(85% - 16px);
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  padding: 0;
  overflow: visible;
}

@media (max-width: 768px) {
  .dnd-popup {
    top: 64px;
    left: 10px;
    right: 10px;
    width: auto;
    max-width: none;
  }

  .dnd-how-panel {
    top: 64px;
  }
}

.dnd-popup .popup-header {
  margin: 0;
  padding: 8px 10px;
  border-radius: 0;
}

.dnd-popup .popup-title {
  margin: 0;
}

.dnd-popup .close-button {
  margin: 0;
}

.dnd-popup .popup-body {
  overflow: visible;
  max-height: none;
  min-width: 0;
}

.dnd-always-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 10px;
}

.dnd-always-on {
  display: inline-block;
  margin: 0;
  flex: 0 0 auto;
  background: #fff;
  color: #6e5875;
  border: 1px solid #6e5875;
  border-radius: 4px;
  padding: 6px 14px;
  cursor: pointer;
  font-size: 0.95em;
}

.dnd-how {
  margin-left: auto;
  flex: 0 0 auto;
  background: #fff;
  color: #111;
  border: 1px solid #c9b8d0;
  border-radius: 4px;
  padding: 3px 8px;
  cursor: pointer;
  font-size: 0.75em;
}

.dnd-how-panel {
  position: absolute;
  z-index: 10006;
  top: 108px;
  left: 4%;
  right: 4%;
  width: auto;
  max-height: calc(100dvh - 120px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  user-select: text;
  -webkit-user-select: text;
}

.dnd-how-panel * {
  user-select: text;
  -webkit-user-select: text;
}

.dnd-how-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  background: #a080a8;
  color: #fff;
  font-weight: 600;
  border-radius: 8px 8px 0 0;
}

.dnd-how-close {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #e1dede;
  background: #907793;
  color: #fff;
  cursor: pointer;
}

.dnd-how-body {
  overflow-x: hidden;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  padding: 10px 12px 12px;
  color: #111;
  font-size: 0.85em;
  line-height: 1.35;
}

.dnd-how-body::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.dnd-how-body p {
  margin: 0 0 8px;
}

.dnd-how-body p:last-child {
  margin-bottom: 0;
}

.dnd-always-on-active {
  background: #6e5875;
  color: #fff;
}

.dnd-until,
.dnd-check {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
  font-size: 0.95em;
  min-width: 0;
  max-width: 100%;
}

.dnd-check {
  flex-direction: row;
  align-items: center;
}

.dnd-until input[type='datetime-local'] {
  display: block;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  min-height: 44px;
  height: auto;
  padding: 8px;
  font-size: 16px;
  line-height: 1.3;
}

.dnd-until input[type='datetime-local']::-webkit-datetime-edit,
.dnd-until input[type='datetime-local']::-webkit-datetime-edit-fields-wrapper {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  min-width: 0;
  padding: 0;
}

.dnd-keywords input {
  width: 100%;
  box-sizing: border-box;
  padding: 7px 10px;
  border: 1px solid #6e5875;
  border-radius: 4px;
  color: #333;
  background: #fff;
  font-size: 0.95em;
}

.dnd-keywords input:focus {
  outline: none;
  border-color: #6e5875;
  box-shadow: 0 0 0 2px rgba(110, 88, 117, 0.18);
}

.dnd-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}

.dnd-actions button {
  margin-left: 0;
  background: #fff;
  color: #6e5875;
  border: 1px solid #6e5875;
  border-radius: 4px;
  padding: 6px 14px;
  cursor: pointer;
  font-size: 0.95em;
}

.dnd-actions button:hover {
  background: rgba(110, 88, 117, 0.08);
}

.content {
  flex: 1;
  border: 2px solid #afafaf;
  border-radius: 6px;
  background: #fffefe;
  padding: 8px 5px 5px 5px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0; /* Important for nested flex containers to properly scroll */
}

.composer-wrap {
  flex: 0 0 auto;
  background: #cdcdcd;
  z-index: 10002;
}

.chat-pending-images {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px 4px;
  overflow-x: auto;
}

.chat-pending-send {
  margin-left: auto;
  background: #4caf50;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 8px 14px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
}

.chat-pending-send:hover {
  background: #45a049;
}

.chat-pending-send:disabled {
  opacity: 0.75;
  cursor: wait;
}

.chat-pending-thumb {
  position: relative;
  width: 52px;
  height: 52px;
  flex-shrink: 0;
}

.chat-pending-thumb img {
  width: 52px;
  height: 52px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #999;
}

.chat-pending-remove {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: none;
  background: #4b0082;
  color: #fff;
  font-size: 12px;
  line-height: 18px;
  padding: 0;
  cursor: pointer;
}

.input-container {
  display: flex;
  align-items: stretch;
  flex: 0 0 auto; /* Changed from fixed 60px to auto */
  background: #cdcdcd;
  z-index: 10002;
  margin: 0;
  height: 60px; /* Maintain theheight */
}

.chat-gallery-input {
  display: none;
}

.chat-attach-btn {
  width: 42px;
  border: 1px solid #999999;
  border-right: none;
  border-radius: 7px 0 0 7px;
  background: #eee;
  color: #4b0082;
  cursor: pointer;
  margin: 0;
}

.chat-attach-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.chat-mic-btn {
  border-radius: 0;
  border-left: 1px solid #999999;
}

.chat-mic-btn.recording {
  background: #e53935;
  color: #fff;
}

.input-container textarea {
  border-radius: 0;
}

.chat-pending-audio {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px 4px;
}

.chat-audio-player-pending {
  position: relative;
  flex: 1;
}

.chat-pending-audio-remove {
  position: relative;
  top: 0;
  right: 0;
  margin-left: auto;
}

.chat-recording-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px 4px;
  color: #b00020;
  font-size: 0.9em;
}

.chat-recording-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #e53935;
  animation: chat-rec-pulse 1s ease-in-out infinite;
}

@keyframes chat-rec-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

.chat-recording-stop {
  margin-left: auto;
  background: #e53935;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-weight: 600;
  cursor: pointer;
}

.chat-inline-audios {
  margin-top: 8px;
}

.chat-audio-player {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px 4px 4px;
  background: rgba(75, 0, 130, 0.08);
  border: 1px solid #c4b8cc;
  border-radius: 20px;
  position: relative;
}

.chat-audio-player audio {
  width: 0;
  height: 0;
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.chat-audio-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: #4b0082;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.chat-audio-btn i {
  font-size: 0.85em;
}

.chat-audio-label {
  font-size: 0.85em;
  color: #4b0082;
  padding-right: 4px;
  white-space: nowrap;
}

.chat-inline-images {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.chat-inline-image-wrap {
  cursor: pointer;
}

.chat-inline-image {
  max-width: 180px;
  max-height: 180px;
  border-radius: 6px;
  cursor: pointer;
  display: block;
  object-fit: cover;
}

.chat-inline-image-skel {
  width: 120px;
  height: 90px;
  border-radius: 6px;
  background: linear-gradient(90deg, #ececec 0%, #f7f7f7 50%, #ececec 100%);
  background-size: 200% 100%;
  animation: chat-media-skel-shine 1.4s ease-in-out infinite;
}

@keyframes chat-media-skel-shine {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

.chat-image-lightbox {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.78);
  z-index: 20000;
  display: flex;
  align-items: center;
  justify-content: center;
  touch-action: none;
}

.chat-image-lightbox img {
  max-width: 92vw;
  max-height: 92vh;
  border-radius: 6px;
  user-select: none;
  -webkit-user-drag: none;
}

.active-chats-wrapper-outer {
  height: 700px;
  position: relative;
  width: 15%;
}

.active-chats-wrapper {
  height: 700px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fixed-chats {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 42px;
}

.chat-heads-column {
  width: 67px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right: 1px solid #ccc;
}

.scrollable-chats {
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  overflow-x: hidden;
  overflow-anchor: none;
  flex: 1;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scrollable-chats::-webkit-scrollbar {
  display: none;
}

.chat-head-label {
  width: 56px;
  margin: 6px 0 0;
  padding: 3px 0 0;
  border-top: 1px solid #c5c5c5;
  color: #888;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.03em;
  line-height: 1;
  text-align: center;
}

.scrollable-chats .chat-head-label:first-child {
  margin-top: 10px;
  padding-top: 0;
  border-top: none;
}

.scrollable-chats .chat-head-label + .chat-square {
  margin-top: 0;
}

.zoom-meet-btn {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 28px;
  margin: 6px auto 2px;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: #0e71eb;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.25);
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  touch-action: manipulation;
}

.zoom-url-popup {
  position: absolute;
  z-index: 10005;
  top: 64px;
  left: 72px;
  right: 12px;
  max-width: 420px;
  box-sizing: border-box;
  padding: 12px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.zoom-url-title {
  font-weight: 600;
  color: #333;
}

.zoom-url-popup input {
  display: block;
  width: 100%;
  box-sizing: border-box;
  margin: 8px 0;
  padding: 8px;
  font-size: 16px;
}

.zoom-url-error {
  margin: 0 0 8px;
  color: #a33;
  font-size: 0.85em;
}

.zoom-url-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.zoom-url-actions button {
  margin: 0;
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  color: #333;
}

.zoom-url-actions .zoom-url-save {
  background: #0e71eb;
  color: #fff;
  border-color: #0e71eb;
}

.recent-feature-hint {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: var(--recent-feature-hint-left, 72px);
  z-index: 30;
  background: rgba(20, 16, 24, 0.82);
}

.recent-feature-hint-callout {
  position: absolute;
  left: 0;
  top: var(--recent-feature-hint-top, 80px);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  max-width: min(340px, calc(100% - 12px));
  color: #fff;
  pointer-events: none;
}

.recent-feature-hint-arrow {
  width: 72px;
  height: 40px;
  flex-shrink: 0;
  overflow: visible;
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.35));
}

.recent-feature-hint-copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.recent-feature-hint-text {
  margin: 0;
  color: #fff;
  font-size: 1.05em;
  font-weight: 700;
  line-height: 1.35;
  text-align: left;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.45);
}

.recent-feature-hint-dismiss {
  pointer-events: auto;
  margin: 1.6em 0 0;
  min-height: 44px;
  padding: 12px 14px;
  border: 1px solid rgba(255, 255, 255, 0.75);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
  font-size: 0.85em;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
}

.recent-tenant-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 28px;
  margin: 4px auto 8px;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: #6e5875;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.25);
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
}

.recent-tenants-popup {
  position: absolute;
  z-index: 10004;
  top: 64px;
  left: 72px;
  right: 12px;
  max-width: 420px;
  max-height: calc(100dvh - 90px);
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.recent-tenants-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  background: #a080a8;
  color: #fff;
  font-weight: 600;
  border-radius: 8px 8px 0 0;
}

.recent-tenants-close {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #e1dede;
  background: #907793;
  color: #fff;
  cursor: pointer;
}

.recent-tenants-panel {
  position: relative;
  flex: 1;
  min-height: 220px;
  display: flex;
  flex-direction: column;
}

.recent-tenants-status {
  padding: 12px;
  color: #333;
  font-size: 0.9em;
}

.recent-tenants-hint {
  position: absolute;
  inset: 0;
  z-index: 2;
  background: rgba(20, 16, 24, 0.82);
}

.recent-tenants-hint-callout {
  position: absolute;
  left: 16px;
  right: 16px;
  top: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  pointer-events: none;
  text-align: center;
}

.recent-tenants-hint-text {
  margin: 0;
  max-width: 280px;
  color: #fff;
  font-size: 1.05em;
  font-weight: 700;
  line-height: 1.35;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.45);
}

.recent-tenants-hint-dismiss {
  pointer-events: auto;
  margin: 1.6em 0 0;
  min-height: 44px;
  padding: 12px 14px;
  border: 1px solid rgba(255, 255, 255, 0.75);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
  font-size: 0.85em;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
}

.recent-tenants-list {
  list-style: none;
  margin: 0;
  padding: 0 20px;
  box-sizing: border-box;
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.recent-tenants-list::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.recent-tenant-row {
  display: block;
  width: 100%;
  margin: 0;
  text-align: left;
  border: 0;
  border-bottom: 1px solid #eee;
  background: #fff;
  color: #111;
  box-sizing: border-box;
  padding: 8px 0;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  touch-action: manipulation;
}

.recent-tenant-meta {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
  font-size: 0.85em;
}

.recent-tenant-meta strong {
  min-width: 0;
  text-align: left;
}

.recent-tenant-meta > span {
  flex: 0 0 auto;
  white-space: nowrap;
}

.recent-tenant-text {
  display: block;
  margin-top: 2px;
  font-size: 0.9em;
  white-space: pre-wrap;
  word-break: break-word;
}

.chat-square {
  position: relative;
  box-sizing: border-box;
  width: 56px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  margin: 0 0 2px;
  user-select: none;
  -webkit-user-select: none;
}

.chat-circle {
  width: 52px;
  height: 28px;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.25);
}

.chat-circle-tool {
  box-sizing: border-box;
  background: transparent;
  border: 2px solid #6e5875;
  color: #6e5875;
  box-shadow: none;
}

.chat-circle-tool-alert {
  border-color: #e6a817;
  color: #e6a817;
}

.chat-circle-tool-dnd {
  background: #6e5875;
  border-color: #6e5875;
  color: #fff;
}

.chat-circle-group {
  display: block;
  box-sizing: border-box;
  padding: 0 3px;
  font-size: 10px;
  line-height: 28px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.conversation-panel {
  flex-grow: 1;
  height: 100%;
  width: 95%;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 10px 4px 70px 10px;
  -ms-overflow-style: none; /* Hide scrollbar for IE and Edge */
  scrollbar-width: none; /* Hide scrollbar for Firefox */
}

.conversation-panel::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome, Safari, and Opera */
}

.chat-date-group-header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e0d6e4;
  background: #f3eef6;
  color: #4a3a52;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 0.85em;
  font-weight: 600;
  cursor: pointer;
  margin: 8px 0;
  margin-left: 0;
  text-align: left;
}

.chat-date-group-header-spaced {
  margin-top: 16px;
}

.chat-date-group-header i {
  width: 12px;
  font-size: 0.75em;
  color: #6a5570;
}

.chat-date-group-count {
  margin-left: auto;
  font-weight: 500;
  color: #8a7a90;
  font-size: 0.9em;
}

.message {
  position: relative;
  margin-bottom: 10px;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
  background: #f0f0f0;
  border-radius: 6px;
  padding: 3px 8px;
  line-height: calc(1.2em + 3px);
}

.system-message-text {
  font-size: 11px;
}

.message.system-chat-message {
  padding-top: 1px;
  padding-bottom: 1px;
  font-family: Consolas, "Segoe UI", sans-serif;
  line-height: normal;
}

.chat-circle-sys {
  font-family: Consolas, "Segoe UI", sans-serif;
}

.message.system-chat-message .timestamp {
  margin-top: 0;
  margin-bottom: 0;
}

.system-message-text :deep(p) {
  margin: 0;
}

.message :deep(a):not(.chat-video-preview) {
  text-decoration: none;
  background: #d6ebff;
  border: none;
  border-radius: 3px;
  padding: 0 2px;
  color: #1a4f9c;
  cursor: pointer;
}

.message.reply {
  margin-left: 15px;
}

.message.reply-context {
  border-left: 2px solid #6e5875;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.message.selected {
  background-color: #e0e0e0;
}

.message.push-highlight {
  box-shadow: inset 0 0 0 2px #6e5875;
}

.message.has-reactions {
  margin-bottom: 18px;
}

button.chat-outdent {
  position: absolute;
  left: -16px;
  top: 50%;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 28px;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  color: #6e5875;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  transform: translateY(-50%);
}

button.chat-react-face {
  position: absolute;
  right: -2px;
  top: 4px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin: 0;
  padding: 0;
  border: 1px solid #e0d6e4;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  line-height: 1;
  font-size: 16px;
  text-align: center;
}

.chat-react-picker {
  position: absolute;
  right: 0;
  top: 36px;
  z-index: 3;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  width: max-content;
  max-width: min(220px, 100%);
  gap: 1px;
  background: #fff;
  border: 1px solid #e0d6e4;
  border-radius: 18px;
  padding: 3px 6px;
}

button.chat-react-choice {
  flex: 0 0 auto;
  border: none;
  background: transparent;
  font-size: 17px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  margin: 0;
}

.chat-react-choice.chosen {
  background: #f3eef6;
  border-radius: 8px;
}

.chat-reaction-row {
  position: absolute;
  right: 6px;
  bottom: -10px;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0;
  width: max-content;
  white-space: nowrap;
  background: none;
  border: none;
  padding: 0;
  font-size: 21px;
  line-height: 1;
}

.chat-reaction-row span {
  display: inline-block;
  line-height: 1;
}

.message :deep(p),
.message :deep(a) {
  overflow-wrap: anywhere;
  word-break: break-word;
}

.footer {
  text-align: left;
  font-size: 0.8em;
}

button {
  margin-left: 5px;
}

.reply {
  margin-top: 5px;
  color: #4a4a4a;
}

.timestamp {
  font-size: 0.75em;
  color: #888;
  margin-bottom: -13px;
  margin-top: 10px;
}

.message:has(.chat-inline-images) .timestamp,
.message:has(.chat-inline-audios) .timestamp {
  margin-bottom: 6px;
}

.tenant-viewed-check {
  color: #22c55e;
  margin-left: 4px;
  font-size: 0.9em;
  vertical-align: baseline;
}

textarea {
  flex-grow: 1;
  padding: 5px;
  border-radius: 7px 0 0 7px;
  border: 1px solid #999999;
  resize: none;
  height: 48px;
  outline: none;
  background: #fff;
  margin: 0;
}

.popup {
  position: absolute;
  top: 100px;
  left: 25px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 7px 5px 13px 2px rgba(0, 0, 0, 0.25);
  z-index: 10001;
}

.popup input {
  width: 92%;
  padding: 5px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline: none;
}

.popup ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.popup li {
  padding: 5px;
  cursor: pointer;
}

.popup li:hover {
  background: #f0f0f0;
}

.selected {
  background-color: #c4c4c4;
}

.keyword-flag {
  position: absolute;
  right: -2px;
  bottom: -3px;
  box-sizing: border-box;
  width: 18px;
  height: 18px;
  padding: 3px;
  border-radius: 50%;
  background: red;
  color: white;
  border: 1px solid #f1f1f1;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  pointer-events: none;
}

.keyword-flag i {
  margin: 0;
  font-size: 8px;
  line-height: 1;
}

.badge {
  position: absolute;
  top: -3px;
  right: -2px;
  background: red;
  border: 1px solid #f1f1f1;
  color: white;
  border-radius: 50%;
  min-width: 16px;
  height: 16px;
  font-size: 0.65em;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  text-align: center;
  font-weight: bold;
  z-index: 10;
}

.selected-chat {
  background: #efefef;
  border: 1px solid #aaa;
  border-radius: 6px;
}

.fromuser {
  color: #222;
}

.initials {
  color: #c58919;
  font-weight: bold;
}

.from-me {
  color: #4caf50;
  font-weight: bold;
}

.search-bar {
  background: #ffffff;
  border-radius: 4px;
  padding: 7px 7px 7px 13px;
}

.search-bar input {
  border: 1px solid #ccc;
  width: 148px;
  font-size: 12px;
  border-radius: 4px;
  padding: 5px;
  margin-right: 5px;
  outline: none;
}

.search-bar input.search-input-iphone {
  font-size: 16pt;
}

.search-bar input::placeholder {
  color: #ddd;
}

.search-bar button {
  font-size: 14pt;
  min-width: 30px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
  color: #a080a0;
}

@media (max-width: 768px) {
  .search-bar {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 4px;
  }

  .search-bar input {
    width: 84px;
    max-width: 84px;
    flex: 0 1 84px;
    min-width: 0;
    box-sizing: border-box;
    margin-right: 0;
  }

  .search-bar button {
    flex: 0 0 auto;
  }
}

.send-button {
  height: 60px;
  width: 40px;
  background-color: #6e5875;
  color: white;
  border: none;
  border-radius: 0 4px 4px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 0;
}

.send-button:hover {
  background-color: #5c4a66;
}

.send-button:disabled {
  opacity: 0.75;
  cursor: wait;
}

.send-button .fa-spinner {
  font-size: 16px;
}

.group-icon {
  cursor: pointer;
  margin-left: 8px;
  font-size: 0.8em;
  color: #eaeaea;
  transition: color 0.3s;
}

.group-icon:hover {
  color: #ffffff;
}

/* Chat type selector styles */
.chat-type-selector {
  display: flex;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}

.chat-type-selector button {
  flex: 1;
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
  margin: 0;
}

.chat-type-selector button.active {
  border-bottom: 2px solid #a080a8;
  font-weight: bold;
}

/* One-to-one section */
.one-to-one-section {
  padding: 10px 0;
}

/* Group chat section */
.group-section {
  padding: 10px 0;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.section-header h3 {
  margin: 0;
  font-size: 1em;
}

.create-group-btn {
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 0.8em;
  cursor: pointer;
}

.back-btn {
  background: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 0.8em;
  cursor: pointer;
}

.no-groups {
  text-align: center;
  padding: 20px 0;
}

.create-group {
  padding: 5px 0;
}

.group-name-input {
  width: 100%;
  padding: 8px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.group-members h4 {
  margin: 10px 0;
  font-size: 0.9em;
}

.selected-members-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 10px;
}

.selected-member {
  background: #e1e1e1;
  border-radius: 15px;
  padding: 3px 10px;
  font-size: 0.8em;
  display: flex;
  align-items: center;
}

.selected-member button {
  background: none;
  border: none;
  font-size: 0.9em;
  color: #888;
  cursor: pointer;
  margin-left: 5px;
  padding: 0;
}

.already-selected {
  opacity: 0.7;
  background: #f5f5f5;
}

.already-selected-text {
  font-size: 0.8em;
  color: #4caf50;
  margin-left: 5px;
}

.create-group-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}

.create-btn {
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 15px;
  cursor: pointer;
}

.create-btn:disabled {
  background: #cccccc;
  cursor: not-allowed;
}

.cancel-btn {
  background: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 15px;
  cursor: pointer;
}

.loading {
  text-align: center;
  padding: 15px 0;
  color: #666;
}

/* Group management popup — stays inside Inside Chat, not the viewport */
.group-management-popup {
  position: absolute;
  top: 56px;
  left: 8px;
  right: 8px;
  width: auto;
  max-height: calc(100% - 64px);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
  background: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 10006;
}

.group-management-popup .popup-header {
  flex-shrink: 0;
}

.group-management-popup .popup-body {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #a080a8;
  color: white;
  border-bottom: 1px solid #eee;
  padding: 10px;
  border-radius: 5px 5px 0 0;
}

.popup-title {
  display: flex;
  flex-direction: column;
}

.popup-title small {
  font-size: 0.8em;
}

.popup-title .group-name {
  font-size: 1em;
  font-weight: bold;
}

.close-button {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #e1dede;
  background: #907793;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  font-size: 0.9em;
}

.popup-body {
  padding: 10px;
  max-height: 400px;
  overflow-y: auto;
}

.popup-body h4 {
  margin: 10px 0;
  font-size: 0.9em;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
}

.member-list {
  list-style: none;
  padding: 0;
  margin: 0 0 15px 0;
}

.member-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
  border-bottom: 1px solid #f5f5f5;
}

.remove-member {
  background: none;
  border: none;
  color: #a080a0;
  cursor: pointer;
  padding: 3px;
}

.add-members-section,
.rename-group-section {
  margin-top: 15px;
}

.members-to-add-list {
  list-style: none;
  padding: 0;
  margin: 10px 0;
  border: 1px solid #eee;
  border-radius: 4px;
  max-height: 150px;
  overflow-y: auto;
}

.members-to-add-list li {
  display: flex;
  justify-content: space-between;
  padding: 8px 10px;
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
}

.members-to-add-list li:hover {
  background: #f9f9f9;
}

.members-to-add-list i {
  color: #4caf50;
}

.rename-input-group {
  display: flex;
  margin-top: 10px;
}

.rename-input-group input {
  flex: 1;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px 0 0 4px;
}

.rename-input-group button {
  background: #a080a8;
  color: white;
  border: none;
  border-radius: 0 4px 4px 0;
  padding: 0 10px;
  cursor: pointer;
}

.rename-input-group button:disabled {
  background: #cccccc;
  cursor: not-allowed;
}

/* Close all chats popup */
.close-all-chats-popup {
  position: absolute;
  top: 100px;
  left: 25px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 7px 5px 13px 2px rgba(0, 0, 0, 0.25);
  z-index: 10001;
}

.popup-content {
  text-align: center;
}

.popup-actions {
  margin-top: 10px;
}

.confirm-btn,
.cancel-btn {
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
}

.confirm-btn {
  background: #4caf50;
  color: white;
}

.cancel-btn {
  background: #f44336;
  color: white;
}

.chat-name-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.chat-name-block {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.chat-name-line {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  max-width: 100%;
}

.chat-name-line .chat-name {
  flex: 0 1 auto;
}

.person-flag {
  flex: 0 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  box-sizing: border-box;
  font-size: 8px;
  font-weight: 700;
  line-height: 1;
  padding: 0;
  border: 1px solid #8a8a8a;
  border-radius: 50%;
  background: transparent;
  color: #555;
}

.person-flag-on {
  background: #d4edda;
  border-color: #28a745;
  color: #155724;
}

.chat-name {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0; /* Important for text-overflow to work in flex containers */
}

.chat-name-property {
  display: block;
  font-size: 0.72em;
  font-weight: 400;
  line-height: 1.15;
  opacity: 0.9;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.group-icon-container {
  flex-shrink: 0; /* Prevents the icon from shrinking */
  margin-left: 5px;
}

/* Add style for the pagination control */
.pagination-control {
  text-align: center;
  padding: 10px 0;
  margin-bottom: 10px;
}

.pagination-control button {
  background-color: #a080a8;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  font-size: 0.9em;
  cursor: pointer;
}

.pagination-control button:hover {
  background-color: #8a6d94;
}

.pagination-control button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.tenant-resolve-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 4px 16px;
  font-size: 12px;
  color: #555;
}

.tenant-resolve-bar button {
  font-size: 12px;
  line-height: 1.2;
  padding: 3px 8px;
  border: 1px solid #c5c5c5;
  border-radius: 4px;
  background: #fff;
  color: #333;
  margin: 0;
  cursor: pointer;
}

.tenant-resolve-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.tenant-resolve-bar .tenant-resolve-toggle {
  padding: 5px 8px;
  border-radius: 6px;
  background: #f0f0f0;
}

/* Debug log styles */
.debug-log {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.9);
  color: #18fb18;
  padding: 0;
  border-radius: 5px;
  z-index: 10010;
  width: 90vw;
  max-width: 420px;
  height: 80vh;
  display: flex;
  flex-direction: column;
  user-select: all !important;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
}

.debug-header {
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  background: rgba(0, 0, 0, 0.95);
  padding: 10px;
  border-bottom: 1px solid #333;
  z-index: 1;
}

.debug-log button {
  background: #444;
  color: #fff;
  border: none;
  border-radius: 3px;
  padding: 5px 10px;
  cursor: pointer;
  margin-right: 5px;
}

.debug-log .copy-button {
  background: #2a652a;
}

.debug-log .copy-button:hover {
  background: #1f4f1f;
}

.debug-log button:hover {
  background: #555;
}

.log-message {
  font-family: monospace;
  font-size: 0.85em;
  line-height: 1.4;
  white-space: pre-wrap;
  flex: 1;
  overflow-y: auto;
  padding: 15px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  user-select: text;
}

.log-message::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}
.member-search {
  border-radius: 5px;
  padding: 8px;
  outline: none;
  border: 1px solid #ddd;
  width: 95%;
}
</style>
